import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const TechnologySkillsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(0 0) rotate(-13)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(87 0) rotate(-3)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(171 0) rotate(2)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(5 -82) rotate(-8)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(85 -82) rotate(-3)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(170 -82) rotate(3)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-technology-skills"
      transform="translate(970, 25)"
    >
      <defs>
        <radialGradient
          id="abd2e942-14a1-40b0-bd7e-c0e61b2f7151"
          data-name="grad-35"
          cx="310.46"
          cy="317.5"
          r="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ff78" />
          <stop offset="0.1" stopColor="#00ff7b" stopOpacity="0.98" />
          <stop offset="0.22" stopColor="#00ff84" stopOpacity="0.91" />
          <stop offset="0.36" stopColor="#00ff92" stopOpacity="0.81" />
          <stop offset="0.51" stopColor="#00ffa6" stopOpacity="0.66" />
          <stop offset="0.68" stopColor="#00ffc0" stopOpacity="0.47" />
          <stop offset="0.84" stopColor="#00ffdf" stopOpacity="0.24" />
          <stop offset="1" stopColor="aqua" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="e777b9b5-803d-4611-8708-cc843e21940c"
          cx="310.46"
          r="69.5"
          xlinkHref="#abd2e942-14a1-40b0-bd7e-c0e61b2f7151"
        />
        <radialGradient
          id="ac7d1e2b-2d50-4fff-aa3b-2aac2eedf88b"
          data-name="grad-20"
          cx="294.21"
          cy="108.52"
          r="119.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="1" stopColor="#29abe2" stopOpacity="0.5" />
        </radialGradient>
        <radialGradient
          id="be7a3fd8-2214-4e55-ae31-ce2673d970be"
          data-name="grad-2"
          cx="443.29"
          cy="117.93"
          r="2.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.51" stopColor="#7fff7f" stopOpacity="0.65" />
          <stop offset="1" stopColor="lime" />
        </radialGradient>
        <radialGradient
          id="e0c16df3-84af-402e-aca3-c0c928f5ee25"
          data-name="grad-3"
          cx="435.5"
          cy="119.17"
          r="1.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="0.13" stopColor="#f7d1df" stopOpacity="0.6" />
          <stop offset="0.38" stopColor="#e87fa5" stopOpacity="0.77" />
          <stop offset="0.62" stopColor="#dd447c" stopOpacity="0.9" />
          <stop offset="0.84" stopColor="#d62163" stopOpacity="0.97" />
          <stop offset="1" stopColor="#d4145a" />
        </radialGradient>
        <radialGradient
          id="a4daf704-16ad-4c5a-81b0-448da1187e00"
          data-name="grad-67"
          cx="423.21"
          cy="434.19"
          r="16.88"
          gradientTransform="translate(0 -266.5) scale(1 0.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#8cc63f" />
          <stop offset="0.04" stopColor="#92c83e" stopOpacity="0.96" />
          <stop offset="0.35" stopColor="#bfd831" stopOpacity="0.64" />
          <stop offset="0.62" stopColor="#e0e428" stopOpacity="0.4" />
          <stop offset="0.83" stopColor="#f4eb23" stopOpacity="0.25" />
          <stop offset="0.95" stopColor="#fcee21" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="bea08fcd-8361-4aa8-9d71-a5a7267a49cf"
          cx="424.46"
          cy="89.8"
          r="25.35"
          gradientTransform="translate(0 30.58) scale(1 0.73)"
          xlinkHref="#a4daf704-16ad-4c5a-81b0-448da1187e00"
        />
      </defs>
      <g id="ab039953-8a19-4689-8f97-2cffecd6e38c" data-name="tech">
        <g>
          <path
            d="M166.65,121.64c-10.79-19.38-31.7-33-52.61-34.1S56.73,180,114,200s81.2-32.71,120-12.67Z"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="0.89"
            opacity="0.51"
          />
          <path
            d="M455.81,117.44c10.55-19.38,31-33,51.44-34.1s56,92.5,0,112.47-79.4-32.71-117.32-12.68Z"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.51"
          />
          <path
            d="M307.38,452.81v-4.24A19.71,19.71,0,0,1,307.38,452.81Z"
            fill="#e7f4f7"
          />
          <path
            d="M370.15,313.11S356,291,354.77,308.81s18.46,62.15-6.15,82.46c0,0,6.15-25.85-7.39-26.46-12.45-.57-32.2,63.44-33.85,83.76-1.64-20.32-21.39-84.33-33.84-83.76-13.54.61-7.39,26.46-7.39,26.46-24.61-20.31-4.92-64.62-6.15-82.46s-15.38,4.3-15.38,4.3c-3.7-29.53,15.38-49.84,15.38-49.84l26.46-.62,8.62,11.7h27.07l8.62-11.08h24S373.85,283.58,370.15,313.11Z"
            fill="#e7f4f7"
          />
          <path
            d="M364.62,297.73s-17-9.13-18,5.63,26.09,46.5,5.73,63.29c0,0-5.73-16.46-16.93-17-10.3-.47-26.64,52.48-28,69.28-1.35-16.8-17.69-69.75-28-69.28-11.2.51-13.24,12.05-13.24,12.05-20.36-16.8,3.06-43.61,2-58.37s-18-5.63-18-5.63c-3.05-24.43,18-32,18-32l18.27-3,10.74,12.2h22.4l11.17-8.5,15.81-.66S367.67,273.3,364.62,297.73Z"
            fill="#a6e4f4"
          />
          <path
            d="M350,286.93s-12.66-6.79-13.42,4.19S356,325.71,340.8,338.2c0,0-4.26-12.24-12.59-12.62-7.66-.35-19.81,39-20.83,51.53-1-12.49-13.16-51.88-20.82-51.53-8.33.38-9.85,9-9.85,9-15.14-12.49,2.28-32.44,1.52-43.42s-13.42-4.19-13.42-4.19c-2.27-18.17,13.42-23.83,13.42-23.83l16.85,11.25,4.73-4.43h16.66l5.68,4.43,14.39-11.25S352.23,268.76,350,286.93Z"
            fill="#425cad"
          />
          <path
            d="M332.48,281.52s-7.47-4.93-7.92,3,11.46,25.1,2.52,34.17c0,0-2.52-8.89-7.44-9.17-4.52-.25-11.69,28.33-12.29,37.4-.6-9.07-7.77-37.65-12.29-37.4-4.92.28-5.82,6.51-5.82,6.51-8.94-9.07,1.34-23.54.9-31.51s-7.92-3-7.92-3c-1.34-13.19,4.24-18.87,4.24-18.87L297.54,275l5.34-5.79h9.83l5.14,8.87L332.62,267S333.82,268.33,332.48,281.52Z"
            fill="#e7f4f7"
          />
          <path
            d="M307.38,448.57v4.24A21.11,21.11,0,0,1,307.38,448.57Z"
            fill="#e7f4f7"
          />
          <path
            d="M330.77,233.73V266.1s14.77,11.62,27.08,0V233.73Z"
            fill="#6e7582"
          />
          <path d="M259.38,238.65v24s14.77,8.62,27.08,0v-24Z" fill="#6e7582" />
          <line
            x1="307.08"
            y1="78.96"
            x2="306.46"
            y2="18.65"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="1.04"
            opacity="0.51"
          />
          <path
            d="M295.08,242.35v32.37s14.77,11.62,27.07,0V242.35Z"
            fill="#6e7582"
          />
          <path
            d="M330.77,233.73v22c9.16-1.1,19.08-3,27.08-11l-.13-11.08Z"
            fill="#152b4c"
            opacity="0.38"
          />
          <path
            d="M322.15,256.52V242.35H295.08v13.5A26.61,26.61,0,0,0,322.15,256.52Z"
            fill="#152b4c"
            opacity="0.38"
          />
          <path
            d="M286.46,238.65h-27l0,6.16a39.29,39.29,0,0,0,27.08,10Z"
            fill="#152b4c"
            opacity="0.38"
          />
          <path
            d="M259.46,217.73l-.08,20.92s55.39,17.23,98.47,0l-.17-20.3Z"
            fill="#6e7582"
          />
          <path
            d="M357.85,238.65l-.17-20.3-15-.1-37.28,5.58s-14,20.36-46,14.82C259.38,238.65,314.77,255.88,357.85,238.65Z"
            fill="#1e3b68"
            opacity="0.38"
          />
          <path
            d="M307.38,223.88c118.16,1.85,142.77-88,142.77-88H164S189.23,222,307.38,223.88Z"
            fill="#bb8082"
          />
          <path
            d="M443.06,152.64c-5-5.48-10.75-11.22-11.37-11.22-1.23,0-20.92,14.77-20.92,14.77s-80,20.92-138.46,18.46c0,0,86.77,8.62,63.38,28.93a152.13,152.13,0,0,1-30.33,20.25l2,0C392.89,225.22,429.4,178.54,443.06,152.64Z"
            fill="#6e7582"
          />
          <path
            d="M165.7,140.55c7.25,17.92,40.05,81.43,141,83.31-80.85-12.88-97.46-76.32-99.85-88H194.28C185.45,137.24,173.71,139.1,165.7,140.55Z"
            fill="#f39189"
            opacity="0.48"
          />
          <path
            d="M164,108.1c-40.27-22.66-11.89-56.29,29.1-59.45s73.58,14.72,93.55,15.77,44.12,24.12,44.12,24.12Z"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="1.04"
            opacity="0.51"
          />
          <path
            d="M199.41,184.25c-28.38,37.84,45.2,63.06,131.39,49.4s74.59-48.58,96.16-57.4S199.41,184.25,199.41,184.25Z"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="1.04"
            opacity="0.51"
          />
          <path
            d="M324.77,83.33c-18.15-4.19-.28-42,33.36-34.68s65.17,9.46,85.14-1,46.25,35.74,42,52.56-3.15,36.79-23.12,28.38S324.77,83.33,324.77,83.33Z"
            fill="#4fabb2"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="1.04"
            opacity="0.51"
          />
          <path
            d="M199.43,186.83c29.57,8.37,67.77,13.42,109.49,13.42,40.62,0,77.9-4.79,107.12-12.76,26.6-24.22,34.11-51.61,34.11-51.61H164S171.88,162.77,199.43,186.83Z"
            fill="#1e3b68"
            opacity="0.38"
          />
          <ellipse
            cx="307.08"
            cy="135.88"
            rx="169.85"
            ry="56.98"
            fill="#875c81"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="3.08"
          />
          <ellipse cx="307.08" cy="135.88" rx="143.08" ry="48" fill="#ddad9b" />
          <path
            d="M216.46,199.47c21.24,13.35,50.47,23.67,90.3,24.4h7.59c36.86-.56,64.16-10.25,84.2-23-25.34,4.65-55.32,7.34-87.47,7.34C275.86,208.19,243.23,205,216.46,199.47Z"
            fill="#1e3b68"
            opacity="0.38"
          />
          <line
            x1="476.92"
            y1="135.58"
            x2="598.15"
            y2="135.58"
            fill="#046582"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="0.65"
          />
          <line
            x1="137.23"
            y1="135.58"
            x2="5.54"
            y2="135.58"
            fill="#046582"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="0.65"
          />
          <line
            x1="308.31"
            y1="192.81"
            x2="308.31"
            y2="254.96"
            fill="#046582"
            stroke="#6ef4ed"
            strokeMiterlimit="10"
            strokeWidth="0.65"
          />
          <circle cx="5.85" cy="134.65" r="5.85" fill="#6ef4ed" />
          <circle cx="306.46" cy="18.65" r="5.85" fill="#6ef4ed" />
          <circle cx="307.69" cy="254.96" r="5.85" fill="#6ef4ed" />
          <circle
            cx="310.46"
            cy="317.5"
            r="69"
            strokeMiterlimit="10"
            opacity="0.65"
            fill="url(#abd2e942-14a1-40b0-bd7e-c0e61b2f7151)"
            stroke="url(#e777b9b5-803d-4611-8708-cc843e21940c)"
          />
          <path
            d="M444.21,139.69c0,15.29-75.15,46.12-158,46.12s-142-30.83-142-46.12c0,0,.16-.81.52-2.31,3.8-15.64,30.81-105.45,149.48-106.15S440,121.71,443.71,137.41v0C444.07,138.89,444.21,139.69,444.21,139.69Z"
            stroke="#dcf0f7"
            strokeMiterlimit="10"
            opacity="0.39"
            fill="url(#ac7d1e2b-2d50-4fff-aa3b-2aac2eedf88b)"
          />
          <path
            d="M272.31,220.56l-12.85-2.83-.08,20.92C263.69,224.5,272.31,220.56,272.31,220.56Z"
            fill="#f39189"
            opacity="0.48"
          />
          <path
            d="M450.63,135.9s-42.57,41.51-133.08,37v11s66.86,8.78,133.08-32.22Z"
            fill="#a12568"
          />
          <path
            d="M322.92,168l-5.26,5.26s35.74,6.31,76.73-3.15,56.76-33.64,56.76-33.64l-8.41-1S419.62,177.41,322.92,168Z"
            fill="#513126"
          />
          <g>
            <g>
              <path
                d="M393.52,165.23c-1.59.68-4-2.83-5.43-4.33a11.89,11.89,0,0,1,4.57.17C394.28,161.68,395.66,164.31,393.52,165.23Z"
                fill="#1c7f19"
              />
              <path
                d="M388.09,160.9a30.19,30.19,0,0,1,3.43,1.42,14.33,14.33,0,0,1,1.6,1,2.69,2.69,0,0,1,1.21,1.37,3,3,0,0,0-1.26-1.3,14.08,14.08,0,0,0-1.61-.9C390.37,161.86,389.23,161.39,388.09,160.9Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M403,161.41c-1.59.68-4-2.83-5.42-4.32a11.76,11.76,0,0,1,4.56.16C403.74,157.87,405.13,160.49,403,161.41Z"
                fill="#1c7f19"
              />
              <path
                d="M397.56,157.09a26.8,26.8,0,0,1,3.42,1.42,12.88,12.88,0,0,1,1.6.94,2.77,2.77,0,0,1,1.21,1.37,3.09,3.09,0,0,0-1.26-1.3,15.79,15.79,0,0,0-1.61-.9C399.83,158.05,398.69,157.58,397.56,157.09Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M400.09,167.51c-1.59.68-4-2.83-5.43-4.33a11.89,11.89,0,0,1,4.57.17C400.85,164,402.23,166.59,400.09,167.51Z"
                fill="#1b6817"
              />
              <path
                d="M394.66,163.18a30.19,30.19,0,0,1,3.43,1.42,14.33,14.33,0,0,1,1.6,1,2.69,2.69,0,0,1,1.21,1.37,3,3,0,0,0-1.26-1.3,14.08,14.08,0,0,0-1.61-.9C396.94,164.14,395.8,163.67,394.66,163.18Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M395.74,168.44c-1.14.49-2.83-2-3.89-3.11a8.47,8.47,0,0,1,3.28.12C396.29,165.89,397.29,167.77,395.74,168.44Z"
                fill="#1b6817"
              />
              <path
                d="M391.85,165.33a18.76,18.76,0,0,1,2.46,1,10.21,10.21,0,0,1,1.15.68,2,2,0,0,1,.87,1,2.15,2.15,0,0,0-.91-.93,10,10,0,0,0-1.15-.65C393.48,166,392.66,165.68,391.85,165.33Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M393.86,160.59c-1.15.5-2.87-2.05-3.94-3.14a8.47,8.47,0,0,1,3.32.12C394.42,158,395.42,159.92,393.86,160.59Z"
                fill="#1c7f19"
              />
              <path
                d="M389.92,157.45a20.07,20.07,0,0,1,2.49,1,10.56,10.56,0,0,1,1.17.69,2,2,0,0,1,.87,1,2.17,2.17,0,0,0-.91-.94,8.92,8.92,0,0,0-1.17-.65C391.58,158.15,390.75,157.8,389.92,157.45Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M396.48,166.11c1.72,0,2.44-4.2,3.16-6.17a11.83,11.83,0,0,0-4.09,2C394.32,163.19,394.14,166.15,396.48,166.11Z"
                fill="#1c7f19"
              />
              <path
                d="M399.64,159.94c-.83.91-1.68,1.81-2.44,2.78a14.08,14.08,0,0,0-1.09,1.48,3.1,3.1,0,0,0-.62,1.7,2.75,2.75,0,0,1,.54-1.74,14.81,14.81,0,0,1,1.07-1.52A28.25,28.25,0,0,1,399.64,159.94Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M404,159.15c1.73,0,2.44-4.2,3.17-6.17a11.64,11.64,0,0,0-4.09,2C401.82,156.24,401.63,159.2,404,159.15Z"
                fill="#1c7f19"
              />
              <path
                d="M407.14,153c-.84.91-1.68,1.81-2.44,2.79a14.55,14.55,0,0,0-1.1,1.48A3,3,0,0,0,403,159a2.73,2.73,0,0,1,.54-1.75,13,13,0,0,1,1.07-1.52A28.1,28.1,0,0,1,407.14,153Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M395.55,161.74c1.26,0,1.77-3.05,2.3-4.48a8.51,8.51,0,0,0-3,1.47C394,159.62,393.85,161.78,395.55,161.74Z"
                fill="#1b6817"
              />
              <path
                d="M397.85,157.26c-.6.66-1.22,1.32-1.77,2a12.05,12.05,0,0,0-.8,1.08,2.17,2.17,0,0,0-.44,1.24,2,2,0,0,1,.39-1.27,10.56,10.56,0,0,1,.78-1.11A21.24,21.24,0,0,1,397.85,157.26Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M396.71,167.74a6.9,6.9,0,0,1-1.76-2.07,3.54,3.54,0,0,1-.41-2.72,10.38,10.38,0,0,0-.12-2.6c-.13-.88-.32-1.75-.51-2.63a12.63,12.63,0,0,1,.89,2.55,8.09,8.09,0,0,1,.25,2.74,3.52,3.52,0,0,0-.1,1.27,4.57,4.57,0,0,0,.35,1.22A11.06,11.06,0,0,0,396.71,167.74Z"
              fill="#30562e"
            />
            <path
              d="M399.75,159c0,.33-.13.7-.15,1a2.54,2.54,0,0,0,.47.8,7.11,7.11,0,0,1,1,1.83,8.32,8.32,0,0,1,.41,2,8.79,8.79,0,0,1,0,2,24.79,24.79,0,0,0-.85-3.92,12.49,12.49,0,0,0-.83-1.79l-.23-.46a1.06,1.06,0,0,1-.15-.56C399.48,159.63,399.63,159.37,399.75,159Z"
              fill="#30562e"
            />
            <path
              d="M403.09,154.69a5.64,5.64,0,0,1-.54,1.32c-.23.4-.43.83-.23,1.17a2.88,2.88,0,0,0,.89.92,4.38,4.38,0,0,1,1,1.12,7.78,7.78,0,0,1,.94,2.73,11.28,11.28,0,0,1,.12,2.84,25.3,25.3,0,0,0-.5-2.76,9.52,9.52,0,0,0-1-2.54,4.1,4.1,0,0,0-.85-1,3,3,0,0,1-1-1.16,1,1,0,0,1,0-.81,2.83,2.83,0,0,1,.37-.64A7.7,7.7,0,0,0,403.09,154.69Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M405.93,163.73c1.25,0,1.77-3,2.3-4.48a8.61,8.61,0,0,0-3,1.47C404.36,161.61,404.23,163.77,405.93,163.73Z"
                fill="#1b6817"
              />
              <path
                d="M405.21,165.8c1.25,0,1.77-3.05,2.3-4.48a8.61,8.61,0,0,0-3,1.47C403.64,163.68,403.51,165.83,405.21,165.8Z"
                fill="#1b6817"
              />
              <path
                d="M408.23,159.25c-.61.66-1.23,1.32-1.78,2a10.29,10.29,0,0,0-.79,1.08,2.19,2.19,0,0,0-.45,1.24,2,2,0,0,1,.39-1.27,10.56,10.56,0,0,1,.78-1.11A21.36,21.36,0,0,1,408.23,159.25Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M402.5,166.13c1.72,0,2.44-4.2,3.16-6.17a11.73,11.73,0,0,0-4.09,2C400.34,163.21,400.16,166.17,402.5,166.13Z"
                fill="#1c7f19"
              />
              <path
                d="M405.66,160c-.83.91-1.68,1.81-2.44,2.79a13.11,13.11,0,0,0-1.09,1.48,3,3,0,0,0-.62,1.7,2.79,2.79,0,0,1,.54-1.75,16,16,0,0,1,1.07-1.52A28.25,28.25,0,0,1,405.66,160Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M399.23,161.48c-1.16.5-2.87-2-3.94-3.14a8.42,8.42,0,0,1,3.31.12C399.78,158.91,400.79,160.81,399.23,161.48Z"
                fill="#1c7f19"
              />
              <path
                d="M395.29,158.34a20.72,20.72,0,0,1,2.49,1,10.42,10.42,0,0,1,1.16.69,2,2,0,0,1,.88,1,2.23,2.23,0,0,0-.91-.94,11.19,11.19,0,0,0-1.17-.65C396.94,159,396.11,158.7,395.29,158.34Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M403.55,156.51c-1.42-.21-.76-2.57-1.1-3.42s.85-1.7,2-1.41.75,1.32,1.72,1.68S404.71,156.69,403.55,156.51Z"
                fill="#bc784a"
              />
              <path
                d="M403,156.74c-1.43.15-1.36-2.3-1.9-3s.4-1.87,1.6-1.88,1,1.09,2.07,1.19S404.16,156.62,403,156.74Z"
                fill="#ed863a"
              />
              <path
                d="M403,156.94c-1.43.15-.63-2.05-1.17-2.79s-.27-1.58.93-1.59.86.52,1.89.62S404.14,156.82,403,156.94Z"
                fill="#bc784a"
              />
              <path
                d="M403.24,157.3c-1.32-.11-.79-2.09-1.14-2.78s.72-1.45,1.8-1.27.74,1.05,1.65,1.3S404.32,157.38,403.24,157.3Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M399.28,158.17c-1.44,0-1.18-2.4-1.66-3.18s.54-1.83,1.73-1.75,1,1.17,2,1.35S400.45,158.14,399.28,158.17Z"
                fill="#4233aa"
              />
              <path
                d="M398.77,158.49c-1.38.4-1.73-2-2.38-2.66s.08-1.92,1.25-2.14,1.21.89,2.24.81S399.89,158.17,398.77,158.49Z"
                fill="#583bea"
              />
              <path
                d="M398.78,158.69c-1.38.4-1-1.91-1.62-2.54s-.53-1.51.64-1.74.94.36,2,.28S399.91,158.37,398.78,158.69Z"
                fill="#4233aa"
              />
              <path
                d="M399.11,159c-1.32.13-1.14-1.92-1.6-2.53s.46-1.56,1.56-1.58.9.92,1.84,1S400.18,158.89,399.11,159Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M394.78,157.75c1.33-.56.09-2.68.21-3.58s-1.25-1.45-2.3-.88-.39,1.46-1.25,2S393.71,158.2,394.78,157.75Z"
                fill="#ad45a6"
              />
              <path
                d="M395.38,157.84c1.42-.2.74-2.57,1.08-3.41s-.87-1.72-2-1.44-.73,1.32-1.7,1.67S394.22,158,395.38,157.84Z"
                fill="#dd52cd"
              />
              <path
                d="M395.45,158c1.42-.2.1-2.14.43-3s-.13-1.6-1.29-1.32-.71.71-1.68,1.06S394.29,158.19,395.45,158Z"
                fill="#ad45a6"
              />
              <path
                d="M395.28,158.43c1.25-.42.25-2.21.41-3s-1.06-1.24-2.06-.8-.45,1.2-1.27,1.66S394.26,158.78,395.28,158.43Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="406.37"
              cy="162.57"
              rx="0.91"
              ry="0.27"
              transform="translate(73.13 446.31) rotate(-62.22)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <g>
            <g>
              <path
                d="M409.83,158.32c-1.51.84-4.21-2.41-5.83-3.75a11.62,11.62,0,0,1,4.55-.3C410.23,154.71,411.88,157.18,409.83,158.32Z"
                fill="#1c7f19"
              />
              <path
                d="M404,154.57a27.33,27.33,0,0,1,3.55,1.06,12.93,12.93,0,0,1,1.69.78,2.73,2.73,0,0,1,1.34,1.23,3.08,3.08,0,0,0-1.38-1.16,16.88,16.88,0,0,0-1.69-.73C406.36,155.29,405.18,154.94,404,154.57Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M418.86,153.55c-1.51.84-4.22-2.41-5.84-3.74a11.66,11.66,0,0,1,4.56-.3C419.26,150,420.9,152.42,418.86,153.55Z"
                fill="#1c7f19"
              />
              <path
                d="M413,149.81a27.94,27.94,0,0,1,3.56,1.06,14.27,14.27,0,0,1,1.69.78,2.77,2.77,0,0,1,1.34,1.23,3.05,3.05,0,0,0-1.39-1.16,14.11,14.11,0,0,0-1.69-.73C415.39,150.53,414.2,150.18,413,149.81Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M416.6,159.91c-1.51.84-4.22-2.41-5.83-3.74a11.6,11.6,0,0,1,4.55-.3C417,156.31,418.64,158.78,416.6,159.91Z"
                fill="#1b6817"
              />
              <path
                d="M410.77,156.17a27.33,27.33,0,0,1,3.55,1.06A12.93,12.93,0,0,1,416,158a2.73,2.73,0,0,1,1.34,1.23,3.08,3.08,0,0,0-1.38-1.16,15,15,0,0,0-1.7-.73C413.13,156.89,411.94,156.54,410.77,156.17Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M412.38,161.28c-1.09.6-3-1.73-4.2-2.69a8.43,8.43,0,0,1,3.28-.22C412.66,158.69,413.85,160.47,412.38,161.28Z"
                fill="#1b6817"
              />
              <path
                d="M408.18,158.59a20.87,20.87,0,0,1,2.56.76,11,11,0,0,1,1.21.56,2,2,0,0,1,1,.89,2.22,2.22,0,0,0-1-.84,10.16,10.16,0,0,0-1.22-.52C409.88,159.11,409,158.85,408.18,158.59Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M409.71,153.67c-1.1.61-3.07-1.75-4.24-2.73a8.45,8.45,0,0,1,3.31-.21C410,151.05,411.19,152.84,409.71,153.67Z"
                fill="#1c7f19"
              />
              <path
                d="M405.47,150.94a21.82,21.82,0,0,1,2.58.78,9.69,9.69,0,0,1,1.23.56,2,2,0,0,1,1,.9,2.28,2.28,0,0,0-1-.84,9.63,9.63,0,0,0-1.24-.53C407.18,151.47,406.32,151.21,405.47,150.94Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M412.87,158.89c1.71-.21,2-4.43,2.52-6.46a11.75,11.75,0,0,0-3.86,2.43C410.43,156.21,410.55,159.17,412.87,158.89Z"
                fill="#1c7f19"
              />
              <path
                d="M415.39,152.43c-.74,1-1.49,2-2.14,3a14,14,0,0,0-.94,1.58,3.06,3.06,0,0,0-.44,1.76,2.69,2.69,0,0,1,.36-1.79,14.42,14.42,0,0,1,.91-1.63A26.6,26.6,0,0,1,415.39,152.43Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M419.61,151.21c1.72-.21,2-4.43,2.52-6.47a11.76,11.76,0,0,0-3.86,2.44C417.17,148.52,417.29,151.49,419.61,151.21Z"
                fill="#1c7f19"
              />
              <path
                d="M422.13,144.74c-.73,1-1.48,2-2.14,3a15.07,15.07,0,0,0-.94,1.59,3.13,3.13,0,0,0-.44,1.75,2.84,2.84,0,0,1,.36-1.79,15.21,15.21,0,0,1,.91-1.62A30.62,30.62,0,0,1,422.13,144.74Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M411.5,154.64c1.25-.15,1.46-3.21,1.83-4.69a8.44,8.44,0,0,0-2.8,1.77C409.73,152.69,409.82,154.85,411.5,154.64Z"
                fill="#1b6817"
              />
              <path
                d="M413.33,150c-.53.72-1.08,1.43-1.55,2.19a9,9,0,0,0-.68,1.16,2.14,2.14,0,0,0-.32,1.27,2,2,0,0,1,.26-1.3,10.47,10.47,0,0,1,.66-1.18A21.18,21.18,0,0,1,413.33,150Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M413.27,160.49a7,7,0,0,1-2-1.88,3.83,3.83,0,0,1-.61-1.27,3.92,3.92,0,0,1-.08-1.39,10.54,10.54,0,0,0-.39-2.58c-.22-.86-.49-1.71-.77-2.56a13.37,13.37,0,0,1,1.15,2.45,8.1,8.1,0,0,1,.52,2.7,3.81,3.81,0,0,0,0,1.27,4.52,4.52,0,0,0,.48,1.17A10.72,10.72,0,0,0,413.27,160.49Z"
              fill="#30562e"
            />
            <path
              d="M415.41,151.52c0,.33-.06.71-.05,1s.34.49.54.74a7.12,7.12,0,0,1,1.16,1.72,9.57,9.57,0,0,1,.78,4,24.51,24.51,0,0,0-1.25-3.8,11.9,11.9,0,0,0-1-1.71l-.28-.43a.94.94,0,0,1-.2-.54C415.2,152.14,415.32,151.86,415.41,151.52Z"
              fill="#30562e"
            />
            <path
              d="M418.28,146.86a5.44,5.44,0,0,1-.4,1.36c-.18.43-.35.87-.11,1.2a3,3,0,0,0,1,.82,4.25,4.25,0,0,1,1.1,1,7.8,7.8,0,0,1,1.21,2.62,10.8,10.8,0,0,1,.41,2.82,24,24,0,0,0-.78-2.7,9.77,9.77,0,0,0-1.24-2.43,3.9,3.9,0,0,0-.95-.91,3,3,0,0,1-1.08-1.05,1.14,1.14,0,0,1-.07-.81,4.23,4.23,0,0,1,.3-.68A6.37,6.37,0,0,0,418.28,146.86Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M422,155.57c1.24-.16,1.45-3.22,1.83-4.7a8.54,8.54,0,0,0-2.81,1.77C420.25,153.62,420.34,155.77,422,155.57Z"
                fill="#1b6817"
              />
              <path
                d="M421.52,157.7c1.25-.16,1.45-3.22,1.83-4.7a8.44,8.44,0,0,0-2.8,1.77C419.75,155.75,419.84,157.9,421.52,157.7Z"
                fill="#1b6817"
              />
              <path
                d="M423.86,150.87c-.54.72-1.08,1.43-1.56,2.19a11.33,11.33,0,0,0-.68,1.16,2.21,2.21,0,0,0-.32,1.27,2,2,0,0,1,.26-1.3,10.47,10.47,0,0,1,.66-1.18A21.27,21.27,0,0,1,423.86,150.87Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M418.86,158.3c1.72-.21,2-4.43,2.52-6.46a11.75,11.75,0,0,0-3.86,2.43C416.42,155.62,416.54,158.58,418.86,158.3Z"
                fill="#1c7f19"
              />
              <path
                d="M421.38,151.84c-.74,1-1.49,2-2.14,3a14,14,0,0,0-.94,1.58,3.06,3.06,0,0,0-.44,1.76,2.69,2.69,0,0,1,.36-1.79,14.42,14.42,0,0,1,.91-1.63A27.89,27.89,0,0,1,421.38,151.84Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M415.14,154c-1.1.61-3.07-1.75-4.25-2.73a8.51,8.51,0,0,1,3.32-.21C415.42,151.39,416.62,153.18,415.14,154Z"
                fill="#1c7f19"
              />
              <path
                d="M410.89,151.28a21.37,21.37,0,0,1,2.59.77,11.25,11.25,0,0,1,1.22.57,2,2,0,0,1,1,.9,2.19,2.19,0,0,0-1-.84,10.41,10.41,0,0,0-1.23-.54C412.61,151.81,411.75,151.55,410.89,151.28Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M418.93,148.62c-1.44-.07-1-2.48-1.44-3.28s.67-1.79,1.85-1.62.88,1.24,1.88,1.49S420.1,148.68,418.93,148.62Z"
                fill="#bc784a"
              />
              <path
                d="M418.4,148.91c-1.41.3-1.59-2.15-2.2-2.83s.21-1.91,1.4-2,1.15,1,2.18,1S419.54,148.67,418.4,148.91Z"
                fill="#ed863a"
              />
              <path
                d="M418.4,149.11c-1.41.3-.84-2-1.45-2.66s-.43-1.54.76-1.67.91.42,1.94.41S419.54,148.87,418.4,149.11Z"
                fill="#bc784a"
              />
              <path
                d="M418.7,149.43c-1.32,0-1-2-1.42-2.64s.57-1.52,1.66-1.45.84,1,1.77,1.12S419.78,149.41,418.7,149.43Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M414.85,150.7c-1.43.19-1.42-2.26-2-3s.35-1.88,1.55-1.92,1.07,1.07,2.1,1.15S416,150.55,414.85,150.7Z"
                fill="#4233aa"
              />
              <path
                d="M414.38,151.08c-1.34.54-1.93-1.85-2.65-2.41s-.11-1.91,1-2.25,1.3.76,2.31.58S415.46,150.64,414.38,151.08Z"
                fill="#583bea"
              />
              <path
                d="M414.41,151.28c-1.33.54-1.16-1.81-1.88-2.37s-.68-1.45.46-1.79,1,.26,2,.07S415.49,150.84,414.41,151.28Z"
                fill="#4233aa"
              />
              <path
                d="M414.76,151.54c-1.29.27-1.33-1.79-1.84-2.35s.29-1.6,1.38-1.73,1,.82,1.93.8S415.82,151.33,414.76,151.54Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M410.33,150.75c1.27-.69-.18-2.67-.16-3.58s-1.39-1.32-2.38-.65-.24,1.5-1,2.16S409.31,151.31,410.33,150.75Z"
                fill="#ad45a6"
              />
              <path
                d="M410.93,150.77c1.4-.34.48-2.62.73-3.49s-1-1.62-2.16-1.23-.6,1.39-1.53,1.83S409.8,151.05,410.93,150.77Z"
                fill="#dd52cd"
              />
              <path
                d="M411,151c1.4-.34-.12-2.14.13-3s-.3-1.58-1.42-1.18-.63.78-1.56,1.22S409.89,151.23,411,151Z"
                fill="#ad45a6"
              />
              <path
                d="M410.89,151.38c1.21-.55,0-2.23.11-3s-1.18-1.13-2.13-.59-.33,1.24-1.1,1.78S409.92,151.82,410.89,151.38Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="422.35"
              cy="154.36"
              rx="0.91"
              ry="0.27"
              transform="translate(121.44 488.51) rotate(-68.07)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <g>
            <g>
              <path
                d="M426.55,151c-1.08.91-3.76-1.27-5.26-2.09a9.49,9.49,0,0,1,3.6-1C426.31,148.07,428,149.79,426.55,151Z"
                fill="#1c7f19"
              />
              <path
                d="M421.29,148.93a21.77,21.77,0,0,1,3,.3,12.25,12.25,0,0,1,1.48.35,2.27,2.27,0,0,1,1.27.79,2.48,2.48,0,0,0-1.29-.72,14.4,14.4,0,0,0-1.48-.32C423.29,149.14,422.29,149,421.29,148.93Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M433,145.79c-1.08.91-3.76-1.27-5.27-2.09a9.7,9.7,0,0,1,3.61-1C432.8,142.83,434.5,144.56,433,145.79Z"
                fill="#1c7f19"
              />
              <path
                d="M427.77,143.7a23.39,23.39,0,0,1,3,.29,12.28,12.28,0,0,1,1.48.36,2.25,2.25,0,0,1,1.27.78,2.54,2.54,0,0,0-1.29-.71,10.53,10.53,0,0,0-1.48-.32C429.78,143.91,428.78,143.81,427.77,143.7Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M432.23,151.24c-1.08.91-3.76-1.27-5.27-2.09a9.7,9.7,0,0,1,3.61-1C432,148.29,433.69,150,432.23,151.24Z"
                fill="#1b6817"
              />
              <path
                d="M427,149.15a23.39,23.39,0,0,1,3,.29,12.28,12.28,0,0,1,1.48.36,2.25,2.25,0,0,1,1.27.79,2.48,2.48,0,0,0-1.29-.72,12.17,12.17,0,0,0-1.48-.32C429,149.36,428,149.26,427,149.15Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M429.06,153c-.78.65-2.7-.91-3.79-1.5a6.86,6.86,0,0,1,2.6-.69C428.88,150.88,430.11,152.12,429.06,153Z"
                fill="#1b6817"
              />
              <path
                d="M425.27,151.5a15.78,15.78,0,0,1,2.17.21,7.46,7.46,0,0,1,1.06.26,1.58,1.58,0,0,1,.92.56,1.75,1.75,0,0,0-.93-.51,7.7,7.7,0,0,0-1.06-.23C426.72,151.65,426,151.58,425.27,151.5Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M425.72,147.31c-.78.67-2.73-.92-3.83-1.51a7,7,0,0,1,2.62-.7C425.54,145.17,426.78,146.42,425.72,147.31Z"
                fill="#1c7f19"
              />
              <path
                d="M421.89,145.8a16.22,16.22,0,0,1,2.2.21,7.94,7.94,0,0,1,1.07.26,1.65,1.65,0,0,1,.92.57,1.76,1.76,0,0,0-.94-.52,7.84,7.84,0,0,0-1.07-.23C423.35,146,422.62,145.88,421.89,145.8Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M429.08,151c1.34-.44.9-3.87,1-5.58a9.51,9.51,0,0,0-2.71,2.56C426.7,149.24,427.26,151.6,429.08,151Z"
                fill="#1c7f19"
              />
              <path
                d="M430.08,145.43c-.43.91-.88,1.81-1.24,2.75a12.11,12.11,0,0,0-.5,1.43,2.39,2.39,0,0,0-.08,1.47,2.24,2.24,0,0,1,0-1.49,12.26,12.26,0,0,1,.47-1.45A24.36,24.36,0,0,1,430.08,145.43Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M433.28,143.79c1.34-.44.91-3.87,1-5.58a9.5,9.5,0,0,0-2.72,2.56C430.9,142,431.47,144.38,433.28,143.79Z"
                fill="#1c7f19"
              />
              <path
                d="M434.29,138.21c-.44.91-.89,1.81-1.25,2.75a12.11,12.11,0,0,0-.5,1.43,2.54,2.54,0,0,0-.08,1.47,2.24,2.24,0,0,1,0-1.49,12.26,12.26,0,0,1,.47-1.45A22.8,22.8,0,0,1,434.29,138.21Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M427.32,147.82c1-.32.66-2.81.73-4.06a7,7,0,0,0-2,1.86C425.59,146.53,426,148.24,427.32,147.82Z"
                fill="#1b6817"
              />
              <path
                d="M428.05,143.76c-.32.66-.64,1.32-.91,2a9,9,0,0,0-.36,1,1.87,1.87,0,0,0-.06,1.07,1.6,1.6,0,0,1,0-1.08,7.57,7.57,0,0,1,.34-1A15.84,15.84,0,0,1,428.05,143.76Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M429.65,152.22a5.78,5.78,0,0,1-1.87-1.19,3.14,3.14,0,0,1-.68-.93,3.33,3.33,0,0,1-.29-1.1,8,8,0,0,0-.71-2c-.31-.65-.67-1.29-1-1.93a10.83,10.83,0,0,1,1.3,1.78,7.1,7.1,0,0,1,.84,2.09,2.89,2.89,0,0,0,.79,1.88A9.3,9.3,0,0,0,429.65,152.22Z"
              fill="#30562e"
            />
            <path
              d="M430,144.7c.07.26.06.58.11.81s.36.33.56.51a6.38,6.38,0,0,1,1.19,1.19,7.66,7.66,0,0,1,1.26,3.11c-.24-.51-.48-1-.74-1.48a10.68,10.68,0,0,0-.86-1.38,8.07,8.07,0,0,0-1.07-1.21c-.17-.22-.43-.34-.54-.71S429.94,145,430,144.7Z"
              fill="#30562e"
            />
            <path
              d="M431.53,140.51a4,4,0,0,1-.11,1.15c-.08.37-.14.76.1,1a2.34,2.34,0,0,0,.92.51,3.45,3.45,0,0,1,1,.63,6.89,6.89,0,0,1,1.38,1.91,9.28,9.28,0,0,1,.77,2.2,17.82,17.82,0,0,0-1.05-2,7,7,0,0,0-1.38-1.75,2.81,2.81,0,0,0-.9-.59,2.42,2.42,0,0,1-1-.67.89.89,0,0,1-.18-.64,2.81,2.81,0,0,1,.13-.59A5.3,5.3,0,0,0,431.53,140.51Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M435.9,146.9c1-.32.66-2.81.73-4.05a6.9,6.9,0,0,0-2,1.86C434.17,145.62,434.58,147.33,435.9,146.9Z"
                fill="#1b6817"
              />
              <path
                d="M435.83,148.69c1-.32.66-2.81.73-4.05a6.9,6.9,0,0,0-2,1.86C434.1,147.4,434.51,149.12,435.83,148.69Z"
                fill="#1b6817"
              />
              <path
                d="M436.63,142.85c-.31.66-.64,1.32-.9,2a9.74,9.74,0,0,0-.37,1,1.81,1.81,0,0,0-.05,1.08,1.63,1.63,0,0,1,0-1.09,8.08,8.08,0,0,1,.35-1.05A16.35,16.35,0,0,1,436.63,142.85Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M433.79,149.59c1.34-.44.91-3.86,1-5.58a9.66,9.66,0,0,0-2.72,2.56C431.41,147.82,432,150.18,433.79,149.59Z"
                fill="#1c7f19"
              />
              <path
                d="M434.8,144c-.44.92-.89,1.82-1.25,2.76a12.62,12.62,0,0,0-.5,1.42,2.5,2.5,0,0,0-.08,1.48,2.27,2.27,0,0,1,0-1.5,12.11,12.11,0,0,1,.47-1.44A22.93,22.93,0,0,1,434.8,144Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M430.13,146.73c-.79.67-2.73-.92-3.83-1.51a6.89,6.89,0,0,1,2.62-.7C430,144.59,431.19,145.84,430.13,146.73Z"
                fill="#1c7f19"
              />
              <path
                d="M426.3,145.22a15.92,15.92,0,0,1,2.19.21,8.08,8.08,0,0,1,1.08.26,1.65,1.65,0,0,1,.92.57,1.76,1.76,0,0,0-.94-.52,7.84,7.84,0,0,0-1.07-.23C427.76,145.37,427,145.3,426.3,145.22Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M432.33,141.82c-1.17.17-1.21-1.83-1.68-2.41s.26-1.54,1.24-1.59.89.86,1.74.91S433.27,141.68,432.33,141.82Z"
                fill="#bc784a"
              />
              <path
                d="M432,142.13c-1.09.46-1.61-1.47-2.21-1.92s-.13-1.56.8-1.85,1.08.6,1.9.44S432.83,141.76,432,142.13Z"
                fill="#ed863a"
              />
              <path
                d="M432,142.29c-1.09.46-1-1.45-1.58-1.9s-.59-1.17.34-1.46.8.19,1.63,0S432.86,141.92,432,142.29Z"
                fill="#bc784a"
              />
              <path
                d="M432.27,142.51c-1.06.23-1.12-1.45-1.55-1.9s.21-1.31,1.1-1.43.83.65,1.6.63S433.13,142.32,432.27,142.51Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M429.38,144.13c-1.12.37-1.5-1.6-2.06-2.09s0-1.56.95-1.78,1,.69,1.86.59S430.28,143.83,429.38,144.13Z"
                fill="#4233aa"
              />
              <path
                d="M429.06,144.51c-1,.64-1.83-1.18-2.5-1.52s-.39-1.52.47-2,1.16.41,2,.1S429.86,144,429.06,144.51Z"
                fill="#583bea"
              />
              <path
                d="M429.12,144.66c-1,.64-1.22-1.27-1.88-1.6s-.78-1.06.09-1.51.82,0,1.6-.25S429.92,144.14,429.12,144.66Z"
                fill="#4233aa"
              />
              <path
                d="M429.44,144.82c-1,.41-1.34-1.23-1.85-1.6s0-1.33.84-1.6.92.49,1.68.33S430.25,144.48,429.44,144.82Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M425.77,144.87c.9-.75-.57-2.11-.69-2.84s-1.33-.84-2-.15,0,1.24-.49,1.9S425,145.48,425.77,144.87Z"
                fill="#ad45a6"
              />
              <path
                d="M426.25,144.8c1.07-.5,0-2.18,0-2.92s-1.08-1.14-1.92-.64-.26,1.2-.94,1.71S425.39,145.2,426.25,144.8Z"
                fill="#dd52cd"
              />
              <path
                d="M426.35,144.93c1.07-.5-.43-1.7-.37-2.44s-.48-1.22-1.33-.72-.38.72-1.06,1.23S425.49,145.33,426.35,144.93Z"
                fill="#ad45a6"
              />
              <path
                d="M426.31,145.29c.88-.63-.33-1.79-.38-2.41s-1.12-.72-1.8-.14-.07,1-.6,1.6S425.6,145.8,426.31,145.29Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="435.97"
              cy="145.88"
              rx="0.74"
              ry="0.22"
              transform="translate(210.62 546.59) rotate(-79.15)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <g>
            <g>
              <path
                d="M438,141c-.85.71-2.94-1-4.12-1.64a7.53,7.53,0,0,1,2.82-.75C437.83,138.67,439.16,140,438,141Z"
                fill="#1c7f19"
              />
              <path
                d="M433.9,139.34a18.67,18.67,0,0,1,2.36.23,11.33,11.33,0,0,1,1.15.28,1.82,1.82,0,0,1,1,.61,1.94,1.94,0,0,0-1-.55,9.25,9.25,0,0,0-1.16-.26C435.47,139.51,434.68,139.43,433.9,139.34Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M443.09,136.88c-.84.71-2.94-1-4.12-1.63a7.59,7.59,0,0,1,2.82-.75C442.9,134.57,444.23,135.92,443.09,136.88Z"
                fill="#1c7f19"
              />
              <path
                d="M439,135.25a18.67,18.67,0,0,1,2.36.23,9.33,9.33,0,0,1,1.16.28,1.83,1.83,0,0,1,1,.61,2,2,0,0,0-1-.56c-.38-.11-.77-.18-1.15-.25C440.54,135.41,439.76,135.34,439,135.25Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M442.46,141.15c-.85.71-2.94-1-4.12-1.64a7.39,7.39,0,0,1,2.82-.74C442.27,138.84,443.6,140.19,442.46,141.15Z"
                fill="#1b6817"
              />
              <path
                d="M438.34,139.51a18.67,18.67,0,0,1,2.36.23,11.33,11.33,0,0,1,1.15.28,1.78,1.78,0,0,1,1,.62,1.88,1.88,0,0,0-1-.56,7.74,7.74,0,0,0-1.16-.25C439.91,139.68,439.12,139.6,438.34,139.51Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M440,142.52c-.61.51-2.12-.71-3-1.17a5.41,5.41,0,0,1,2-.54C439.84,140.86,440.8,141.83,440,142.52Z"
                fill="#1b6817"
              />
              <path
                d="M437,141.35c.56,0,1.13.08,1.69.16a7.75,7.75,0,0,1,.83.21,1.34,1.34,0,0,1,.72.43,1.35,1.35,0,0,0-.73-.4,7.65,7.65,0,0,0-.83-.18C438.15,141.47,437.58,141.4,437,141.35Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M437.37,138.08c-.62.52-2.14-.72-3-1.19a5.37,5.37,0,0,1,2.05-.54C437.23,136.4,438.2,137.38,437.37,138.08Z"
                fill="#1c7f19"
              />
              <path
                d="M434.37,136.89a16.42,16.42,0,0,1,1.72.17,5.16,5.16,0,0,1,.84.21,1.29,1.29,0,0,1,.72.44,1.31,1.31,0,0,0-.73-.41,5,5,0,0,0-.84-.18A16,16,0,0,0,434.37,136.89Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M440,141c1.05-.34.71-3,.79-4.36a7.57,7.57,0,0,0-2.13,2C438.13,139.58,438.57,141.42,440,141Z"
                fill="#1c7f19"
              />
              <path
                d="M440.78,136.6c-.34.72-.69,1.42-1,2.16a8.63,8.63,0,0,0-.4,1.11,1.89,1.89,0,0,0-.06,1.15,1.71,1.71,0,0,1,0-1.16,8.78,8.78,0,0,1,.37-1.13A16.83,16.83,0,0,1,440.78,136.6Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M443.28,135.32c1.05-.34.71-3,.78-4.36a7.45,7.45,0,0,0-2.12,2C441.42,133.94,441.86,135.78,443.28,135.32Z"
                fill="#1c7f19"
              />
              <path
                d="M444.06,131c-.33.71-.69,1.42-1,2.15a9.15,9.15,0,0,0-.39,1.11,1.92,1.92,0,0,0-.06,1.16,1.8,1.8,0,0,1,0-1.17,10.66,10.66,0,0,1,.37-1.13A19.89,19.89,0,0,1,444.06,131Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M438.61,138.47c.77-.25.52-2.2.58-3.17a5.44,5.44,0,0,0-1.55,1.45C437.26,137.46,437.58,138.8,438.61,138.47Z"
                fill="#1b6817"
              />
              <path
                d="M439.19,135.3a14.78,14.78,0,0,0-.71,1.57,5.89,5.89,0,0,0-.29.8,1.34,1.34,0,0,0,0,.84,1.34,1.34,0,0,1,0-.84,5.72,5.72,0,0,1,.26-.83A17,17,0,0,1,439.19,135.3Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M440.44,141.92A4.51,4.51,0,0,1,439,141a2.4,2.4,0,0,1-.76-1.59,6.22,6.22,0,0,0-.56-1.56c-.24-.51-.52-1-.8-1.52a7,7,0,0,1,1.68,3,2.28,2.28,0,0,0,.62,1.47A6.86,6.86,0,0,0,440.44,141.92Z"
              fill="#30562e"
            />
            <path
              d="M440.68,136c.06.21.05.45.09.63s.27.27.43.4a5.23,5.23,0,0,1,.94.94,5.93,5.93,0,0,1,1,2.42,14.68,14.68,0,0,0-1.25-2.23,6.15,6.15,0,0,0-.84-.94c-.13-.17-.33-.27-.42-.56S440.67,136.26,440.68,136Z"
              fill="#30562e"
            />
            <path
              d="M441.91,132.76a3.06,3.06,0,0,1-.09.9c-.06.29-.11.59.08.76a1.93,1.93,0,0,0,.72.4,2.81,2.81,0,0,1,.81.5,5.21,5.21,0,0,1,1.08,1.49,7.05,7.05,0,0,1,.61,1.72,14.21,14.21,0,0,0-.83-1.6,5.8,5.8,0,0,0-1.07-1.37,2.55,2.55,0,0,0-.71-.46,1.79,1.79,0,0,1-.8-.52,1,1,0,0,1,0-1A5,5,0,0,0,441.91,132.76Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M445.33,137.76c.76-.25.51-2.2.57-3.17a5.44,5.44,0,0,0-1.55,1.45C444,136.75,444.29,138.09,445.33,137.76Z"
                fill="#1b6817"
              />
              <path
                d="M445.27,139.15c.76-.25.52-2.19.57-3.17a5.54,5.54,0,0,0-1.54,1.46C443.92,138.15,444.24,139.49,445.27,139.15Z"
                fill="#1b6817"
              />
              <path
                d="M445.9,134.59c-.26.51-.5,1-.71,1.56a6,6,0,0,0-.29.81,1.34,1.34,0,0,0,0,.84,1.37,1.37,0,0,1,0-.85,7.81,7.81,0,0,1,.26-.82A17,17,0,0,1,445.9,134.59Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M443.68,139.86c1.05-.34.7-3,.78-4.36a7.45,7.45,0,0,0-2.12,2C441.82,138.48,442.26,140.32,443.68,139.86Z"
                fill="#1c7f19"
              />
              <path
                d="M444.46,135.5c-.34.71-.69,1.42-1,2.15a9.15,9.15,0,0,0-.39,1.11,1.92,1.92,0,0,0-.06,1.16,1.8,1.8,0,0,1,0-1.17,8.78,8.78,0,0,1,.37-1.13A18.16,18.16,0,0,1,444.46,135.5Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M440.81,137.62c-.61.52-2.13-.72-3-1.18a5.44,5.44,0,0,1,2.05-.55C440.67,136,441.64,136.92,440.81,137.62Z"
                fill="#1c7f19"
              />
              <path
                d="M437.82,136.44a16.22,16.22,0,0,1,1.71.16,7.37,7.37,0,0,1,.84.21,1.37,1.37,0,0,1,.72.44,1.3,1.3,0,0,0-.73-.41,7.34,7.34,0,0,0-.84-.18A16.12,16.12,0,0,0,437.82,136.44Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M442.53,133.78c-.91.14-.94-1.43-1.31-1.88s.2-1.2,1-1.24.7.67,1.36.7S443.27,133.67,442.53,133.78Z"
                fill="#bc784a"
              />
              <path
                d="M442.23,134c-.84.36-1.26-1.16-1.72-1.51s-.1-1.22.63-1.45.84.48,1.48.35S442.92,133.73,442.23,134Z"
                fill="#ed863a"
              />
              <path
                d="M442.26,134.15c-.85.36-.77-1.14-1.24-1.49s-.46-.91.27-1.14.63.15,1.27,0S442.94,133.86,442.26,134.15Z"
                fill="#bc784a"
              />
              <path
                d="M442.49,134.32c-.83.18-.88-1.13-1.22-1.48s.17-1,.86-1.12.65.51,1.25.49S443.16,134.17,442.49,134.32Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M440.23,135.59c-.88.29-1.17-1.25-1.61-1.63s0-1.23.74-1.4.8.54,1.45.46S440.93,135.35,440.23,135.59Z"
                fill="#4233aa"
              />
              <path
                d="M440,135.88c-.77.5-1.44-.92-2-1.18s-.31-1.19.36-1.54.91.32,1.52.08S440.6,135.47,440,135.88Z"
                fill="#583bea"
              />
              <path
                d="M440,136c-.77.5-.95-1-1.46-1.25s-.61-.83.06-1.18.64,0,1.26-.2S440.65,135.59,440,136Z"
                fill="#4233aa"
              />
              <path
                d="M440.28,136.13c-.78.32-1.06-1-1.45-1.26s0-1,.66-1.25.72.39,1.31.27S440.91,135.86,440.28,136.13Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M437.4,136.17c.71-.59-.44-1.65-.54-2.23s-1-.65-1.57-.11,0,1-.38,1.48S436.83,136.65,437.4,136.17Z"
                fill="#ad45a6"
              />
              <path
                d="M437.78,136.11c.83-.39,0-1.7,0-2.28s-.85-.89-1.51-.5-.2.94-.73,1.33S437.1,136.43,437.78,136.11Z"
                fill="#dd52cd"
              />
              <path
                d="M437.86,136.21c.83-.38-.34-1.33-.29-1.9s-.38-.95-1-.57-.3.57-.83,1S437.18,136.53,437.86,136.21Z"
                fill="#ad45a6"
              />
              <path
                d="M437.83,136.5c.69-.5-.26-1.41-.3-1.89s-.88-.56-1.41-.11-.05.82-.47,1.25S437.27,136.9,437.83,136.5Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="445.38"
              cy="136.96"
              rx="0.58"
              ry="0.17"
              transform="translate(227.02 548.59) rotate(-79.15)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <polygon
            points="172.61 114.35 164.2 114.35 165.25 124.86 171.56 124.86 172.61 114.35"
            fill="#bf3c87"
          />
          <path
            d="M164.2,114.35s28.38-33.64,131.39-31.54c0,0-47.3-4.2-123,31.54Z"
            fill="#513126"
          />
          <path
            d="M171.56,124.86c4.2-9.46,72.55-38,123.52-32.13l.51-9.92s-50.46,0-78.84,10.52c-31.17,11.54-44.14,21-44.14,21Z"
            fill="#a12568"
          />
          <g>
            <g>
              <g>
                <path
                  d="M157.45,86.67c0-.23,0-.46-.07-.7a5.8,5.8,0,0,1,0-1,8.82,8.82,0,0,1,.2-.89,2.76,2.76,0,0,0,.08-.81c0-.29-.09-.57-.11-.86a1.89,1.89,0,0,1,.06-.67,3.38,3.38,0,0,1,.18-.44,4.4,4.4,0,0,1,.26-.39.08.08,0,0,0,0-.08,3.1,3.1,0,0,1,3.46-1.49,1.36,1.36,0,0,0,.24.24,2,2,0,0,0,.72.26,1.4,1.4,0,0,1,.74.39,6.14,6.14,0,0,1,.51.81,1.56,1.56,0,0,0,.33.35,1.53,1.53,0,0,0,.41.19,1.08,1.08,0,0,1,.43.27,2.82,2.82,0,0,1,.29.39,4,4,0,0,0,.35.36,3.33,3.33,0,0,1,.25.28,4.22,4.22,0,0,1,.53,1.71,2.46,2.46,0,0,0,.4.94,4.25,4.25,0,0,0,.6.6,2.22,2.22,0,0,1,.45.52,2.28,2.28,0,0,1,.21,1c0,.78,0,1.56.06,2.34a5.67,5.67,0,0,0,.1.57c0,.18.11.35.14.53a1.24,1.24,0,0,1-.05.69c-.09.21-.22.39-.32.59a1.66,1.66,0,0,0-.3.93,1.51,1.51,0,0,1,0,.52,1.07,1.07,0,0,1-.22.37,5.17,5.17,0,0,0-.58.66.08.08,0,0,0,0,0,2.76,2.76,0,0,1-.81.48,2.89,2.89,0,0,1-1.34.21,5.14,5.14,0,0,0-.9-.47,11.29,11.29,0,0,1-1.08-.46,3.46,3.46,0,0,1-.47-.31l-.43-.37c-.29-.21-.62-.37-.89-.6a1.43,1.43,0,0,1-.38-.47c-.09-.18-.16-.36-.24-.54a1.86,1.86,0,0,0-.29-.49,5.44,5.44,0,0,0-.42-.41l-.57-.5a13.78,13.78,0,0,1-.71-1.44,3.42,3.42,0,0,1,.26-.59c.15-.29.33-.56.48-.84,0,0,0-.1,0-.11-.26,0-.53-.1-.78-.17a1.24,1.24,0,0,1-.5-.28,1.41,1.41,0,0,1-.19-.34Z"
                  fill="#396039"
                />
                <path
                  d="M159.87,80a53.34,53.34,0,0,1,3.54,7.63c1,2.62,1.9,5.29,2.7,8s1.48,5.42,2.13,8.15l.89,4.12.78,4.14c-.55-2.75-1.12-5.5-1.77-8.23s-1.35-5.45-2.17-8.14-1.65-5.36-2.65-8c-.5-1.31-1-2.62-1.59-3.9A37.67,37.67,0,0,0,159.87,80Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M173.06,98.67a8.53,8.53,0,0,0,0-1,23.05,23.05,0,0,1,1.54-5,5.67,5.67,0,0,0,.48-.5,6.7,6.7,0,0,0,.51-.68l.59-.8a6.76,6.76,0,0,0,.94-1.65c.1-.3.14-.61.22-.91s.13-.4.2-.6c1.92-2.57,3.93-4,5.17-3.38a1.28,1.28,0,0,1,.45.35,2.76,2.76,0,0,1,.08.27,3.87,3.87,0,0,1,.12,1.27,5.75,5.75,0,0,1-.25,1.22,7.83,7.83,0,0,0-.41,1.41,5,5,0,0,0,.05,1.34,6.71,6.71,0,0,1,.1,1.35,1.85,1.85,0,0,1-.39,1.11,3.55,3.55,0,0,1-.71.51,3.21,3.21,0,0,0-.76.71,1,1,0,0,0-.27.72c0,.28.15.54.2.82a2.31,2.31,0,0,1-.57,1.84,9.59,9.59,0,0,1-1.57,1.34c-.29.22-.58.45-.86.7l-.4.39c-.15.16-.27.33-.41.49a8.46,8.46,0,0,1-2.07,1.59c-.37.23-.74.46-1.08.72a2.53,2.53,0,0,1-1.06-2.23A5.38,5.38,0,0,0,173.06,98.67Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M183.15,84c-1.47,2.17-2.83,4.41-4.13,6.68s-2.48,4.61-3.58,7a76.22,76.22,0,0,0-2.92,7.28,52.56,52.56,0,0,0-1.89,7.61,46.57,46.57,0,0,1,1.79-7.64,77.6,77.6,0,0,1,2.89-7.31A92.27,92.27,0,0,1,183.15,84Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M173.19,100.57c0-.26.07-.53.1-.79a17.5,17.5,0,0,1,1.83-3.69c.15-.11.3-.21.44-.33s.33-.31.49-.47.37-.37.56-.55a5.61,5.61,0,0,0,.94-1.18c.12-.22.19-.45.3-.68a4.66,4.66,0,0,1,.22-.45c1.83-1.77,3.59-2.62,4.49-2a1.22,1.22,0,0,1,.31.33l0,.22a3.11,3.11,0,0,1-.07,1,4.37,4.37,0,0,1-.36.93,7.19,7.19,0,0,0-.5,1,4.22,4.22,0,0,0-.13,1.06,4.84,4.84,0,0,1-.09,1.07,1.45,1.45,0,0,1-.45.82,2.4,2.4,0,0,1-.62.31,2.68,2.68,0,0,0-.69.46.71.71,0,0,0-.29.53c0,.22.05.45.05.67a1.83,1.83,0,0,1-.69,1.36,7.33,7.33,0,0,1-1.39.86c-.26.14-.52.28-.77.44a4.06,4.06,0,0,0-.36.26c-.14.1-.26.22-.39.33a6.53,6.53,0,0,1-1.82,1c-.32.13-.63.27-.94.42a2,2,0,0,1-.54-1.88A4.68,4.68,0,0,0,173.19,100.57Z"
                  fill="#396039"
                />
                <path
                  d="M183,90.35c-1.42,1.51-2.76,3.1-4.07,4.71s-2.52,3.3-3.69,5a61.31,61.31,0,0,0-3.22,5.33,42.43,42.43,0,0,0-2.45,5.72,35.24,35.24,0,0,1,2.37-5.76,60.14,60.14,0,0,1,3.18-5.37A73.09,73.09,0,0,1,183,90.35Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M168.75,100.72a.44.44,0,0,0,.15-.25.45.45,0,0,0-.16-.29,3.75,3.75,0,0,0-.44-.35h0a2.47,2.47,0,0,0,.28-.28.44.44,0,0,0,.11-.24c0-.18-.18-.26-.31-.31l-.3-.11c-.06-.3-.12-.62-.18-.95l.18,0a3.59,3.59,0,0,0,.43-.14.91.91,0,0,0,.29-.19s0-.09,0-.11a3.23,3.23,0,0,0-.42-.2A.91.91,0,0,1,168,97c-.1-.13,0-.29,0-.45a.44.44,0,0,0-.17-.3l-.14-.11c0-.4-.08-.8-.11-1.21l.24-.07a1.27,1.27,0,0,0,.55-.29.44.44,0,0,0,.08-.55,1,1,0,0,0-.55-.41l-.35-.11c0-.14,0-.28-.07-.42,0-.41,0-.82,0-1.23l0,0a.79.79,0,0,1,.23-.14,1.28,1.28,0,0,0,.35-.26s0-.08,0-.1-.56-.35-.45-.62c0-.08.16-.09.23-.12a.23.23,0,0,0,.12-.25c-.05-.18-.28-.25-.38-.4s.17-.22.28-.23a4,4,0,0,0,.6,0,.08.08,0,0,0,0-.14c-.31-.22-.61-.44-.93-.63,0-.86.14-1.69.24-2.46l.14,0s.08,0,.09-.06a3.19,3.19,0,0,1,.58.3l.32.24c.07.06.17,0,.1-.1a2.69,2.69,0,0,0-.33-.26,6.59,6.59,0,0,0-.85-.51c.11-.67.22-1.3.36-1.87a2.73,2.73,0,0,1,.72.37l.26.24c.07.06.17,0,.1-.1a1.27,1.27,0,0,0-.27-.25c-.17-.16-.34-.32-.52-.47l-.2-.17a11.64,11.64,0,0,1,.51-1.6c.32.14.64.28,1,.39a.08.08,0,0,0,.09-.07,1.5,1.5,0,0,0-.36-.8,2.43,2.43,0,0,0-.3-.34c.35-.6.75-.94,1.16-.94.83,0,1.58,1.37,2.11,3.55-.22.19-.42.4-.63.61a.07.07,0,0,0,.09.11,5.24,5.24,0,0,0,.61-.44c.13.58.25,1.21.34,1.88a11.45,11.45,0,0,0-.64,1.32s0,.09,0,.1c.27.15.56.26.84.39.08.95.14,2,.16,3a5.66,5.66,0,0,0-.59,1.36,3.32,3.32,0,0,0,0,1.09c0,.18,0,.36,0,.54s0,.36,0,.53c.06.34.18.66.24,1a.81.81,0,0,1-.22.81,2,2,0,0,1-.61.24.29.29,0,0,0-.19.15A.36.36,0,0,0,172,97a1.45,1.45,0,0,0,.62.53l.23.13c-.51,3.22-1.43,5.37-2.47,5.37-.65,0-1.25-.82-1.73-2.2Z"
                  fill="#659965"
                />
                <path
                  d="M170.33,84.28c.12,4.65.16,9.3.21,14v7c0,2.32,0,4.65-.21,7,.11-1.16.08-2.32.1-3.48v-3.49l0-7Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M165.77,89.37a1,1,0,0,1,.55,0c.1.13.2.27.31.4s.32.38.5.56a6.3,6.3,0,0,1,.48.55,4.87,4.87,0,0,1,.55,1,4.63,4.63,0,0,0,.57,1.16,10.52,10.52,0,0,0,.76.73h0l.18.51a14.38,14.38,0,0,1,.68,3.3l0,.26a21.16,21.16,0,0,0-.42,2.38.88.88,0,0,1-.45.34c-1.14.38-2.89-1.83-3.91-4.92S164.63,89.75,165.77,89.37Z"
                  fill="#3b6818"
                />
                <path
                  d="M165.55,95.65s4.9,2.49,5.07,15.37"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.15"
                />
                <path
                  d="M166.54,90.54a2.69,2.69,0,0,1,.68,1.28,6.21,6.21,0,0,0,.27,1.35,2,2,0,0,0,.45.61c.18.17.36.31.54.48a1.47,1.47,0,0,1,.39.65,1.26,1.26,0,0,1,0,.58,3,3,0,0,0-.09.6,2.23,2.23,0,0,0,.25.82,1.56,1.56,0,0,1,.16,1.37,1.58,1.58,0,0,0,0,.58,1.45,1.45,0,0,0,.18.53,1.21,1.21,0,0,1,.16.45,1.36,1.36,0,0,1-.21.68l0,.07a.44.44,0,0,1-.19.12c-.9.3-2.46-2-3.48-5.06s-1.11-5.84-.21-6.14a.67.67,0,0,1,.37,0A5.87,5.87,0,0,0,166.54,90.54Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M188.81,85.32c0-.18,0-.37.05-.56a4.58,4.58,0,0,0,0-.83,6.2,6.2,0,0,0-.16-.72,2.36,2.36,0,0,1-.07-.65c0-.24.08-.47.09-.7a1.64,1.64,0,0,0,0-.54L188.5,81a2.2,2.2,0,0,0-.21-.32,0,0,0,0,1,0-.06,2.62,2.62,0,0,0-1.26-1.1,2.52,2.52,0,0,0-1.54-.11,1.14,1.14,0,0,1-.19.19,1.58,1.58,0,0,1-.58.22,1.06,1.06,0,0,0-.6.31,4.43,4.43,0,0,0-.41.65,1.5,1.5,0,0,1-.27.29,1.4,1.4,0,0,1-.33.15.87.87,0,0,0-.35.22,3.65,3.65,0,0,0-.24.31,1.92,1.92,0,0,1-.28.29c-.07.08-.14.15-.2.23a3.53,3.53,0,0,0-.43,1.38,2,2,0,0,1-.32.77,3.7,3.7,0,0,1-.49.48,1.78,1.78,0,0,0-.36.42,1.73,1.73,0,0,0-.17.77c0,.63,0,1.27-.05,1.9a3.69,3.69,0,0,1-.08.46c0,.14-.09.28-.11.43a1,1,0,0,0,0,.56c.07.16.17.31.26.47a1.45,1.45,0,0,1,.24.75,1.19,1.19,0,0,0,0,.42.65.65,0,0,0,.18.3,4,4,0,0,1,.47.54v0a2.88,2.88,0,0,0,.65.39,2.52,2.52,0,0,0,1.09.17,4.28,4.28,0,0,1,.73-.39,7.25,7.25,0,0,0,.87-.36c.13-.08.26-.16.38-.25s.23-.21.35-.3.5-.3.72-.49a1.4,1.4,0,0,0,.31-.38c.07-.14.12-.29.19-.44a1.33,1.33,0,0,1,.24-.39,2.57,2.57,0,0,1,.33-.33l.47-.41a11.35,11.35,0,0,0,.56-1.16,2,2,0,0,0-.2-.48c-.12-.23-.27-.45-.39-.68a.06.06,0,0,1,0-.09,6.21,6.21,0,0,0,.62-.14.91.91,0,0,0,.41-.22.76.76,0,0,0,.15-.28C188.76,85.57,188.78,85.45,188.81,85.32Z"
                  fill="#396039"
                />
                <path
                  d="M186.85,80a45.42,45.42,0,0,0-2.8,6.2c-.8,2.12-1.5,4.28-2.14,6.46s-1.22,4.36-1.76,6.57l-.75,3.32-.66,3.34.63-3.35.72-3.33c.52-2.2,1.06-4.41,1.71-6.59s1.37-4.33,2.19-6.45A46.63,46.63,0,0,1,186.85,80Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M176.18,95c0-.27,0-.54,0-.81a18.2,18.2,0,0,0-1.25-4c-.13-.13-.26-.26-.38-.4a5.7,5.7,0,0,1-.42-.55c-.15-.22-.31-.43-.47-.65a5.33,5.33,0,0,1-.76-1.33,6.47,6.47,0,0,1-.18-.73c0-.17-.1-.33-.16-.49-1.55-2.08-3.18-3.22-4.19-2.73a1.17,1.17,0,0,0-.36.28l-.06.22a3.19,3.19,0,0,0-.1,1,4.71,4.71,0,0,0,.21,1,6.46,6.46,0,0,1,.33,1.14,4.35,4.35,0,0,1,0,1.08,5,5,0,0,0-.08,1.09,1.44,1.44,0,0,0,.31.9,2.68,2.68,0,0,0,.58.42,2.54,2.54,0,0,1,.61.57.75.75,0,0,1,.21.58c0,.23-.12.44-.16.66a1.9,1.9,0,0,0,.47,1.49,7.65,7.65,0,0,0,1.26,1.08c.24.19.48.37.7.57s.22.21.32.32.23.26.34.39a6.78,6.78,0,0,0,1.67,1.29,10.11,10.11,0,0,1,.87.58,2.07,2.07,0,0,0,.86-1.81A4.52,4.52,0,0,1,176.18,95Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M168,83.16a76.83,76.83,0,0,1,6.34,11,59.84,59.84,0,0,1,2.32,5.91,39.8,39.8,0,0,1,1.46,6.17,39.43,39.43,0,0,0-1.51-6.15,62.31,62.31,0,0,0-2.38-5.88A76.83,76.83,0,0,0,168,83.16Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M176.08,96.56c0-.22-.06-.43-.08-.64a13.94,13.94,0,0,0-1.48-3l-.35-.27c-.14-.12-.27-.25-.4-.38l-.45-.45a4.39,4.39,0,0,1-.77-1c-.09-.17-.15-.37-.23-.55s-.12-.24-.19-.36c-1.48-1.43-2.89-2.12-3.62-1.61a.93.93,0,0,0-.25.27,1.1,1.1,0,0,0,0,.18,2.44,2.44,0,0,0,0,.81,4,4,0,0,0,.29.75,5.48,5.48,0,0,1,.4.85,3.54,3.54,0,0,1,.11.85,4.2,4.2,0,0,0,.07.87,1.18,1.18,0,0,0,.37.67,2.59,2.59,0,0,0,.5.25,2.21,2.21,0,0,1,.55.37.58.58,0,0,1,.24.43c0,.18,0,.36,0,.54a1.53,1.53,0,0,0,.55,1.1,6.57,6.57,0,0,0,1.13.69c.21.11.42.23.62.36l.3.2.31.27a5.37,5.37,0,0,0,1.47.8,7.35,7.35,0,0,1,.76.34,1.61,1.61,0,0,0,.44-1.52A4,4,0,0,1,176.08,96.56Z"
                  fill="#396039"
                />
                <path
                  d="M168.19,88.29a58.23,58.23,0,0,1,6.37,7.81c.93,1.4,1.79,2.85,2.58,4.33a30.41,30.41,0,0,1,1.91,4.66,34.9,34.9,0,0,0-2-4.62q-1.2-2.22-2.61-4.31t-3-4C170.43,90.8,169.34,89.52,168.19,88.29Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M179.67,96.68a.37.37,0,0,1-.12-.2.41.41,0,0,1,.13-.24A3.44,3.44,0,0,1,180,96h0a1.52,1.52,0,0,1-.22-.22.42.42,0,0,1-.1-.2c0-.14.15-.21.26-.25l.24-.09c.05-.24.1-.5.14-.77l-.14,0-.34-.11a.56.56,0,0,1-.24-.16.06.06,0,0,1,0-.09l.34-.16a.67.67,0,0,0,.3-.19c.09-.11,0-.24,0-.36a.33.33,0,0,1,.14-.24.52.52,0,0,1,.11-.1c0-.32.07-.64.09-1l-.19-.06a1.07,1.07,0,0,1-.45-.23.38.38,0,0,1-.07-.45.84.84,0,0,1,.45-.33,1.31,1.31,0,0,1,.28-.09l.06-.34c0-.33,0-.66,0-1a.05.05,0,0,0,0,0,.47.47,0,0,0-.19-.12,1.08,1.08,0,0,1-.28-.21.06.06,0,0,1,0-.08c.14-.11.46-.28.36-.5,0-.06-.12-.07-.18-.1a.16.16,0,0,1-.09-.2c0-.15.22-.2.3-.32s-.14-.18-.23-.18a2.54,2.54,0,0,1-.48,0,.06.06,0,0,1,0-.11c.25-.17.5-.35.76-.51,0-.7-.12-1.36-.2-2l-.11,0a.05.05,0,0,1-.07-.05,2.16,2.16,0,0,0-.48.24l-.25.19c-.06,0-.14,0-.08-.08l.27-.21a5.11,5.11,0,0,1,.68-.41c-.08-.54-.18-1-.29-1.51a2,2,0,0,0-.58.3l-.21.19c-.06,0-.14,0-.09-.08a1.37,1.37,0,0,1,.22-.2l.42-.38.17-.14a9.32,9.32,0,0,0-.42-1.29,6.67,6.67,0,0,1-.78.31s-.08,0-.07-.06a1.33,1.33,0,0,1,.29-.64,3,3,0,0,1,.24-.28c-.28-.48-.6-.75-.93-.75-.68,0-1.29,1.1-1.71,2.86l.51.5c.05,0,0,.12-.07.09s-.34-.23-.5-.35c-.1.46-.2,1-.28,1.51a8.86,8.86,0,0,1,.53,1.07s0,.07,0,.08c-.22.12-.45.21-.68.31-.07.77-.11,1.59-.13,2.43a4.45,4.45,0,0,1,.47,1.1,2.36,2.36,0,0,1,0,.88c0,.15,0,.29,0,.44a3.17,3.17,0,0,1,0,.43c0,.27-.14.53-.19.8a.66.66,0,0,0,.18.66,1.39,1.39,0,0,0,.49.19.23.23,0,0,1,.15.12.31.31,0,0,1,0,.23,1.25,1.25,0,0,1-.51.43l-.19.1c.42,2.61,1.16,4.34,2,4.34.52,0,1-.66,1.39-1.78Z"
                  fill="#659965"
                />
                <path
                  d="M178.4,83.39l-.06,11.28,0,5.64c0,1.88,0,3.76.09,5.63-.18-1.87-.15-3.75-.17-5.63V94.67C178.27,90.91,178.3,87.15,178.4,83.39Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M182.08,87.5a.82.82,0,0,0-.44,0c-.09.11-.17.22-.26.32a5.72,5.72,0,0,1-.4.46,3.23,3.23,0,0,0-.38.45,3.5,3.5,0,0,0-.45.8,3.57,3.57,0,0,1-.46.94c-.18.22-.41.39-.61.59h0l-.15.41a11.76,11.76,0,0,0-.55,2.67c0,.07,0,.14,0,.21a15.75,15.75,0,0,1,.34,1.92.77.77,0,0,0,.37.28c.92.3,2.33-1.48,3.15-4S183,87.81,182.08,87.5Z"
                  fill="#3b6818"
                />
                <path
                  d="M182.26,92.58s-4,2-4.1,12.43"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.12"
                />
                <path
                  d="M181.46,88.45a2.15,2.15,0,0,0-.55,1,5.11,5.11,0,0,1-.22,1.1,1.78,1.78,0,0,1-.36.49c-.15.13-.3.25-.44.39a1.2,1.2,0,0,0-.32.52,1.05,1.05,0,0,0,0,.47,2,2,0,0,1,.07.49,1.54,1.54,0,0,1-.2.65,1.89,1.89,0,0,0-.2.68,1.49,1.49,0,0,0,.08.43,1.47,1.47,0,0,1,0,.47,1,1,0,0,1-.14.43,1,1,0,0,0-.13.37,1.15,1.15,0,0,0,.17.55l0,.06a.51.51,0,0,0,.16.09c.73.24,2-1.59,2.8-4.09s.91-4.72.18-5a.44.44,0,0,0-.3,0A4.89,4.89,0,0,1,181.46,88.45Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M178.45,83.21c0-.16,0-.34,0-.5a3.77,3.77,0,0,1,0-.75c0-.22.09-.43.14-.65a1.88,1.88,0,0,0,.07-.58c0-.22-.07-.42-.09-.63a1.6,1.6,0,0,1,0-.49l.14-.32a1.73,1.73,0,0,1,.19-.28,0,0,0,0,0,0-.06,2.3,2.3,0,0,1,2.53-1.09.58.58,0,0,0,.17.18,1.36,1.36,0,0,0,.52.19,1,1,0,0,1,.54.28,5.27,5.27,0,0,1,.37.59,1,1,0,0,0,.24.26,1.64,1.64,0,0,0,.3.14.77.77,0,0,1,.31.19,2.92,2.92,0,0,1,.21.28,2.13,2.13,0,0,0,.26.26l.18.21a3.21,3.21,0,0,1,.39,1.24,1.62,1.62,0,0,0,.29.69,3.57,3.57,0,0,0,.43.44,1.33,1.33,0,0,1,.33.38,1.48,1.48,0,0,1,.15.69c0,.57,0,1.14.05,1.71a3.2,3.2,0,0,0,.07.41c0,.13.08.25.1.38a.88.88,0,0,1,0,.51,3.42,3.42,0,0,1-.23.42,1.31,1.31,0,0,0-.22.68,1,1,0,0,1,0,.38.74.74,0,0,1-.16.27,3.21,3.21,0,0,0-.42.48s0,0,0,0a2.42,2.42,0,0,1-.58.35,2.32,2.32,0,0,1-1,.15,3.17,3.17,0,0,0-.66-.34c-.26-.11-.53-.2-.78-.33a2.54,2.54,0,0,1-.34-.23c-.11-.09-.2-.19-.31-.27s-.45-.27-.65-.44a1.13,1.13,0,0,1-.28-.34c-.07-.13-.11-.26-.17-.39a1.13,1.13,0,0,0-.22-.36,2.76,2.76,0,0,0-.3-.29c-.13-.13-.28-.25-.42-.37q-.27-.5-.51-1.05a2.35,2.35,0,0,1,.19-.43c.11-.21.24-.4.35-.61a.05.05,0,0,0,0-.08c-.18,0-.38-.07-.56-.12a.82.82,0,0,1-.36-.21.62.62,0,0,1-.14-.25C178.49,83.43,178.47,83.32,178.45,83.21Z"
                  fill="#396039"
                />
                <path
                  d="M180.21,78.39a38.84,38.84,0,0,1,2.58,5.55c.74,1.91,1.38,3.85,2,5.81s1.08,3.94,1.55,5.93l.65,3,.56,3c-.4-2-.81-4-1.28-6s-1-4-1.58-5.91-1.2-3.91-1.93-5.81A42.29,42.29,0,0,0,180.21,78.39Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M189.81,91.94c0-.24,0-.49,0-.73a15.62,15.62,0,0,1,1.12-3.6c.12-.12.24-.24.35-.37s.25-.33.37-.5l.42-.58a4.93,4.93,0,0,0,.69-1.2c.08-.21.1-.44.16-.66s.09-.29.14-.43c1.4-1.87,2.86-2.9,3.77-2.46a1.11,1.11,0,0,1,.33.25,1.46,1.46,0,0,1,.05.2,2.85,2.85,0,0,1,.09.92,4.55,4.55,0,0,1-.19.89,6.05,6.05,0,0,0-.29,1,3.94,3.94,0,0,0,0,1,4,4,0,0,1,.07,1,1.3,1.3,0,0,1-.28.81,2.29,2.29,0,0,1-.51.37,2.31,2.31,0,0,0-.56.52.72.72,0,0,0-.19.52c0,.2.11.4.14.6a1.67,1.67,0,0,1-.41,1.33,6.28,6.28,0,0,1-1.14,1c-.21.16-.43.33-.63.51a4,4,0,0,0-.29.29c-.11.11-.2.23-.3.35a6.28,6.28,0,0,1-1.5,1.16,8.28,8.28,0,0,0-.79.52,1.84,1.84,0,0,1-.77-1.62A4.16,4.16,0,0,0,189.81,91.94Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M197.14,81.26c-1.07,1.58-2,3.21-3,4.86s-1.8,3.35-2.6,5.08a56.17,56.17,0,0,0-2.13,5.29A37.67,37.67,0,0,0,188,102a34.26,34.26,0,0,1,1.3-5.56,55.26,55.26,0,0,1,2.1-5.31A68,68,0,0,1,197.14,81.26Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M189.9,93.32c0-.19,0-.38.07-.58a13,13,0,0,1,1.33-2.68,2.43,2.43,0,0,0,.32-.24,3.82,3.82,0,0,0,.36-.34l.41-.4a3.79,3.79,0,0,0,.68-.86c.09-.15.14-.33.22-.49s.1-.22.16-.33c1.33-1.29,2.61-1.9,3.27-1.44a.8.8,0,0,1,.22.23,1,1,0,0,1,0,.17,2.25,2.25,0,0,1-.05.73,3,3,0,0,1-.26.67,6,6,0,0,0-.36.77,3.32,3.32,0,0,0-.1.77,3.43,3.43,0,0,1-.07.78,1.07,1.07,0,0,1-.32.6,2.35,2.35,0,0,1-.45.22,1.7,1.7,0,0,0-.5.34.54.54,0,0,0-.22.38c0,.16,0,.32,0,.49a1.33,1.33,0,0,1-.5,1,5,5,0,0,1-1,.62l-.56.32a2.48,2.48,0,0,0-.26.19c-.1.07-.19.16-.29.24a4.54,4.54,0,0,1-1.32.71l-.68.31a1.45,1.45,0,0,1-.4-1.37A3.1,3.1,0,0,0,189.9,93.32Z"
                  fill="#396039"
                />
                <path
                  d="M197,85.89A57.43,57.43,0,0,0,191.36,93,42.32,42.32,0,0,0,189,96.84a30.49,30.49,0,0,0-1.79,4.16,31.26,31.26,0,0,1,4-8.09A52.25,52.25,0,0,1,197,85.89Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M186.67,93.43a.31.31,0,0,0,.11-.18.36.36,0,0,0-.11-.21,2.69,2.69,0,0,0-.33-.26h0c.07-.07.14-.13.2-.2a.36.36,0,0,0,.08-.18c0-.13-.13-.19-.23-.23l-.21-.08c-.05-.22-.09-.45-.13-.69l.13,0,.31-.1a.55.55,0,0,0,.21-.14.05.05,0,0,0,0-.08,2.12,2.12,0,0,0-.31-.14,1,1,0,0,1-.27-.17c-.07-.1,0-.22,0-.33a.3.3,0,0,0-.13-.22l-.1-.09c0-.28-.06-.57-.08-.87l.18,0a1,1,0,0,0,.4-.21.35.35,0,0,0,.06-.4.78.78,0,0,0-.41-.3,1,1,0,0,0-.25-.08,2.87,2.87,0,0,0-.05-.31c0-.29,0-.59,0-.89l0,0a.48.48,0,0,1,.17-.1,1.1,1.1,0,0,0,.25-.19s0-.06,0-.08-.41-.24-.33-.44.12-.07.17-.09a.17.17,0,0,0,.08-.18c0-.14-.2-.19-.27-.29s.12-.16.21-.17a3.09,3.09,0,0,0,.43,0c.05,0,.05-.07,0-.1a8.09,8.09,0,0,0-.68-.46c0-.63.11-1.23.18-1.78l.1,0a.05.05,0,0,0,.07,0,1.68,1.68,0,0,1,.42.22l.23.17s.13,0,.08-.07l-.25-.19a4.72,4.72,0,0,0-.61-.37c.07-.49.16-1,.26-1.37a2.61,2.61,0,0,1,.52.28l.19.17a.06.06,0,0,0,.08-.08l-.2-.17-.38-.35-.15-.12a7.9,7.9,0,0,1,.38-1.16c.23.1.46.2.7.28a.06.06,0,0,0,.07,0,1.27,1.27,0,0,0-.26-.58,1.79,1.79,0,0,0-.23-.25c.26-.44.55-.68.85-.68.6,0,1.15,1,1.54,2.58-.16.14-.31.29-.46.44s0,.12.06.08a4.5,4.5,0,0,0,.45-.31c.09.42.17.87.25,1.36a8.59,8.59,0,0,0-.48,1,.08.08,0,0,0,0,.08l.61.28c.06.69.1,1.42.12,2.18a4,4,0,0,0-.43,1,2.32,2.32,0,0,0,0,.79c0,.13,0,.26,0,.4s0,.25,0,.38.12.48.17.72a.61.61,0,0,1-.17.6,1.67,1.67,0,0,1-.44.17.18.18,0,0,0-.13.11.24.24,0,0,0,0,.2,1.16,1.16,0,0,0,.46.39l.17.09c-.37,2.35-1,3.91-1.8,3.91-.47,0-.91-.6-1.26-1.6Z"
                  fill="#659965"
                />
                <path
                  d="M187.82,81.47c.09,3.38.11,6.77.15,10.15V96.7c0,1.69,0,3.38-.15,5.07.11-1.69.06-3.38.08-5.07l0-5.08Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M184.5,85.18a.68.68,0,0,1,.4,0l.23.28a4.79,4.79,0,0,0,.36.41,4.36,4.36,0,0,1,.35.4,3.72,3.72,0,0,1,.4.73,3.45,3.45,0,0,0,.41.84c.17.2.38.35.56.54h0c0,.13.09.25.13.38a9.64,9.64,0,0,1,.5,2.39,1.23,1.23,0,0,1,0,.19,14.91,14.91,0,0,0-.3,1.73.65.65,0,0,1-.33.25c-.83.28-2.1-1.33-2.84-3.58S183.68,85.45,184.5,85.18Z"
                  fill="#3b6818"
                />
                <path
                  d="M184.34,89.74s3.56,1.82,3.69,11.18"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.11"
                />
                <path
                  d="M185.06,86a2.05,2.05,0,0,1,.5.93,4.06,4.06,0,0,0,.2,1,1.32,1.32,0,0,0,.32.44c.13.12.27.23.39.35a1.1,1.1,0,0,1,.29.47.89.89,0,0,1,0,.43,2,2,0,0,0-.06.44,1.4,1.4,0,0,0,.18.59,1.6,1.6,0,0,1,.18.6,1.51,1.51,0,0,1-.07.39,1.23,1.23,0,0,0,0,.43.91.91,0,0,0,.13.38.81.81,0,0,1,.11.33,1,1,0,0,1-.15.5l0,0-.15.09c-.65.21-1.78-1.44-2.52-3.69s-.82-4.24-.16-4.46a.42.42,0,0,1,.27,0A4.31,4.31,0,0,0,185.06,86Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M206.68,79a4.4,4.4,0,0,0,0-.51,4.54,4.54,0,0,0,0-.74c0-.22-.1-.44-.15-.65a2.37,2.37,0,0,1-.06-.59c0-.21.06-.42.08-.63a1.54,1.54,0,0,0,0-.48,3.09,3.09,0,0,0-.14-.32,1.67,1.67,0,0,0-.18-.28s0,0,0-.06a2.28,2.28,0,0,0-2.53-1.09.58.58,0,0,1-.17.18A1.55,1.55,0,0,1,203,74a1,1,0,0,0-.54.28,4.38,4.38,0,0,0-.37.58.85.85,0,0,1-.24.26,1,1,0,0,1-.3.14.84.84,0,0,0-.31.19,3.06,3.06,0,0,0-.21.29,3.07,3.07,0,0,1-.25.26,1.9,1.9,0,0,0-.19.21,3.1,3.1,0,0,0-.38,1.24,1.77,1.77,0,0,1-.3.69,2.91,2.91,0,0,1-.43.43,1.33,1.33,0,0,0-.33.38,1.66,1.66,0,0,0-.15.7c0,.56,0,1.13-.05,1.7a1.85,1.85,0,0,1-.07.41c0,.13-.07.26-.1.39a.85.85,0,0,0,0,.5c.06.15.16.29.23.43a1.28,1.28,0,0,1,.22.68,1,1,0,0,0,0,.38.74.74,0,0,0,.16.27,3.21,3.21,0,0,1,.42.48v0a1.91,1.91,0,0,0,.58.35,2.18,2.18,0,0,0,1,.16,4.17,4.17,0,0,1,.66-.35,5.88,5.88,0,0,0,.78-.33,1.56,1.56,0,0,0,.34-.23c.11-.08.2-.18.32-.26s.45-.27.65-.44a1.31,1.31,0,0,0,.27-.35,2.71,2.71,0,0,0,.17-.39,1.38,1.38,0,0,1,.22-.35,2.83,2.83,0,0,1,.3-.3l.42-.36q.27-.5.51-1a1.66,1.66,0,0,0-.19-.43c-.11-.21-.24-.41-.35-.61,0,0,0-.07,0-.08a5.07,5.07,0,0,0,.56-.13.75.75,0,0,0,.36-.2.62.62,0,0,0,.14-.25C206.64,79.23,206.66,79.12,206.68,79Z"
                  fill="#396039"
                />
                <path
                  d="M204.92,74.18a44.27,44.27,0,0,0-2.51,5.58c-.73,1.91-1.35,3.85-1.93,5.81s-1.1,3.93-1.58,5.92-.88,4-1.28,6l.56-3,.65-3c.47-2,1-4,1.55-5.93s1.23-3.9,2-5.8A40.62,40.62,0,0,1,204.92,74.18Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M195.32,87.74c0-.25,0-.49,0-.74a15.92,15.92,0,0,0-1.12-3.6c-.12-.12-.24-.24-.34-.36a6,6,0,0,1-.38-.5l-.42-.58a5.12,5.12,0,0,1-.69-1.2c-.07-.22-.1-.44-.16-.66s-.09-.29-.14-.44c-1.4-1.87-2.86-2.89-3.77-2.46a1,1,0,0,0-.32.26,1.39,1.39,0,0,0-.06.19,2.91,2.91,0,0,0-.09.93,4.31,4.31,0,0,0,.19.88,7.56,7.56,0,0,1,.3,1,3.93,3.93,0,0,1,0,1,4.67,4.67,0,0,0-.07,1,1.33,1.33,0,0,0,.28.82,2.44,2.44,0,0,0,.52.37,2.46,2.46,0,0,1,.55.52.68.68,0,0,1,.19.52c0,.2-.11.39-.14.59a1.65,1.65,0,0,0,.42,1.34,7.57,7.57,0,0,0,1.13,1,7.79,7.79,0,0,1,.63.51,3.83,3.83,0,0,1,.29.28c.11.11.2.24.3.36a6.24,6.24,0,0,0,1.5,1.15c.27.17.54.34.79.52.46-.22.71-.8.77-1.62A4.58,4.58,0,0,1,195.32,87.74Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M188,77.06a67,67,0,0,1,5.7,9.89,56.5,56.5,0,0,1,2.1,5.32,34.14,34.14,0,0,1,1.3,5.55,37.54,37.54,0,0,0-1.37-5.53A55.1,55.1,0,0,0,193.59,87q-1.2-2.59-2.6-5.08C190.05,80.27,189.06,78.64,188,77.06Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M195.23,89.12c0-.19,0-.39-.07-.58a12.78,12.78,0,0,0-1.33-2.68l-.32-.24c-.13-.11-.24-.23-.36-.34l-.4-.41a3.53,3.53,0,0,1-.69-.85,4.4,4.4,0,0,1-.21-.5c0-.11-.11-.21-.17-.32-1.33-1.29-2.61-1.91-3.26-1.45a.76.76,0,0,0-.23.24c0,.05,0,.11,0,.16a2.29,2.29,0,0,0,.05.74,3.44,3.44,0,0,0,.26.67,4.16,4.16,0,0,1,.36.77,2.78,2.78,0,0,1,.1.76,3.38,3.38,0,0,0,.07.78,1.07,1.07,0,0,0,.32.6,1.91,1.91,0,0,0,.45.23,1.89,1.89,0,0,1,.5.33.56.56,0,0,1,.22.39c0,.16,0,.32,0,.48a1.35,1.35,0,0,0,.5,1,5.55,5.55,0,0,0,1,.62c.18.1.37.2.55.32l.27.18.28.24a4.7,4.7,0,0,0,1.32.72,7,7,0,0,1,.69.31,1.46,1.46,0,0,0,.39-1.37A3.72,3.72,0,0,1,195.23,89.12Z"
                  fill="#396039"
                />
                <path
                  d="M188.13,81.68a53.53,53.53,0,0,1,5.73,7,31.32,31.32,0,0,1,4,8.1,31.16,31.16,0,0,0-1.78-4.16,45,45,0,0,0-2.35-3.88A59,59,0,0,0,188.13,81.68Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M198.46,89.23a.27.27,0,0,1-.1-.18.25.25,0,0,1,.11-.21,2,2,0,0,1,.32-.26h0a1.19,1.19,0,0,1-.19-.2.26.26,0,0,1-.09-.18c0-.12.13-.18.23-.22l.21-.08c.05-.22.09-.45.13-.69l-.12,0-.31-.1a.83.83,0,0,1-.22-.14s0-.07,0-.08.21-.1.31-.15a.77.77,0,0,0,.27-.17c.08-.1,0-.21,0-.33a.28.28,0,0,1,.12-.21l.1-.09c0-.28.06-.58.08-.88l-.17,0a.86.86,0,0,1-.4-.21.32.32,0,0,1-.06-.4.75.75,0,0,1,.4-.3l.25-.08c0-.1,0-.2,0-.3,0-.3,0-.6,0-.9l0,0a.57.57,0,0,0-.16-.11.94.94,0,0,1-.25-.18.05.05,0,0,1,0-.08c.12-.1.4-.25.32-.45s-.11-.06-.16-.09a.15.15,0,0,1-.09-.18c0-.13.2-.18.28-.29s-.13-.16-.21-.16a2.13,2.13,0,0,1-.44,0,0,0,0,0,1,0-.09c.22-.16.45-.32.68-.46,0-.63-.1-1.23-.18-1.79l-.1,0a0,0,0,0,1-.06,0,2.18,2.18,0,0,0-.43.22l-.23.18c-.05,0-.13,0-.07-.08a1.08,1.08,0,0,1,.24-.18,4.78,4.78,0,0,1,.61-.38c-.07-.49-.16-.94-.25-1.36a2.4,2.4,0,0,0-.53.27l-.19.18a.06.06,0,0,1-.08-.08,1.62,1.62,0,0,1,.2-.18l.38-.34.15-.12a10.18,10.18,0,0,0-.37-1.17,6.15,6.15,0,0,1-.71.28,0,0,0,0,1-.06,0,1.09,1.09,0,0,1,.25-.57,2.85,2.85,0,0,1,.23-.26c-.26-.43-.55-.67-.85-.67-.6,0-1.15,1-1.53,2.57l.46.45s0,.11-.07.08a2.75,2.75,0,0,1-.44-.32c-.1.42-.18.88-.25,1.37a7.76,7.76,0,0,1,.47,1s0,.06,0,.07c-.2.11-.41.19-.61.28-.06.69-.1,1.42-.11,2.19a4.15,4.15,0,0,1,.42,1,2.32,2.32,0,0,1,0,.79c0,.13,0,.26,0,.39s0,.26,0,.39-.13.47-.17.72a.58.58,0,0,0,.16.59,1.19,1.19,0,0,0,.44.17.18.18,0,0,1,.13.11.26.26,0,0,1,0,.21,1.16,1.16,0,0,1-.46.39l-.17.09c.37,2.34,1,3.9,1.8,3.9.47,0,.91-.59,1.26-1.6Z"
                  fill="#659965"
                />
                <path
                  d="M197.31,77.27l-.05,10.15,0,5.07c0,1.69,0,3.39.08,5.07-.15-1.68-.13-3.38-.15-5.07V87.42C197.2,84,197.22,80.65,197.31,77.27Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M200.63,81a.68.68,0,0,0-.4,0c-.07.1-.15.19-.23.29a4.59,4.59,0,0,1-.36.41c-.12.13-.24.26-.35.4a3.67,3.67,0,0,0-.4.73,3.44,3.44,0,0,1-.41.84c-.17.2-.37.35-.55.53h0c0,.12-.09.25-.13.37a10.3,10.3,0,0,0-.5,2.4c0,.06,0,.12,0,.19a16.46,16.46,0,0,1,.31,1.73.67.67,0,0,0,.33.25c.82.27,2.1-1.33,2.84-3.58S201.46,81.25,200.63,81Z"
                  fill="#3b6818"
                />
                <path
                  d="M200.79,85.54s-3.56,1.81-3.69,11.18"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.11"
                />
                <path
                  d="M200.07,81.82a2,2,0,0,0-.49.93,4.26,4.26,0,0,1-.21,1,1.28,1.28,0,0,1-.32.44c-.13.12-.26.22-.39.35a1,1,0,0,0-.29.47,1,1,0,0,0,0,.42,2.22,2.22,0,0,1,.06.44,1.4,1.4,0,0,1-.18.59,1.65,1.65,0,0,0-.18.61,1.68,1.68,0,0,0,.07.39,1.46,1.46,0,0,1,0,.42,1.28,1.28,0,0,1-.13.39.66.66,0,0,0-.12.33,1,1,0,0,0,.15.49l0,.06a.39.39,0,0,0,.14.08c.65.22,1.79-1.43,2.53-3.68s.81-4.25.15-4.46a.42.42,0,0,0-.27,0A4,4,0,0,1,200.07,81.82Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M201.57,75.85c0-.15,0-.3,0-.45a3.75,3.75,0,0,1,0-.67,3.9,3.9,0,0,1,.13-.57,1.84,1.84,0,0,0,0-.52c0-.19-.06-.37-.07-.56a1.24,1.24,0,0,1,0-.43,1.78,1.78,0,0,1,.12-.29,1.75,1.75,0,0,1,.16-.25,0,0,0,0,0,0,0,2.1,2.1,0,0,1,1-.88,2.05,2.05,0,0,1,1.23-.08.75.75,0,0,0,.16.15,1.21,1.21,0,0,0,.46.17,1,1,0,0,1,.48.25,4.59,4.59,0,0,1,.33.52.77.77,0,0,0,.21.23.83.83,0,0,0,.27.12.61.61,0,0,1,.27.18,1.18,1.18,0,0,1,.19.25c.07.08.15.15.23.23s.11.12.16.19a2.62,2.62,0,0,1,.34,1.1,1.73,1.73,0,0,0,.26.61,3.59,3.59,0,0,0,.39.39,1.3,1.3,0,0,1,.29.33,1.47,1.47,0,0,1,.13.62c0,.51,0,1,.05,1.52a2.25,2.25,0,0,0,.06.36c0,.12.07.23.09.35a.82.82,0,0,1,0,.44,3.41,3.41,0,0,1-.21.38,1,1,0,0,0-.19.61,1.22,1.22,0,0,1,0,.33.75.75,0,0,1-.15.24,2.54,2.54,0,0,0-.37.43s0,0,0,0a1.71,1.71,0,0,1-.52.31,1.84,1.84,0,0,1-.87.14,4,4,0,0,0-.58-.31A6.91,6.91,0,0,1,205,81a3.13,3.13,0,0,1-.3-.2c-.1-.08-.18-.17-.28-.24s-.4-.24-.58-.39a1,1,0,0,1-.24-.31,3.68,3.68,0,0,1-.15-.35,1.44,1.44,0,0,0-.19-.31l-.27-.26-.37-.33a8,8,0,0,1-.46-.93,1.84,1.84,0,0,1,.17-.38c.09-.19.21-.36.31-.54s0-.07,0-.07-.34-.07-.51-.12a.65.65,0,0,1-.32-.18.78.78,0,0,1-.12-.22Z"
                  fill="#396039"
                />
                <path
                  d="M203.14,71.56a38.13,38.13,0,0,1,2.28,4.94c.65,1.69,1.22,3.42,1.75,5.15s1,3.51,1.37,5.27.75,3.55,1.08,5.34c-.34-1.78-.71-3.56-1.13-5.32s-.88-3.53-1.41-5.26-1.06-3.47-1.71-5.17A37.27,37.27,0,0,0,203.14,71.56Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M211.66,83.6c0-.21,0-.43,0-.65a14.59,14.59,0,0,1,1-3.2c.11-.1.21-.21.31-.32s.22-.29.33-.44l.38-.52a4.36,4.36,0,0,0,.61-1.07c.07-.19.09-.39.14-.58s.08-.26.13-.39c1.24-1.66,2.54-2.57,3.34-2.19a1.09,1.09,0,0,1,.3.23,1.09,1.09,0,0,0,.05.17,2.57,2.57,0,0,1,.07.83,3.49,3.49,0,0,1-.16.78,5.09,5.09,0,0,0-.27.92,3.57,3.57,0,0,0,0,.86,4.25,4.25,0,0,1,.06.87,1.21,1.21,0,0,1-.25.72,2.15,2.15,0,0,1-.46.33,2.39,2.39,0,0,0-.49.46.64.64,0,0,0-.17.47,5.11,5.11,0,0,0,.13.53,1.48,1.48,0,0,1-.38,1.18,6,6,0,0,1-1,.87c-.19.15-.38.29-.55.45s-.18.17-.26.26-.18.21-.27.31a5.11,5.11,0,0,1-1.33,1c-.24.15-.48.3-.71.47a1.66,1.66,0,0,1-.68-1.45A3.6,3.6,0,0,0,211.66,83.6Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M218.18,74.12a61.76,61.76,0,0,0-5,8.83,36.21,36.21,0,0,0-3.11,9.62,36.4,36.4,0,0,1,3-9.66A61.87,61.87,0,0,1,218.18,74.12Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M211.74,84.83c0-.17,0-.34.07-.51A11.39,11.39,0,0,1,213,81.94a2.09,2.09,0,0,0,.28-.22,3.06,3.06,0,0,0,.32-.3l.36-.36a3.19,3.19,0,0,0,.61-.76,3.43,3.43,0,0,0,.19-.44l.15-.29c1.18-1.14,2.32-1.69,2.9-1.28a.58.58,0,0,1,.2.21s0,.09,0,.14a2.11,2.11,0,0,1-.05.66,2.67,2.67,0,0,1-.23.59,4.66,4.66,0,0,0-.32.68,2.71,2.71,0,0,0-.08.69,4,4,0,0,1-.06.69,1,1,0,0,1-.29.53,2.14,2.14,0,0,1-.4.2,1.68,1.68,0,0,0-.45.3.47.47,0,0,0-.19.34c0,.14,0,.29,0,.43a1.13,1.13,0,0,1-.44.88,4.66,4.66,0,0,1-.9.56c-.17.09-.34.18-.5.28l-.23.17a2.52,2.52,0,0,0-.25.21,4.35,4.35,0,0,1-1.18.64c-.2.08-.41.17-.61.27a1.31,1.31,0,0,1-.35-1.22A2.45,2.45,0,0,0,211.74,84.83Z"
                  fill="#396039"
                />
                <path
                  d="M218.06,78.22a49,49,0,0,0-5,6.3,28.56,28.56,0,0,0-3.67,7.14,29,29,0,0,1,3.59-7.2A50,50,0,0,1,218.06,78.22Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M208.87,84.93a.23.23,0,0,0,.1-.16.27.27,0,0,0-.1-.19l-.29-.23h0l.18-.18a.33.33,0,0,0,.07-.16c0-.11-.12-.17-.2-.2l-.19-.07-.12-.61.11,0a2.29,2.29,0,0,0,.28-.09.62.62,0,0,0,.19-.12.05.05,0,0,0,0-.08c-.09,0-.18-.08-.27-.12a.56.56,0,0,1-.24-.16c-.07-.08,0-.19,0-.29a.25.25,0,0,0-.11-.19l-.09-.08c0-.25,0-.51-.07-.78l.16,0a.8.8,0,0,0,.35-.19.3.3,0,0,0,.06-.36.72.72,0,0,0-.36-.26l-.22-.07A2.56,2.56,0,0,1,208,80c0-.27,0-.53,0-.8,0,0,0,0,0,0a.26.26,0,0,1,.14-.09.76.76,0,0,0,.23-.17s0,0,0-.07-.36-.22-.29-.39.1-.06.14-.08a.14.14,0,0,0,.08-.16c0-.12-.18-.17-.24-.26s.11-.14.18-.15a1.7,1.7,0,0,0,.39,0s0-.06,0-.09l-.6-.41c0-.55.09-1.09.16-1.58l.08,0s.06,0,.06,0a2,2,0,0,1,.38.2l.2.15s.12,0,.07-.07l-.22-.16a4.86,4.86,0,0,0-.54-.33,11.88,11.88,0,0,1,.23-1.21,2.32,2.32,0,0,1,.47.24l.16.15c.05,0,.11,0,.07-.06a.69.69,0,0,0-.18-.16l-.33-.31-.13-.1a8,8,0,0,1,.33-1c.2.09.41.18.62.25a0,0,0,0,0,.06,0,1,1,0,0,0-.23-.52,1.37,1.37,0,0,0-.2-.22c.23-.39.49-.6.75-.6.54,0,1,.88,1.37,2.29-.14.12-.28.26-.41.39a0,0,0,0,0,.06.07,2.76,2.76,0,0,0,.39-.28c.09.37.16.78.23,1.21a6.2,6.2,0,0,0-.42.86s0,0,0,.06c.18.1.36.17.54.25.06.62.1,1.27.11,1.94a3.6,3.6,0,0,0-.38.88,2.12,2.12,0,0,0,0,.71l0,.35c0,.11,0,.23,0,.34s.11.42.15.64a.52.52,0,0,1-.14.53,1.38,1.38,0,0,1-.4.15c-.05,0-.1,0-.11.1a.23.23,0,0,0,0,.18.86.86,0,0,0,.41.34l.14.09c-.33,2.08-.92,3.47-1.6,3.47-.41,0-.8-.53-1.11-1.43Z"
                  fill="#659965"
                />
                <path
                  d="M209.89,74.3l.14,9v4.51c0,1.5,0,3-.13,4.51.12-1.5.07-3,.08-4.51l0-4.51Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M207,77.59a.69.69,0,0,1,.35,0c.07.09.14.17.2.26s.21.25.33.36a3.37,3.37,0,0,1,.3.36,3.17,3.17,0,0,1,.36.65,3,3,0,0,0,.37.74c.14.18.33.31.49.48h0c0,.11.08.22.11.33a8.89,8.89,0,0,1,.44,2.13c0,.06,0,.12,0,.17a11.54,11.54,0,0,0-.27,1.54.64.64,0,0,1-.3.22c-.73.24-1.86-1.18-2.52-3.18S206.21,77.84,207,77.59Z"
                  fill="#3b6818"
                />
                <path
                  d="M206.81,81.65s3.16,1.61,3.27,9.94"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.09"
                />
                <path
                  d="M207.45,78.35a1.8,1.8,0,0,1,.43.82,4.29,4.29,0,0,0,.18.88,1.05,1.05,0,0,0,.29.39c.11.11.24.2.35.31a.94.94,0,0,1,.25.42.81.81,0,0,1,0,.38,1.67,1.67,0,0,0-.06.39,1.43,1.43,0,0,0,.16.52,1.52,1.52,0,0,1,.16.54,1,1,0,0,1-.06.35.92.92,0,0,0,0,.37,1,1,0,0,0,.11.35.73.73,0,0,1,.11.29.82.82,0,0,1-.14.44l0,0a.33.33,0,0,1-.13.07c-.58.2-1.58-1.27-2.24-3.27s-.72-3.77-.14-4a.33.33,0,0,1,.24,0A3.46,3.46,0,0,0,207.45,78.35Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M225.62,74.79c0-.12,0-.25,0-.37a2.44,2.44,0,0,0,0-.54,3.94,3.94,0,0,0-.1-.47,1.86,1.86,0,0,1-.05-.42c0-.15.05-.3.06-.45a1,1,0,0,0,0-.35l-.09-.23c0-.07-.09-.14-.14-.21a0,0,0,0,1,0,0,1.68,1.68,0,0,0-.81-.71,1.65,1.65,0,0,0-1-.07.34.34,0,0,1-.12.12,1,1,0,0,1-.38.14.81.81,0,0,0-.39.2,3.78,3.78,0,0,0-.26.43.77.77,0,0,1-.18.18.58.58,0,0,1-.21.1.74.74,0,0,0-.23.14,1.59,1.59,0,0,0-.15.21c0,.07-.12.12-.18.19a.67.67,0,0,0-.14.15,2.44,2.44,0,0,0-.28.89,1.3,1.3,0,0,1-.21.5,2.27,2.27,0,0,1-.31.31,1.08,1.08,0,0,0-.24.28,1.07,1.07,0,0,0-.1.5c0,.41,0,.82,0,1.23,0,.1,0,.2,0,.3a2.68,2.68,0,0,0-.07.27.66.66,0,0,0,0,.37c.05.11.12.2.17.3a.93.93,0,0,1,.16.5.61.61,0,0,0,0,.27.47.47,0,0,0,.12.19c.09.12.22.22.3.35v0a1.43,1.43,0,0,0,.43.25,1.52,1.52,0,0,0,.7.11,2.73,2.73,0,0,1,.48-.25,4.49,4.49,0,0,0,.56-.24,1.32,1.32,0,0,0,.25-.16l.22-.19c.15-.12.33-.2.47-.32A.82.82,0,0,0,224,78c.05-.09.08-.19.12-.28a.82.82,0,0,1,.16-.25,2.28,2.28,0,0,1,.22-.22l.3-.26a7.66,7.66,0,0,0,.37-.76,1.23,1.23,0,0,0-.14-.31l-.25-.44a0,0,0,0,1,0-.06l.41-.09a.57.57,0,0,0,.26-.15.52.52,0,0,0,.1-.18C225.59,75,225.6,74.87,225.62,74.79Z"
                  fill="#396039"
                />
                <path
                  d="M224.34,71.3a31,31,0,0,0-1.81,4c-.52,1.38-1,2.78-1.39,4.19s-.79,2.84-1.14,4.27-.64,2.88-.92,4.32c.26-1.45.55-2.89.88-4.33s.69-2.87,1.11-4.28.89-2.81,1.42-4.19A31,31,0,0,1,224.34,71.3Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M217.42,81.08c0-.17,0-.35,0-.52a11,11,0,0,0-.81-2.6c-.08-.09-.17-.17-.25-.27a3.38,3.38,0,0,1-.27-.36c-.1-.14-.2-.27-.3-.42a3.22,3.22,0,0,1-.5-.86c-.05-.16-.07-.32-.12-.48a1.86,1.86,0,0,0-.1-.31c-1-1.35-2.06-2.09-2.71-1.78a.88.88,0,0,0-.24.19.57.57,0,0,0,0,.14,1.89,1.89,0,0,0-.06.67,2.91,2.91,0,0,0,.13.64,4.52,4.52,0,0,1,.22.74,3.31,3.31,0,0,1,0,.7,2.8,2.8,0,0,0-.05.71,1,1,0,0,0,.2.58,1.59,1.59,0,0,0,.37.27,1.57,1.57,0,0,1,.4.37.5.5,0,0,1,.14.38c0,.15-.08.28-.1.43a1.2,1.2,0,0,0,.3,1,4.65,4.65,0,0,0,.82.71c.15.12.31.24.45.37a2,2,0,0,1,.21.2,2.75,2.75,0,0,1,.22.26,4.38,4.38,0,0,0,1.08.83A5.65,5.65,0,0,1,217,83a1.33,1.33,0,0,0,.56-1.17A2.79,2.79,0,0,1,217.42,81.08Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M212.13,73.38a50.06,50.06,0,0,1,4.11,7.14,29.3,29.3,0,0,1,2.46,7.84,29.14,29.14,0,0,0-2.53-7.81A50.5,50.5,0,0,0,212.13,73.38Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M217.36,82.08c0-.14,0-.28-.06-.42a9.33,9.33,0,0,0-1-1.93l-.23-.17-.26-.25c-.09-.1-.19-.19-.29-.29a3,3,0,0,1-.5-.62c-.06-.11-.1-.24-.15-.35l-.12-.24c-1-.93-1.88-1.37-2.35-1a.55.55,0,0,0-.17.17s0,.08,0,.11a1.41,1.41,0,0,0,0,.54,2.15,2.15,0,0,0,.18.48,3.06,3.06,0,0,1,.26.55,1.76,1.76,0,0,1,.07.56,3.53,3.53,0,0,0,.05.56.74.74,0,0,0,.24.43,1.2,1.2,0,0,0,.32.16,1.29,1.29,0,0,1,.36.25.38.38,0,0,1,.16.27c0,.12,0,.24,0,.35a1,1,0,0,0,.36.72,3.68,3.68,0,0,0,.73.45,3.81,3.81,0,0,1,.4.23l.2.14.2.17a3.24,3.24,0,0,0,.95.51,4.52,4.52,0,0,1,.5.23,1,1,0,0,0,.28-1A2.41,2.41,0,0,1,217.36,82.08Z"
                  fill="#396039"
                />
                <path
                  d="M212.23,76.71a39.48,39.48,0,0,1,4.14,5.07,22.53,22.53,0,0,1,2.91,5.85,23.76,23.76,0,0,0-3-5.8A41.76,41.76,0,0,0,212.23,76.71Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M219.69,82.16a.18.18,0,0,1-.08-.13.22.22,0,0,1,.08-.15,2.11,2.11,0,0,1,.23-.19h0a1,1,0,0,1-.14-.15.2.2,0,0,1-.06-.13c0-.09.09-.13.17-.16l.15-.06c0-.15.07-.32.09-.49l-.09,0-.22-.07a.34.34,0,0,1-.16-.1s0,0,0-.06l.22-.1a.53.53,0,0,0,.2-.13c0-.07,0-.15,0-.23a.2.2,0,0,1,.09-.16l.07-.06c0-.21,0-.42.06-.63l-.13,0a.67.67,0,0,1-.29-.15.26.26,0,0,1,0-.29.58.58,0,0,1,.29-.22l.18-.05a1.85,1.85,0,0,0,0-.23c0-.21,0-.42,0-.64,0,0,0,0,0,0a.35.35,0,0,0-.12-.07,1.1,1.1,0,0,1-.18-.14,0,0,0,0,1,0,0c.09-.07.3-.18.24-.32s-.09-.05-.12-.07a.1.1,0,0,1-.06-.13c0-.09.14-.13.2-.21s-.1-.11-.15-.12a1.13,1.13,0,0,1-.32,0s0,0,0-.07.32-.23.49-.33c0-.45-.07-.88-.13-1.29l-.07,0s0,0,0,0a1.24,1.24,0,0,0-.3.16l-.17.12s-.09,0-.05,0a1.09,1.09,0,0,1,.17-.13,2.56,2.56,0,0,1,.45-.27c-.06-.36-.12-.69-.19-1a2,2,0,0,0-.38.2l-.14.12s-.08,0-.05,0a.86.86,0,0,1,.14-.13l.28-.25.1-.08a6.58,6.58,0,0,0-.27-.85,4.4,4.4,0,0,1-.5.21s0,0,0,0a.8.8,0,0,1,.18-.41,1.54,1.54,0,0,1,.17-.19c-.19-.31-.4-.49-.61-.49-.44,0-.84.72-1.11,1.86l.33.32s0,.09-.05.06a1.72,1.72,0,0,1-.32-.23q-.11.47-.18,1a5.52,5.52,0,0,1,.34.69s0,0,0,.06l-.44.2c0,.5-.08,1-.08,1.57a3.23,3.23,0,0,1,.3.72,1.57,1.57,0,0,1,0,.57l0,.28a1.27,1.27,0,0,1,0,.28c0,.18-.09.35-.12.52a.44.44,0,0,0,.12.43.9.9,0,0,0,.32.13.11.11,0,0,1,.09.08.18.18,0,0,1,0,.14.81.81,0,0,1-.33.28l-.12.07c.27,1.69.75,2.82,1.3,2.82.34,0,.65-.43.9-1.16Z"
                  fill="#659965"
                />
                <path
                  d="M218.86,73.53l0,7.32,0,3.67c0,1.22,0,2.44.06,3.66-.12-1.22-.1-2.44-.11-3.66V80.85C218.77,78.41,218.79,76,218.86,73.53Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M221.25,76.2a.48.48,0,0,0-.29,0l-.16.21c-.09.1-.17.2-.27.3a2.31,2.31,0,0,0-.24.29,1.91,1.91,0,0,0-.29.52,2.66,2.66,0,0,1-.3.61c-.12.14-.27.25-.4.38h0l-.09.27a7.53,7.53,0,0,0-.36,1.73s0,.09,0,.13a9.1,9.1,0,0,1,.22,1.25.51.51,0,0,0,.24.18c.6.2,1.52-1,2.05-2.58S221.85,76.4,221.25,76.2Z"
                  fill="#3b6818"
                />
                <path
                  d="M221.36,79.5s-2.57,1.31-2.65,8.07"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.08"
                />
                <path
                  d="M220.84,76.82a1.44,1.44,0,0,0-.35.67,2.9,2.9,0,0,1-.15.71,1,1,0,0,1-.23.32l-.28.25a.79.79,0,0,0-.21.34.8.8,0,0,0,0,.31,1.06,1.06,0,0,1,.05.31,1.13,1.13,0,0,1-.13.43,1.12,1.12,0,0,0-.13.44.87.87,0,0,0,.05.28,1,1,0,0,1,0,.3.94.94,0,0,1-.1.28.53.53,0,0,0-.08.24.76.76,0,0,0,.11.36l0,0,.1.07c.47.15,1.29-1,1.82-2.66s.59-3.07.12-3.22a.34.34,0,0,0-.2,0A2.88,2.88,0,0,1,220.84,76.82Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M239,75.09l0-.3a3.39,3.39,0,0,0,0-.45c0-.13-.05-.25-.08-.38a1,1,0,0,1,0-.35c0-.12,0-.25,0-.37a.7.7,0,0,0,0-.29,1.08,1.08,0,0,0-.08-.19,1.63,1.63,0,0,0-.11-.17,0,0,0,0,1,0,0A1.36,1.36,0,0,0,238,72a1.46,1.46,0,0,0-.83-.06.35.35,0,0,1-.1.11,1,1,0,0,1-.31.11.59.59,0,0,0-.32.17,3,3,0,0,0-.22.35.66.66,0,0,1-.14.15.58.58,0,0,1-.18.08.44.44,0,0,0-.18.12,1.83,1.83,0,0,0-.13.16,1.14,1.14,0,0,1-.15.16l-.11.12a1.88,1.88,0,0,0-.23.74,1.05,1.05,0,0,1-.17.41,3.19,3.19,0,0,1-.26.26.85.85,0,0,0-.2.22,1,1,0,0,0-.08.41c0,.34,0,.68,0,1a2,2,0,0,1,0,.24,2,2,0,0,0-.06.23.51.51,0,0,0,0,.3,2,2,0,0,0,.14.25.86.86,0,0,1,.13.41.41.41,0,0,0,0,.22.37.37,0,0,0,.09.16,2.26,2.26,0,0,1,.25.29h0a1.2,1.2,0,0,0,.34.21,1.29,1.29,0,0,0,.58.09,2.4,2.4,0,0,1,.39-.2c.16-.07.32-.12.47-.2a1.37,1.37,0,0,0,.2-.13l.19-.16c.12-.1.27-.16.38-.26a.68.68,0,0,0,.17-.21,1.6,1.6,0,0,0,.1-.23.57.57,0,0,1,.13-.21l.18-.18.24-.21a6.14,6.14,0,0,0,.31-.63,1.89,1.89,0,0,0-.11-.25c-.07-.13-.14-.24-.21-.36s0-.05,0-.05a1.87,1.87,0,0,0,.34-.08.4.4,0,0,0,.21-.12.38.38,0,0,0,.09-.15C239,75.22,239,75.15,239,75.09Z"
                  fill="#396039"
                />
                <path
                  d="M237.93,72.22a23.94,23.94,0,0,0-1.49,3.31c-.43,1.14-.8,2.29-1.14,3.46s-.66,2.33-1,3.51-.52,2.36-.75,3.56c.22-1.2.45-2.39.72-3.57s.57-2.36.91-3.52.74-2.32,1.18-3.45A24,24,0,0,1,237.93,72.22Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M232.23,80.27c0-.14,0-.29,0-.43a9.56,9.56,0,0,0-.66-2.14,1.45,1.45,0,0,1-.21-.22,3.15,3.15,0,0,1-.22-.29l-.25-.35a2.79,2.79,0,0,1-.41-.71c-.05-.13-.06-.26-.1-.39a2,2,0,0,0-.08-.26c-.83-1.11-1.7-1.72-2.24-1.46a.45.45,0,0,0-.19.15.49.49,0,0,0,0,.11,2.05,2.05,0,0,0,0,.55,3.12,3.12,0,0,0,.11.53,4.27,4.27,0,0,1,.18.61,2.84,2.84,0,0,1,0,.58,2.24,2.24,0,0,0,0,.58.75.75,0,0,0,.16.48,1.34,1.34,0,0,0,.31.22,1.38,1.38,0,0,1,.33.31.4.4,0,0,1,.11.31c0,.12-.06.23-.08.35a1,1,0,0,0,.24.8,4.73,4.73,0,0,0,.68.58,3.47,3.47,0,0,1,.37.3l.18.17.17.21a3.59,3.59,0,0,0,.9.69,3.37,3.37,0,0,1,.46.31,1.07,1.07,0,0,0,.46-1A2.58,2.58,0,0,1,232.23,80.27Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M227.88,73.93a41.27,41.27,0,0,1,3.38,5.88,23.6,23.6,0,0,1,2,6.45,23.93,23.93,0,0,0-2.07-6.43A41.74,41.74,0,0,0,227.88,73.93Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M232.18,81.09c0-.11,0-.23,0-.34a7.4,7.4,0,0,0-.8-1.59l-.18-.15a2.09,2.09,0,0,1-.22-.2l-.24-.24a2.29,2.29,0,0,1-.41-.51,2.52,2.52,0,0,1-.12-.29c0-.07-.07-.13-.1-.19-.79-.77-1.55-1.13-1.94-.86a.35.35,0,0,0-.13.14.31.31,0,0,0,0,.1,1,1,0,0,0,0,.43,1.93,1.93,0,0,0,.15.4,2.4,2.4,0,0,1,.21.46,1.36,1.36,0,0,1,.06.45,2.32,2.32,0,0,0,0,.46.62.62,0,0,0,.2.36,1.05,1.05,0,0,0,.26.13,1.21,1.21,0,0,1,.3.2.36.36,0,0,1,.13.23c0,.1,0,.19,0,.29a.77.77,0,0,0,.29.59,3.73,3.73,0,0,0,.6.37,2.59,2.59,0,0,1,.33.19.91.91,0,0,1,.16.11l.17.14a3,3,0,0,0,.78.43,3,3,0,0,1,.41.18.86.86,0,0,0,.24-.81A1.92,1.92,0,0,1,232.18,81.09Z"
                  fill="#396039"
                />
                <path
                  d="M228,76.68a32.4,32.4,0,0,1,3.4,4.17,18.6,18.6,0,0,1,2.4,4.8,18.73,18.73,0,0,0-2.45-4.77A32.31,32.31,0,0,0,228,76.68Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M234.1,81.16a.26.26,0,0,1-.07-.11s0-.09.07-.13l.19-.15h0l-.11-.12a.24.24,0,0,1-.06-.11c0-.07.08-.11.14-.13l.13,0c0-.13.05-.27.08-.41l-.08,0-.18-.06a.29.29,0,0,1-.13-.08,0,0,0,0,1,0-.05l.18-.08a.86.86,0,0,0,.16-.1c0-.06,0-.13,0-.2a.19.19,0,0,1,.07-.13l.06,0c0-.17,0-.34.05-.52l-.1,0a.6.6,0,0,1-.24-.12.2.2,0,0,1,0-.24.48.48,0,0,1,.24-.18l.15,0,0-.18c0-.17,0-.35,0-.53a0,0,0,0,0,0,0,.27.27,0,0,0-.1-.06.58.58,0,0,1-.15-.11s0,0,0,0,.24-.15.19-.27-.07,0-.1,0a.09.09,0,0,1-.05-.1c0-.08.12-.11.17-.18s-.08-.09-.13-.1a1.13,1.13,0,0,1-.26,0,0,0,0,0,1,0-.06,3.51,3.51,0,0,1,.4-.27c0-.38-.06-.73-.11-1.07l-.06,0s0,0,0,0l-.26.13-.13.11s-.08,0,0,0l.15-.11a3.13,3.13,0,0,1,.36-.22q-.06-.44-.15-.81a.94.94,0,0,0-.31.17l-.12.1a0,0,0,0,1,0,0,.4.4,0,0,1,.12-.1l.22-.21.09-.07a6.28,6.28,0,0,0-.22-.69l-.42.17s0,0,0,0a.73.73,0,0,1,.15-.35l.14-.15c-.16-.26-.33-.4-.51-.4-.36,0-.68.59-.91,1.53l.27.26s0,.07,0,.05a2.53,2.53,0,0,1-.27-.18c-.05.24-.1.51-.15.8a4.41,4.41,0,0,1,.28.58,0,0,0,0,1,0,0l-.36.17c0,.41-.06.84-.07,1.29a2.18,2.18,0,0,1,.25.59,1.49,1.49,0,0,1,0,.47l0,.24a1.62,1.62,0,0,1,0,.22c0,.15-.07.29-.1.43a.37.37,0,0,0,.1.36c.07.06.17.06.26.1s.07,0,.08.06a.23.23,0,0,1,0,.12.63.63,0,0,1-.28.23l-.09.06c.22,1.39.61,2.32,1.06,2.32.28,0,.54-.35.75-1Z"
                  fill="#659965"
                />
                <path
                  d="M233.41,74.05l0,6,0,3c0,1,0,2,0,3-.08-1-.06-2-.08-3v-3Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M235.38,76.25a.45.45,0,0,0-.23,0c-.05.06-.09.12-.14.17l-.21.25a1.21,1.21,0,0,0-.21.24,2.26,2.26,0,0,0-.24.43,2.3,2.3,0,0,1-.24.5c-.1.12-.23.21-.33.31h0l-.07.22a5.93,5.93,0,0,0-.3,1.42s0,.08,0,.12a7.27,7.27,0,0,1,.18,1,.36.36,0,0,0,.2.15c.49.16,1.25-.79,1.69-2.12S235.87,76.42,235.38,76.25Z"
                  fill="#3b6818"
                />
                <path
                  d="M235.48,79s-2.12,1.07-2.19,6.64"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.06"
                />
                <path
                  d="M235.05,76.76a1.13,1.13,0,0,0-.29.55,2.94,2.94,0,0,1-.12.59,1,1,0,0,1-.19.26,2.29,2.29,0,0,0-.23.21.55.55,0,0,0-.18.28.53.53,0,0,0,0,.25,1.09,1.09,0,0,1,0,.26.89.89,0,0,1-.11.35.88.88,0,0,0-.1.36.59.59,0,0,0,0,.23.69.69,0,0,1,0,.25.88.88,0,0,1-.07.23.37.37,0,0,0-.07.2.48.48,0,0,0,.09.29v0a.2.2,0,0,0,.09.05c.39.13,1.06-.85,1.5-2.18s.48-2.53.09-2.65a.22.22,0,0,0-.16,0A3.13,3.13,0,0,1,235.05,76.76Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M249.81,75.82c0-.07,0-.15,0-.23s0-.22,0-.33a2.86,2.86,0,0,0-.07-.28.76.76,0,0,1,0-.26c0-.1,0-.19,0-.28a.55.55,0,0,0,0-.22.42.42,0,0,0-.06-.14L249.6,74s0,0,0,0a1,1,0,0,0-.5-.44,1,1,0,0,0-.62,0,.27.27,0,0,1-.07.08.63.63,0,0,1-.23.08.36.36,0,0,0-.24.13,1.67,1.67,0,0,0-.17.26.52.52,0,0,1-.1.11.59.59,0,0,1-.14.06.38.38,0,0,0-.13.09l-.1.12a.63.63,0,0,1-.11.12l-.08.09a1.36,1.36,0,0,0-.17.55.85.85,0,0,1-.13.31l-.19.19a.49.49,0,0,0-.15.17.78.78,0,0,0-.07.3c0,.26,0,.51,0,.76a.57.57,0,0,1,0,.18c0,.06,0,.12,0,.17a.36.36,0,0,0,0,.23l.11.19a.53.53,0,0,1,.09.3.48.48,0,0,0,0,.17.75.75,0,0,0,.07.12,1.24,1.24,0,0,1,.19.21h0a1,1,0,0,0,.26.16,1.09,1.09,0,0,0,.44.06,1.59,1.59,0,0,1,.29-.15c.11,0,.23-.09.34-.15l.16-.1.13-.12a2.9,2.9,0,0,0,.29-.19.64.64,0,0,0,.13-.15l.07-.18a.36.36,0,0,1,.1-.15.8.8,0,0,1,.13-.13l.19-.17a4.91,4.91,0,0,0,.22-.46,1.08,1.08,0,0,0-.08-.19l-.16-.27a0,0,0,0,1,0,0l.25,0a.65.65,0,0,0,.16-.09l.06-.11Z"
                  fill="#396039"
                />
                <path
                  d="M249,73.68a17.66,17.66,0,0,0-1.12,2.47c-.32.85-.6,1.71-.85,2.58A50.08,50.08,0,0,0,245.79,84,52,52,0,0,1,247,78.72c.27-.87.55-1.73.88-2.58A17.14,17.14,0,0,1,249,73.68Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M244.77,79.69c0-.11,0-.22,0-.33a7.54,7.54,0,0,0-.5-1.59l-.15-.16a2,2,0,0,1-.17-.23l-.19-.25a2.33,2.33,0,0,1-.3-.53,1.63,1.63,0,0,1-.07-.3,1.46,1.46,0,0,0-.07-.19c-.62-.83-1.26-1.28-1.67-1.09a.49.49,0,0,0-.14.11l0,.09a1.39,1.39,0,0,0,0,.41,1.8,1.8,0,0,0,.08.39,3.47,3.47,0,0,1,.13.46,1.57,1.57,0,0,1,0,.43,2.08,2.08,0,0,0,0,.43.59.59,0,0,0,.13.36,1,1,0,0,0,.23.17,1,1,0,0,1,.24.23.28.28,0,0,1,.09.23,2.5,2.5,0,0,1-.07.26.74.74,0,0,0,.19.59,3.5,3.5,0,0,0,.5.44l.28.22.13.13a1,1,0,0,1,.13.16,3,3,0,0,0,.67.51l.35.23a.83.83,0,0,0,.34-.72A1.77,1.77,0,0,1,244.77,79.69Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M241.52,75a30.2,30.2,0,0,1,2.53,4.38,18.25,18.25,0,0,1,1.51,4.82,18.08,18.08,0,0,0-1.55-4.8A30.72,30.72,0,0,0,241.52,75Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M244.73,80.3l0-.26a5.19,5.19,0,0,0-.59-1.18l-.14-.11-.16-.15-.18-.18a1.79,1.79,0,0,1-.3-.38,2.14,2.14,0,0,1-.1-.22s0-.1-.07-.14c-.59-.57-1.16-.85-1.45-.64a.32.32,0,0,0-.1.1.17.17,0,0,1,0,.07.93.93,0,0,0,0,.33,1.21,1.21,0,0,0,.11.3,1.33,1.33,0,0,1,.16.34,1.27,1.27,0,0,1,0,.34,2,2,0,0,0,0,.34.56.56,0,0,0,.15.27,1.24,1.24,0,0,0,.2.1.78.78,0,0,1,.22.15.22.22,0,0,1,.09.17,1.48,1.48,0,0,1,0,.21.59.59,0,0,0,.22.44,1.89,1.89,0,0,0,.45.28l.24.14.12.08.13.11a2.52,2.52,0,0,0,.58.32l.31.13a.64.64,0,0,0,.17-.6A1.65,1.65,0,0,1,244.73,80.3Z"
                  fill="#396039"
                />
                <path
                  d="M241.58,77a24.62,24.62,0,0,1,2.55,3.12,14.35,14.35,0,0,1,1.79,3.59,14.52,14.52,0,0,0-1.83-3.57A25.22,25.22,0,0,0,241.58,77Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M246.16,80.35a.12.12,0,0,1,0-.08.11.11,0,0,1,0-.09.81.81,0,0,1,.14-.12h0l-.09-.09a.19.19,0,0,1,0-.08c0-.06.05-.08.1-.1l.09,0,.06-.31h-.06l-.13,0a.21.21,0,0,1-.1-.06,0,0,0,0,1,0,0l.13-.06a.32.32,0,0,0,.12-.08s0-.09,0-.14a.19.19,0,0,1,.05-.1l.05,0,0-.39-.07,0a.38.38,0,0,1-.18-.09.15.15,0,0,1,0-.18.4.4,0,0,1,.18-.13l.11,0,0-.13v-.4h0a.15.15,0,0,0-.07,0l-.11-.08a0,0,0,0,1,0,0s.18-.11.14-.19,0,0-.07,0a.07.07,0,0,1,0-.08c0-.06.09-.09.12-.13s-.06-.07-.09-.08h-.19s0,0,0,0a2.73,2.73,0,0,1,.3-.21c0-.28,0-.54-.08-.79h0s0,0,0,0l-.19.1-.1.08s-.06,0,0,0l.1-.08a1.56,1.56,0,0,1,.28-.16c0-.22-.08-.42-.12-.61a1,1,0,0,0-.23.12l-.09.08a0,0,0,1,1,0,0l.09-.08a1.29,1.29,0,0,1,.17-.16l.06,0a4.62,4.62,0,0,0-.16-.52,2.58,2.58,0,0,1-.31.13s0,0,0,0a.41.41,0,0,1,.11-.26.52.52,0,0,1,.1-.11c-.12-.19-.24-.3-.37-.3s-.52.44-.69,1.14l.21.2a0,0,0,1,1,0,0l-.2-.14c0,.19-.08.39-.11.61a3.29,3.29,0,0,1,.21.42s0,0,0,0l-.27.12c0,.31,0,.63-.05,1a1.72,1.72,0,0,1,.19.44.82.82,0,0,1,0,.35c0,.06,0,.11,0,.17a.91.91,0,0,1,0,.17c0,.11-.06.22-.08.32a.29.29,0,0,0,.07.27.68.68,0,0,0,.2.07.08.08,0,0,1,0,.14.42.42,0,0,1-.2.17l-.07,0c.16,1,.46,1.74.8,1.74s.4-.27.55-.71A.1.1,0,0,0,246.16,80.35Z"
                  fill="#659965"
                />
                <path
                  d="M245.66,75.05l0,4.5V81.8c0,.75,0,1.5,0,2.24-.07-.74-.06-1.49-.07-2.24V79.55Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M247.12,76.69a.25.25,0,0,0-.17,0,1.13,1.13,0,0,0-.1.13l-.16.18a1.37,1.37,0,0,0-.16.18,2,2,0,0,0-.18.32,1.27,1.27,0,0,1-.18.37,2.72,2.72,0,0,1-.24.24h0a1.09,1.09,0,0,0,0,.17,4.1,4.1,0,0,0-.22,1.06v.08a6.92,6.92,0,0,1,.14.77.33.33,0,0,0,.15.11c.36.12.93-.59,1.25-1.59S247.49,76.81,247.12,76.69Z"
                  fill="#3b6818"
                />
                <path
                  d="M247.19,78.71s-1.57.81-1.63,5"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.05"
                />
                <path
                  d="M246.88,77.07a.78.78,0,0,0-.22.41,2.15,2.15,0,0,1-.09.44.94.94,0,0,1-.14.19l-.18.16a.43.43,0,0,0-.12.21.37.37,0,0,0,0,.18.69.69,0,0,1,0,.2.61.61,0,0,1-.08.26.61.61,0,0,0-.08.27,1,1,0,0,0,0,.17.4.4,0,0,1,0,.19.49.49,0,0,1-.06.17.38.38,0,0,0,0,.15.57.57,0,0,0,.07.22v0l.07,0c.28.09.79-.64,1.11-1.64s.36-1.88.07-2c0,0-.07,0-.12,0A2.1,2.1,0,0,1,246.88,77.07Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M260.32,74.77a1.79,1.79,0,0,0,0-.23,1.82,1.82,0,0,0,0-.33,1.43,1.43,0,0,0-.07-.28,1.18,1.18,0,0,1,0-.26c0-.1,0-.19,0-.28a.53.53,0,0,0,0-.22.78.78,0,0,0-.05-.14l-.09-.12v0a1,1,0,0,0-.5-.44,1,1,0,0,0-.62,0l-.07.08a.9.9,0,0,1-.23.08.42.42,0,0,0-.24.12,1.83,1.83,0,0,0-.16.26.43.43,0,0,1-.11.12.75.75,0,0,1-.13.06.34.34,0,0,0-.14.09.58.58,0,0,0-.1.12.63.63,0,0,1-.11.12l-.08.09a1.36,1.36,0,0,0-.17.55.74.74,0,0,1-.13.3,1.84,1.84,0,0,1-.19.2.61.61,0,0,0-.15.17.78.78,0,0,0-.07.3c0,.26,0,.51,0,.76a.57.57,0,0,1,0,.18c0,.06,0,.12,0,.17a.36.36,0,0,0,0,.23l.11.19a.53.53,0,0,1,.09.3.86.86,0,0,0,0,.16.36.36,0,0,0,.08.12,1.92,1.92,0,0,1,.18.22h0a1,1,0,0,0,.26.15,1,1,0,0,0,.44.07,1.59,1.59,0,0,1,.29-.15l.35-.15.15-.1.14-.12c.09-.07.2-.12.28-.19a.61.61,0,0,0,.13-.15,1.34,1.34,0,0,0,.07-.18.78.78,0,0,1,.1-.15l.13-.14.19-.16a4.91,4.91,0,0,0,.22-.46,1.08,1.08,0,0,0-.08-.19l-.16-.27s0,0,0,0l.25-.06a.29.29,0,0,0,.16-.09.39.39,0,0,0,.06-.11Z"
                  fill="#396039"
                />
                <path
                  d="M259.54,72.63a18.89,18.89,0,0,0-1.12,2.47c-.32.85-.6,1.71-.85,2.58A53.17,53.17,0,0,0,256.3,83a53.32,53.32,0,0,1,1.22-5.29c.27-.86.55-1.72.88-2.57A17.14,17.14,0,0,1,259.54,72.63Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M255.28,78.64c0-.11,0-.22,0-.33a7.54,7.54,0,0,0-.5-1.59c-.05-.06-.11-.11-.15-.17l-.17-.22c-.06-.08-.12-.17-.19-.25a2.19,2.19,0,0,1-.3-.54,2.46,2.46,0,0,1-.07-.29,1.46,1.46,0,0,0-.07-.19c-.61-.83-1.26-1.28-1.66-1.09a.33.33,0,0,0-.15.11.29.29,0,0,0,0,.09,1.12,1.12,0,0,0,0,.41,1.8,1.8,0,0,0,.08.39,2.42,2.42,0,0,1,.13.46,1.57,1.57,0,0,1,0,.43,2.08,2.08,0,0,0,0,.43.59.59,0,0,0,.13.36,1.37,1.37,0,0,0,.23.17,1,1,0,0,1,.24.23.28.28,0,0,1,.09.23,2.5,2.5,0,0,1-.07.26.76.76,0,0,0,.19.59,3.5,3.5,0,0,0,.5.44l.28.22a.8.8,0,0,1,.13.13,1,1,0,0,1,.13.16,3,3,0,0,0,.67.51l.35.23a.83.83,0,0,0,.34-.72A2.44,2.44,0,0,1,255.28,78.64Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M252,73.9a29.92,29.92,0,0,1,2.53,4.39,17.78,17.78,0,0,1,1.51,4.82,18.08,18.08,0,0,0-1.55-4.8A31.38,31.38,0,0,0,252,73.9Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M255.24,79.25l0-.26a5.19,5.19,0,0,0-.59-1.18l-.14-.11-.16-.15-.18-.18a1.79,1.79,0,0,1-.3-.38c0-.07-.06-.15-.1-.22a.61.61,0,0,0-.07-.14c-.59-.58-1.16-.85-1.45-.65a.52.52,0,0,0-.1.11.17.17,0,0,1,0,.07.93.93,0,0,0,0,.33,1.21,1.21,0,0,0,.11.3,1.33,1.33,0,0,1,.16.34,1.27,1.27,0,0,1,0,.34c0,.11,0,.23,0,.34a.56.56,0,0,0,.15.27,1.24,1.24,0,0,0,.2.1.78.78,0,0,1,.22.15.25.25,0,0,1,.1.17c0,.07,0,.14,0,.21a.59.59,0,0,0,.22.44,2.6,2.6,0,0,0,.45.28l.25.14.11.08a.69.69,0,0,1,.13.11,2.08,2.08,0,0,0,.59.31l.3.14c.15-.1.2-.32.17-.61A1.42,1.42,0,0,1,255.24,79.25Z"
                  fill="#396039"
                />
                <path
                  d="M252.1,76a25.43,25.43,0,0,1,2.54,3.12,14.12,14.12,0,0,1,1.79,3.58,14.64,14.64,0,0,0-1.83-3.56A25.14,25.14,0,0,0,252.1,76Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M256.68,79.3a.1.1,0,0,1-.05-.08.14.14,0,0,1,.05-.1l.14-.11h0l-.09-.09a.19.19,0,0,1,0-.08c0-.06.05-.08.1-.1l.09,0c0-.09,0-.2.06-.3l-.06,0-.13,0a.21.21,0,0,1-.1-.06,0,0,0,0,1,0,0l.13-.06a.32.32,0,0,0,.12-.08s0-.09,0-.14a.15.15,0,0,1,.06-.1l0,0c0-.12,0-.25,0-.39l-.08,0a.44.44,0,0,1-.18-.09.15.15,0,0,1,0-.18A.34.34,0,0,1,257,77l.11,0,0-.13v-.42l-.07,0-.11-.08a0,0,0,0,1,0,0s.18-.11.14-.2-.05,0-.07,0a.06.06,0,0,1,0-.07c0-.06.09-.09.12-.13s-.05-.07-.09-.08a1.21,1.21,0,0,1-.19,0s0,0,0,0l.3-.2c0-.28,0-.54-.08-.79h0s0,0,0,0l-.19.1-.1.07s-.06,0,0,0l.11-.08a1.78,1.78,0,0,1,.27-.17c0-.21-.07-.41-.12-.6a1,1,0,0,0-.23.12.6.6,0,0,0-.08.08,0,0,0,0,1,0,0l.09-.08.17-.15.06,0a4.06,4.06,0,0,0-.16-.52l-.31.13s0,0,0,0a.47.47,0,0,1,.11-.26.52.52,0,0,1,.1-.11c-.11-.2-.24-.3-.37-.3s-.51.44-.69,1.14l.21.2s0,0,0,0l-.2-.14c0,.19-.08.39-.11.61a3.29,3.29,0,0,1,.21.42s0,0,0,0l-.27.12c0,.31,0,.63-.05,1a1.72,1.72,0,0,1,.19.44,1,1,0,0,1,0,.35,1,1,0,0,0,0,.17.91.91,0,0,1,0,.17c0,.11-.06.21-.08.32a.3.3,0,0,0,.08.27.62.62,0,0,0,.19.07s.05,0,.06.05a.1.1,0,0,1,0,.09.42.42,0,0,1-.2.17l-.07,0c.16,1,.46,1.74.8,1.74s.4-.27.55-.71Z"
                  fill="#659965"
                />
                <path
                  d="M256.17,74l0,4.5v2.24c0,.75,0,1.51,0,2.25-.07-.74-.05-1.5-.07-2.25V78.5Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M257.64,75.64a.28.28,0,0,0-.18,0,1.47,1.47,0,0,0-.1.13l-.16.18a.93.93,0,0,0-.16.18,1.09,1.09,0,0,0-.17.32,1.62,1.62,0,0,1-.19.37,2.72,2.72,0,0,1-.24.24h0s0,.11-.05.17a4.1,4.1,0,0,0-.22,1.06.22.22,0,0,0,0,.08c0,.26.12.51.13.77a.33.33,0,0,0,.15.11c.36.12.93-.59,1.26-1.59S258,75.76,257.64,75.64Z"
                  fill="#3b6818"
                />
                <path
                  d="M257.71,77.66s-1.58.81-1.64,5"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.05"
                />
                <path
                  d="M257.39,76a1,1,0,0,0-.22.42,2.2,2.2,0,0,1-.09.43.78.78,0,0,1-.14.2l-.18.15a.55.55,0,0,0-.12.21.41.41,0,0,0,0,.19.69.69,0,0,1,0,.2.65.65,0,0,1-.08.26.77.77,0,0,0-.08.27,1,1,0,0,0,0,.17.4.4,0,0,1,0,.19.55.55,0,0,1-.05.17.35.35,0,0,0-.06.14.48.48,0,0,0,.07.22v0l.07,0c.29.09.79-.64,1.12-1.64s.36-1.88.07-2a.2.2,0,0,0-.13,0A1.65,1.65,0,0,1,257.39,76Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M272.93,74.77a1.79,1.79,0,0,0,0-.23,1.22,1.22,0,0,0,0-.33,2.8,2.8,0,0,0-.06-.28,1.22,1.22,0,0,1,0-.26,2.36,2.36,0,0,1,0-.28.78.78,0,0,0,0-.22l-.06-.14a.83.83,0,0,0-.08-.12,0,0,0,0,1,0,0,1.11,1.11,0,0,0-.5-.44,1,1,0,0,0-.62,0l-.08.08a.9.9,0,0,1-.23.08.46.46,0,0,0-.24.12c-.07.08-.1.18-.16.26a.43.43,0,0,1-.11.12.75.75,0,0,1-.13.06.42.42,0,0,0-.14.09.54.54,0,0,0-.09.12l-.12.12-.08.09a1.53,1.53,0,0,0-.17.55.63.63,0,0,1-.13.3.9.9,0,0,1-.19.2.61.61,0,0,0-.15.17.62.62,0,0,0-.06.3c0,.26,0,.51,0,.76l0,.18a1.54,1.54,0,0,0-.05.17.44.44,0,0,0,0,.23c0,.06.07.12.1.19a.63.63,0,0,1,.1.3.29.29,0,0,0,0,.16.24.24,0,0,0,.07.12c.06.08.14.13.18.22h0a.84.84,0,0,0,.26.15.89.89,0,0,0,.43.07,1.59,1.59,0,0,1,.29-.15,3.68,3.68,0,0,0,.35-.15l.15-.1.14-.12c.09-.07.2-.12.29-.19a.57.57,0,0,0,.12-.15,1.34,1.34,0,0,0,.07-.18.78.78,0,0,1,.1-.15l.13-.14.19-.16a4.93,4.93,0,0,0,.23-.46.66.66,0,0,0-.09-.19c0-.09-.1-.18-.15-.27s0,0,0,0a2.27,2.27,0,0,0,.25-.06.26.26,0,0,0,.16-.09.24.24,0,0,0,.06-.11Z"
                  fill="#396039"
                />
                <path
                  d="M272.15,72.63A20.31,20.31,0,0,0,271,75.1c-.32.85-.59,1.71-.85,2.58A50.46,50.46,0,0,0,268.92,83a48.23,48.23,0,0,1,1.22-5.29c.26-.86.54-1.72.87-2.57A18.3,18.3,0,0,1,272.15,72.63Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M267.9,78.64c0-.11,0-.22,0-.33a7,7,0,0,0-.5-1.59l-.15-.17-.17-.22-.18-.25a2.23,2.23,0,0,1-.31-.54c0-.09,0-.19-.07-.29l-.06-.19c-.62-.83-1.27-1.28-1.67-1.09a.39.39,0,0,0-.15.11s0,.06,0,.09a1.12,1.12,0,0,0,0,.41,1.8,1.8,0,0,0,.08.39,2.42,2.42,0,0,1,.13.46,1.56,1.56,0,0,1,0,.43,2.08,2.08,0,0,0,0,.43.58.58,0,0,0,.12.36,2,2,0,0,0,.23.17,1.09,1.09,0,0,1,.25.23.31.31,0,0,1,.08.23c0,.09-.05.17-.06.26a.75.75,0,0,0,.18.59,3.1,3.1,0,0,0,.51.44,2.88,2.88,0,0,1,.27.22l.13.13.14.16a2.77,2.77,0,0,0,.66.51l.35.23c.21-.1.32-.36.34-.72A1.82,1.82,0,0,1,267.9,78.64Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M264.65,73.9a30.79,30.79,0,0,1,2.52,4.39,17.78,17.78,0,0,1,1.51,4.82,18.08,18.08,0,0,0-1.55-4.8A31.32,31.32,0,0,0,264.65,73.9Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M267.86,79.25a1.15,1.15,0,0,1,0-.26,5.72,5.72,0,0,0-.6-1.18l-.14-.11-.15-.15-.18-.18a1.84,1.84,0,0,1-.31-.38,2,2,0,0,1-.09-.22s-.05-.1-.08-.14c-.59-.58-1.15-.85-1.44-.65a.35.35,0,0,0-.1.11.17.17,0,0,0,0,.07.92.92,0,0,0,0,.33c0,.1.07.2.11.3a1.8,1.8,0,0,1,.17.34,1.86,1.86,0,0,1,0,.34,1.31,1.31,0,0,0,0,.34.47.47,0,0,0,.14.27,1.24,1.24,0,0,0,.2.1.66.66,0,0,1,.22.15.22.22,0,0,1,.1.17c0,.07,0,.14,0,.21a.63.63,0,0,0,.22.44,3,3,0,0,0,.45.28,2,2,0,0,1,.25.14l.12.08.12.11a2.08,2.08,0,0,0,.59.31l.3.14c.15-.1.2-.32.18-.61A1.42,1.42,0,0,1,267.86,79.25Z"
                  fill="#396039"
                />
                <path
                  d="M264.71,76a24.54,24.54,0,0,1,2.54,3.12A14.12,14.12,0,0,1,269,82.65a14.64,14.64,0,0,0-1.83-3.56A25.14,25.14,0,0,0,264.71,76Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M269.29,79.3s-.05,0-.05-.08a.19.19,0,0,1,.05-.1l.14-.11h0a.38.38,0,0,1-.09-.09.12.12,0,0,1,0-.08c0-.06.06-.08.1-.1l.1,0a2.68,2.68,0,0,0,.05-.3l-.05,0-.14,0a.18.18,0,0,1-.09-.06,0,0,0,0,1,0,0l.14-.06a.32.32,0,0,0,.12-.08s0-.09,0-.14a.15.15,0,0,1,.06-.1s0,0,0,0,0-.25,0-.39l-.08,0a.44.44,0,0,1-.18-.09.15.15,0,0,1,0-.18c0-.07.11-.1.18-.13l.11,0a.59.59,0,0,1,0-.13c0-.13,0-.27,0-.4v0a.2.2,0,0,0-.08,0l-.11-.08a0,0,0,0,1,0,0c.05,0,.18-.11.14-.2s-.05,0-.07,0a.06.06,0,0,1,0-.07c0-.06.09-.09.13-.13s-.06-.07-.1-.08a1.21,1.21,0,0,1-.19,0s0,0,0,0a3.28,3.28,0,0,1,.31-.2c0-.28-.05-.54-.08-.79h-.05l0,0a1,1,0,0,0-.18.1l-.11.07a0,0,0,0,1,0,0l.11-.08.27-.17c0-.21-.07-.41-.11-.6a.9.9,0,0,0-.24.12.6.6,0,0,1-.08.08s-.05,0,0,0a.6.6,0,0,1,.08-.08l.17-.15.07,0a4,4,0,0,0-.17-.52l-.31.13,0,0a.56.56,0,0,1,.11-.26l.1-.11c-.11-.2-.24-.3-.37-.3s-.51.44-.68,1.14a1.89,1.89,0,0,1,.2.2s0,0,0,0a1.33,1.33,0,0,1-.19-.14,5.12,5.12,0,0,0-.11.61,3.23,3.23,0,0,1,.2.42,0,0,0,0,1,0,0l-.27.12c0,.31,0,.63,0,1a2.14,2.14,0,0,1,.18.44,1,1,0,0,1,0,.35c0,.06,0,.11,0,.17a.91.91,0,0,1,0,.17c0,.11,0,.21-.07.32a.27.27,0,0,0,.07.27.68.68,0,0,0,.2.07s0,0,0,.05a.14.14,0,0,1,0,.09.47.47,0,0,1-.2.17l-.08,0c.17,1,.46,1.74.8,1.74s.4-.27.56-.71Z"
                  fill="#659965"
                />
                <path
                  d="M268.78,74l0,4.5,0,2.24c0,.75,0,1.51,0,2.25-.06-.74,0-1.5-.06-2.25V78.5Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M270.25,75.64a.28.28,0,0,0-.18,0l-.1.13-.16.18a.9.9,0,0,0-.15.18,1.11,1.11,0,0,0-.18.32,1.59,1.59,0,0,1-.18.37c-.08.09-.17.16-.25.24h0l-.06.17a4.1,4.1,0,0,0-.22,1.06.22.22,0,0,0,0,.08,6.88,6.88,0,0,1,.13.77.33.33,0,0,0,.15.11c.37.12.93-.59,1.26-1.59S270.62,75.76,270.25,75.64Z"
                  fill="#3b6818"
                />
                <path
                  d="M270.32,77.66s-1.58.81-1.63,5"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.05"
                />
                <path
                  d="M270,76a1,1,0,0,0-.22.42,1.65,1.65,0,0,1-.09.43.48.48,0,0,1-.14.2l-.17.15a.46.46,0,0,0-.13.21.31.31,0,0,0,0,.19,1.36,1.36,0,0,1,0,.2.65.65,0,0,1-.08.26.77.77,0,0,0-.07.27.5.5,0,0,0,0,.17.58.58,0,0,1,0,.19.58.58,0,0,1-.06.17.24.24,0,0,0-.05.14.38.38,0,0,0,.06.22l0,0,.06,0c.29.09.79-.64,1.12-1.64s.36-1.88.07-2a.17.17,0,0,0-.12,0A1.69,1.69,0,0,1,270,76Z"
                  fill="#659965"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M286.6,74.77c0-.08,0-.15,0-.23s0-.22,0-.33-.05-.19-.07-.28a1.22,1.22,0,0,1,0-.26c0-.1,0-.19,0-.28a.53.53,0,0,0,0-.22.84.84,0,0,0-.06-.14l-.08-.12s0,0,0,0a1,1,0,0,0-.5-.44,1,1,0,0,0-.62,0l-.07.08a1,1,0,0,1-.24.08.4.4,0,0,0-.23.12c-.07.08-.11.18-.17.26a.4.4,0,0,1-.1.12.59.59,0,0,1-.14.06.3.3,0,0,0-.13.09.58.58,0,0,0-.1.12.63.63,0,0,1-.11.12l-.08.09a1.36,1.36,0,0,0-.17.55.74.74,0,0,1-.13.3,1.26,1.26,0,0,1-.2.2.58.58,0,0,0-.14.17.78.78,0,0,0-.07.3c0,.26,0,.51,0,.76l0,.18c0,.06,0,.12,0,.17a.36.36,0,0,0,0,.23l.11.19a.53.53,0,0,1,.09.3.43.43,0,0,0,0,.16.24.24,0,0,0,.07.12,2,2,0,0,1,.19.22h0a1,1,0,0,0,.26.15.93.93,0,0,0,.44.07,1.32,1.32,0,0,1,.29-.15c.11,0,.23-.09.34-.15l.16-.1.13-.12c.1-.07.2-.12.29-.19a.57.57,0,0,0,.12-.15l.08-.18a.46.46,0,0,1,.09-.15l.14-.14.18-.16a3.29,3.29,0,0,0,.23-.46,1.08,1.08,0,0,0-.08-.19l-.16-.27s0,0,0,0a1.83,1.83,0,0,0,.25-.06.26.26,0,0,0,.16-.09.41.41,0,0,0,.07-.11Z"
                  fill="#396039"
                />
                <path
                  d="M285.82,72.63a17.66,17.66,0,0,0-1.12,2.47c-.32.85-.6,1.71-.85,2.58A50.51,50.51,0,0,0,282.58,83a53.32,53.32,0,0,1,1.22-5.29c.26-.86.55-1.72.88-2.57A17.14,17.14,0,0,1,285.82,72.63Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M281.56,78.64c0-.11,0-.22,0-.33a6.93,6.93,0,0,0-.49-1.59l-.16-.17a1.77,1.77,0,0,1-.16-.22l-.19-.25a2.19,2.19,0,0,1-.3-.54,2.45,2.45,0,0,1-.08-.29.7.7,0,0,0-.06-.19c-.62-.83-1.26-1.28-1.67-1.09a.36.36,0,0,0-.14.11l0,.09a1.12,1.12,0,0,0,0,.41,1.8,1.8,0,0,0,.08.39,3.47,3.47,0,0,1,.13.46,1.57,1.57,0,0,1,0,.43,2.08,2.08,0,0,0,0,.43.59.59,0,0,0,.13.36,1.37,1.37,0,0,0,.23.17,1,1,0,0,1,.24.23.28.28,0,0,1,.09.23c0,.09-.05.17-.07.26a.72.72,0,0,0,.19.59,3.5,3.5,0,0,0,.5.44l.28.22a1.59,1.59,0,0,1,.13.13,1,1,0,0,1,.13.16,3,3,0,0,0,.67.51l.35.23a.83.83,0,0,0,.34-.72A1.83,1.83,0,0,1,281.56,78.64Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M278.31,73.9a31.84,31.84,0,0,1,2.53,4.39,18.13,18.13,0,0,1,1.51,4.82,18.08,18.08,0,0,0-1.55-4.8A31.38,31.38,0,0,0,278.31,73.9Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M281.52,79.25l0-.26a5.19,5.19,0,0,0-.59-1.18l-.14-.11-.16-.15-.18-.18a2.24,2.24,0,0,1-.31-.38l-.09-.22s0-.1-.07-.14c-.59-.58-1.16-.85-1.45-.65a.52.52,0,0,0-.1.11s0,0,0,.07a1.22,1.22,0,0,0,0,.33,1.88,1.88,0,0,0,.12.3,2.68,2.68,0,0,1,.16.34,1.27,1.27,0,0,1,0,.34,2,2,0,0,0,0,.34.49.49,0,0,0,.15.27,1.24,1.24,0,0,0,.2.1.78.78,0,0,1,.22.15.21.21,0,0,1,.09.17,1.48,1.48,0,0,1,0,.21.59.59,0,0,0,.22.44,2.27,2.27,0,0,0,.45.28l.24.14.12.08a1.27,1.27,0,0,1,.13.11,2.16,2.16,0,0,0,.58.31l.31.14a.65.65,0,0,0,.17-.61A1.42,1.42,0,0,1,281.52,79.25Z"
                  fill="#396039"
                />
                <path
                  d="M278.37,76a24.54,24.54,0,0,1,2.54,3.12,14.12,14.12,0,0,1,1.79,3.58,14.26,14.26,0,0,0-1.82-3.56A25.22,25.22,0,0,0,278.37,76Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M283,79.3a.12.12,0,0,1,0-.08s0-.07,0-.1l.14-.11h0l-.09-.09a.2.2,0,0,1,0-.08c0-.06.06-.08.11-.1l.09,0,.06-.3-.06,0-.14,0a.18.18,0,0,1-.09-.06,0,0,0,0,1,0,0l.13-.06a.32.32,0,0,0,.12-.08s0-.09,0-.14a.14.14,0,0,1,.05-.1l.05,0q0-.18,0-.39l-.07,0a.38.38,0,0,1-.18-.09.15.15,0,0,1,0-.18.34.34,0,0,1,.18-.13l.11,0a.59.59,0,0,0,0-.13c0-.13,0-.27,0-.4v0l-.07,0a.31.31,0,0,1-.11-.08,0,0,0,0,1,0,0c.05,0,.18-.11.14-.2s-.05,0-.07,0a.06.06,0,0,1,0-.07c0-.06.09-.09.12-.13s-.06-.07-.09-.08a1.34,1.34,0,0,1-.2,0s0,0,0,0l.3-.2c0-.28,0-.54-.08-.79h0s0,0,0,0l-.19.1-.1.07s-.06,0,0,0l.1-.08.27-.17c0-.21-.07-.41-.11-.6a1,1,0,0,0-.23.12l-.09.08s-.05,0,0,0l.09-.08.17-.15.06,0a4.06,4.06,0,0,0-.16-.52l-.32.13,0,0a.48.48,0,0,1,.12-.26.52.52,0,0,1,.1-.11c-.12-.2-.24-.3-.38-.3s-.51.44-.68,1.14l.21.2s0,0,0,0l-.2-.14c0,.19-.08.39-.11.61a3.29,3.29,0,0,1,.21.42.06.06,0,0,1,0,0l-.27.12c0,.31,0,.63-.05,1a1.72,1.72,0,0,1,.19.44.82.82,0,0,1,0,.35c0,.06,0,.11,0,.17s0,.12,0,.17-.06.21-.08.32a.29.29,0,0,0,.07.27.68.68,0,0,0,.2.07s.05,0,.06.05a.1.1,0,0,1,0,.09.42.42,0,0,1-.2.17l-.07,0c.16,1,.46,1.74.79,1.74s.41-.27.56-.71Z"
                  fill="#659965"
                />
                <path
                  d="M282.44,74l0,4.5,0,2.24c0,.75,0,1.51,0,2.25-.06-.74-.05-1.5-.06-2.25V78.5Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M283.91,75.64a.25.25,0,0,0-.17,0,.64.64,0,0,0-.1.13l-.16.18a.93.93,0,0,0-.16.18,1.4,1.4,0,0,0-.18.32,1.27,1.27,0,0,1-.18.37,2.72,2.72,0,0,1-.24.24h0l-.06.17a5.14,5.14,0,0,0-.22,1.06.22.22,0,0,1,0,.08,6.92,6.92,0,0,1,.14.77.36.36,0,0,0,.14.11c.37.12.94-.59,1.26-1.59S284.28,75.76,283.91,75.64Z"
                  fill="#3b6818"
                />
                <path
                  d="M284,77.66s-1.57.81-1.63,5"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.05"
                />
                <path
                  d="M283.66,76a.93.93,0,0,0-.21.42,2.2,2.2,0,0,1-.09.43.62.62,0,0,1-.15.2l-.17.15a.74.74,0,0,0-.13.21.59.59,0,0,0,0,.19,1.38,1.38,0,0,1,0,.2.65.65,0,0,1-.08.26.61.61,0,0,0-.08.27.51.51,0,0,0,0,.17.59.59,0,0,1,0,.19.58.58,0,0,1-.06.17.34.34,0,0,0,0,.14.48.48,0,0,0,.07.22v0l.06,0c.29.09.8-.64,1.12-1.64s.36-1.88.07-2a.17.17,0,0,0-.12,0A1.39,1.39,0,0,1,283.66,76Z"
                  fill="#659965"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <polygon
                points="407.34 104.71 407.34 104.72 407.34 104.72 407.34 104.71"
                fill="#ef6291"
              />
              <path
                d="M396.85,102.58h0c0,.59,2.48,1.06,5.33,1.06s5.16-.48,5.16-1.07Z"
                fill="#ef6291"
              />
              <path
                d="M399,109.16h0a0,0,0,0,0,0,0c0,.35,1.36.63,3,.63s3-.28,3-.63a0,0,0,0,0,0,0h0l2.28-4.48H396.85Z"
                fill="#a05775"
              />
              <path
                d="M396.85,102.59c0,.59,2.48,1.06,5.33,1.06s5.16-.48,5.16-1.07-2.31-1.07-5.16-1.07-5.31.48-5.33,1.07Z"
                fill="#c16f86"
              />
              <path
                d="M397.44,102.59c0,.52,2.2.94,4.73.94s4.58-.43,4.58-1-2.05-1-4.58-1S397.44,102.06,397.44,102.59Z"
                fill="#513126"
              />
              <path
                d="M399,109.32c3.64.18,3.52-4.29,3.52-4.29l4.7-.17-2.19,4.3h0a0,0,0,0,1,0,0c0,.35-1.36.63-3,.63A5.87,5.87,0,0,1,399,109.32Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M396.85,102.59v2.12h0c0,.59,2.4,1.07,5.24,1.07s5.23-.48,5.25-1.07h0v-2.13c0,.59-2.31,1.07-5.16,1.07S396.85,103.18,396.85,102.59Z"
                fill="#ce6f94"
              />
              <path
                d="M404.56,103.53h0c1.65-.18,2.78-.54,2.78-1v2.13h0c0,.5-1.78.93-4.06,1A1.81,1.81,0,0,0,404.56,103.53Z"
                fill="#602b8e"
                opacity="0.35"
              />
            </g>
            <g>
              <path
                d="M402.33,103.44a7.36,7.36,0,0,1,0-6.69c1.76-3.87,1.06-6,0-11.26,0,0,2.11,5.28,1.76,7.74s-1.06,3.52-1.76,6A7.08,7.08,0,0,0,402.33,103.44Z"
                fill="#513126"
              />
              <path
                d="M404.09,93.23c0-1.41-.35-2.11,1.76-2.82a3.8,3.8,0,0,0,2.46-2.81s-.7,2.81-1.76,2.81-2.11.71-2.11,1.41A3.63,3.63,0,0,1,404.09,93.23Z"
                fill="#513126"
              />
              <path
                d="M403.07,89.17c-.74-1.22-1.09-.87-2.5-1.57a2.5,2.5,0,0,1-1.41-2.11,2.55,2.55,0,0,0,1.76,2.81C403,89,403.07,89.17,403.07,89.17Z"
                fill="#513126"
              />
              <path
                d="M401.27,89c1.84,1.1-4.22-.36-4.22-2.47a6.29,6.29,0,0,1,1.06-3.87,5.27,5.27,0,0,1,2.11,2.11C400.92,86.19,397.75,86.89,401.27,89Z"
                fill="#4f7737"
              />
              <path
                d="M405.14,92.17c-1.84,1.11,4.22-.35,4.22-2.46a6.35,6.35,0,0,0-1.05-3.87A5.2,5.2,0,0,0,406.2,88C405.49,89.36,408.66,90.06,405.14,92.17Z"
                fill="#4f7737"
              />
              <path
                d="M405.05,92.27c-1.35.82,3.12-.26,3.12-1.81a4.67,4.67,0,0,0-.78-2.86,3.88,3.88,0,0,0-1.56,1.56C405.31,90.2,407.65,90.72,405.05,92.27Z"
                fill="#649147"
              />
              <path
                d="M401.27,86.89c-1.76-1.4-2.81-.7-2.11,0a1.56,1.56,0,0,1-.7,2.47c-1.06.35.7,0,2.11,1s.43-2.22,1.62-2.16Z"
                fill="#649147"
              />
              <path
                d="M402.33,86.19c-1.41-1.06-2.82-2.46-.7-3.52a1.94,1.94,0,0,0,1.05-2.82s.35,2.82,1.41,3.88,2.11,2.81.7,3.87S402.33,86.19,402.33,86.19Z"
                fill="#42632d"
              />
              <path
                d="M404.09,89.36c-1.41-1.76-3.11-2.11-2.61-3.87s.5-2.12,1.2-1.06,1.06,1.76,2.11,1.76,2.82-.7,1.41.35A7.4,7.4,0,0,0,404.09,89.36Z"
                fill="#4f7737"
              />
            </g>
          </g>
          <g>
            <g>
              <ellipse
                cx="423.4"
                cy="128.87"
                rx="21.36"
                ry="4.35"
                fill="#5b3570"
              />
              <path
                d="M449.78,111.75v6c0,.55-.57,1.07-1.6,1.56-3.69,1.74-13.39,3-24.78,3s-21.09-1.24-24.78-3c-1-.49-1.59-1-1.59-1.56v-6c0,1.15,2.49,2.21,6.6,3a127.67,127.67,0,0,0,39.54,0C447.28,114,449.78,112.9,449.78,111.75Z"
                fill="#9fb8ad"
              />
              <path
                d="M449.64,110.41v6c0,.55-.56,1.07-1.59,1.56-3.7,1.74-13.4,3-24.78,3s-21.09-1.25-24.78-3c-1-.49-1.6-1-1.6-1.56v-6c0,1.16,2.5,2.21,6.6,3A110.67,110.67,0,0,0,423.27,115,110.55,110.55,0,0,0,443,113.42C447.15,112.62,449.64,111.57,449.64,110.41Z"
                fill="#9fb8ad"
              />
              <path
                d="M449.64,112.21v4.22c0,.55-.56,1.07-1.59,1.56-3.7,1.74-13.4,3-24.78,3s-21.09-1.25-24.78-3a3.29,3.29,0,0,1-1.46-1.1v.88c0,.55.56,1.07,1.59,1.56,3.69,1.74,13.39,3,24.78,3s21.09-1.24,24.78-3c1-.49,1.6-1,1.6-1.56v-6A.91.91,0,0,1,449.64,112.21Z"
                fill="#434c68"
                opacity="0.56"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M449.64,110.55c0,1.15-2.49,2.2-6.6,3a109.62,109.62,0,0,1-19.77,1.54,109.74,109.74,0,0,1-19.78-1.54c-4.1-.8-6.6-1.85-6.6-3,0-2.51,11.81-4.55,26.38-4.55S449.64,108,449.64,110.55Z"
                fill="#c5d7bd"
              />
              <image
                width="80"
                height="78"
                transform="translate(402.96 79)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABOCAYAAAC3zZFGAAAACXBIWXMAAAsSAAALEgHS3X78AAAFdklEQVR4Xu2bT27bOBhHHxMnFyiCYAIM0IVX2eYCukTOk8l1mkPUB2iWk1UWXRQdBEEvELThLMjP/kRRomyScgfDBxCSberfy4+kTSnGWkvjcE5SFRrTNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZNIGZrFIVlsAYY9h3Vs24hT3yfJw51vEPkjaFOY7MRQUaY1xuah5yYZGLCSyeuBQLiawucLa4e9+r3SXr7bhL7HkBiVUFJuXdY5LCUojQCZmWehdZTeCkvClxDzK+TnAb2XNKZK00WmuLF8BgI+UvTrCR8olT7J7lky/hvtwxosdPnfchpXgCR5MXpk6SdhvU28xIYKeO8OCXOpX3jCbRUvaCiwrcS54WJ9I65rFR6yLzgVjTHp5N4aZcViBmmJ4peaG4x0j6boDHwXu7k94wTKSIHEtiQYnFBEbTl5LX+XURd+NfP40042t/BC30BrtNZCyNIxKLNeVUJzm3DDrtcMCQgeIzKz6zwrLiC2d84QzLGX9zvi12pPTruO3c9m5/br+7QWZqYKHMoFJkMiH5fU+Sp5vsI4YbXNqegGvg2X/+HN8N5365xm5TeoP1+7J0SLL7Z6NbgVAmf4Wms6aabjhgdPTlAZxjtvLWwAoTLWu/j2cM577+k9+XdAMdTuIt/e+U92rds/1tnkG2wNknIX1eTB7sxH1VFyriPvrXX5VM2faaoURB/+FiKSxAtsABsfRpeTCUp8XpxAnfIu/J+nNEYseuu5hKYYFmnC9w35OQkVbLk6Wsv2A4DcpLpJ6WCPHRO/yiXph8gWPE0idN99rXCUUAnGK4YsiV/+wl2EaWss+pFEaa8ewuaIQsgdGDz+lrJDHAtn+T1AG8YjgJyqv/7MrXhZ28dbDPBckSOCAy0vWIpe+bEgNO3uVwUy79Z7quIP2n9IVTpM5xT8oKHEOa7xg6eVreDww/1AVriacTIsIRuWI/WE+gnHQXvK+b2iqQEMqLrYfp1PsIm3FHdfIE7jsCz0WEXfii3/vNyBPYoMhv4Wq8piocn7wElm5UL375IdI5yHtSR/ip6q6D7TZ+KbPWFcgTOIWc9AaZMXHoi5SL/+WXF+qzD9heES6CbWI80p90rUhZgXczTvrJLz8Gdb/75Tt2kDJwyXv320hdQf4Qblps+hzmnOMelBWYQl+czPnJxV9it2IusLwHRZL33dfV28Kw+c7EWnvQdkKWwOjB7/1SptQ77KAZvwUCtMSppvkLO5Cn0we75rvBHTuc3i9MlsAksc5bUrgeEQFOVKwI4Tayr1TzrUD2TaWR6Xw3PsduIoWzMvLrQf+i+AfDn/T5GRxFy5O+L0yfQ2/X34c5chMeRTfjWAofcRf8RD+JIuUPv66LoF+/jcgT9LEjzTdXHhRIIIzcD06lEOhN7es0ppDUQV8eEO37HMXTB6USGLvsWAr1gAK7JIIbBN6wrH0Jkfd16sbkhVRKHxRKIIykcOzunCQR5t9UF8Kb64fcWC+UPij5W9gwPTvjkugkuiQ6Ud1WiIhzr8P5w8dgOZa6lDzKyYOCCYSRETn1VNZO5I7YMzIwfCYG+qmDpLyS6YPCAmFGUxbGntDSdNvPwvf7iYN5j7cVlgc1BE494gZE0wj7T7vHxMGizwZCBYEwIRHGH++NPdorUsPvkgc84ltDHlQSCAmJMP2c9D4kxNVotppqAmGGROjfZpwrNCVNqCwPKgsUZokUpu7bpoRpFpAHCwkElvk3L1hMnLCYQKGayIXFCYsL1GTL9I39GOKEowoMmfuk1DGFhfxWAv+LlJnO+h/TBGbSBGbSBGbSBGbSBGbSBGbSBGbSBGbSBGbSBGbSBGbSBGbyL3kEr4p3/LpmAAAAAElFTkSuQmCC"
              />
              <path
                d="M444.73,112.15c0,.93-2,1.79-5.34,2.43a102.9,102.9,0,0,1-32,0c-3.33-.64-5.34-1.5-5.34-2.43,0-2,9.55-3.68,21.33-3.68S444.73,110.12,444.73,112.15Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M437,113.35c0,.6-1.29,1.14-3.4,1.55a66,66,0,0,1-20.36,0c-2.11-.41-3.39-1-3.39-1.55,0-1.29,6.07-2.34,13.57-2.34S437,112.06,437,113.35Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.07"
              />
              <path
                d="M434.6,113.35c0,.49-1.06.94-2.8,1.28a54.54,54.54,0,0,1-16.79,0c-1.75-.34-2.81-.79-2.81-1.28,0-1.06,5-1.93,11.2-1.93S434.6,112.29,434.6,113.35Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.27"
              />
              <path
                d="M432.71,113.35c0,.41-.88.78-2.33,1.07a45.38,45.38,0,0,1-14,0c-1.45-.29-2.33-.66-2.33-1.07,0-.88,4.17-1.6,9.31-1.6S432.71,112.47,432.71,113.35Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.07"
              />
              <path
                d="M430.72,113.35c0,.32-.69.62-1.83.84a35.26,35.26,0,0,1-11,0c-1.14-.22-1.83-.52-1.83-.84,0-.69,3.28-1.26,7.32-1.26S430.72,112.66,430.72,113.35Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.27"
              />
              <path
                d="M440,117.23V120s4.81-.53,6.68-1.54v-2.67A29,29,0,0,1,440,117.23Z"
                fill="url(#be7a3fd8-2214-4e55-ae31-ce2673d970be)"
              />
              <image
                width="77"
                height="76"
                transform="translate(396.96 81)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABMCAYAAAAoVToVAAAACXBIWXMAAAsSAAALEgHS3X78AAADuklEQVR4Xu2aPW7jMBBGPy7cBLGLFOmNwF1Kn2Xvo/vkLCnTLIKF+xQp1kEaA9xCGnlI8ccak1Q2Ow8IIIuywnn4RJO0jbUWyjx+5C5Qpqg0ASpNgEoToNIEqDQBKk2AShOg0gSoNAEqTYBKE6DSBKg0ASpNgEoTsMpd0AxjTO4SfJEdU7NoPy4RFWPBji8j7RpZPgsU0FZaSVk+DQtpIy0vK9fOSXe4QUH1paWFeW1d8KJIW7zjlYuqKy0ujJ3v2OmXhOBH1tGON4QLqFhYPWlhYQJZPjPkVSqupbSAMF/WW0LevddRktfxk+41lYqrIy0qrBtezpHlk5VXXVz5FUFy4M/J+sNe7wE8s7bNUDy9h+SN9wzLMcaUFlc+acmUUYExWXt27t0Ad6xzJHDjdZjkPdpWaSsrLTr4d3BTRtJ8We+JlJJAXx5/XEdxVT8Uyj+eLgEJXFhM1tFgB+AVANbWvWZP8kwv7s1MxzkY5CbBV1A7aSb8WFLCHsKyfBx5xO/htZ+4SNoKFlpuPy05xQjBx6+jwY4JO32a8Q8AdgB2RwMc2T35+4O4/z+/lLuYctKCdIinjB63gCwAwHZ6bjdc77yf7kf3fzHp5dj1VJYWI5ASR9YWOH2Y8dhp52TTVoVa0jKPgpcyLuz0YXphYMfbvvn0acJpi5JrF1FGWnC86DCdzPJPTJ8tRlk+XNyEPdxJMRB9RAuNa2WkZYksk5yUXciYthBzlmNyGkn7XjSSNpl89rwCWN3Mmz+tbmw/bwsR+T+FKSMtOHHs4O59Af1ElC/COQdgdRsuenVrgUOwqb+fvx511qFnCk1wy0ibkukcrSPX1k3boRdE8sbjQ988poxWB3c5Cbl2EbWkZQikjYsbUzccO+2cWGrrUllah/MjSuPNxkvJ+jxGrW6sK887F0xZdO1ZjXK7HNZabx5kkZxcPgN4GI5J3DDZ9VMVXLBnU+ZeX2g8A5rscgDxNeicrSGC76slU1ZNWrmkhQmk7d724ja23xMDzntkJG8dmFZcsgk5UkxQiLJJA2amjfift7uBxJY3APz02iRfrBB+wp7o9bSgwkWWfzynHwgM+iSlxFHhJI+L+QVggymxr/CeppcCxYUBNZJG6JfFAvRnCUL0BzBC9KdWQvI7prl2TrrDDQpqI43Iy5PTsJC20oiS8hYoYBlpxDXyFuz4stI4lwj8Ip39OtL+ISpvQn5PVJoAlSZApQlQaQJUmgCVJkClCVBpAlSaAJUmQKUJUGkCVJoAlSZApQn4C5Tizveb2anHAAAAAElFTkSuQmCC"
              />
              <path
                d="M402,112.15a78.18,78.18,0,0,1,7.76,1.2A74.93,74.93,0,0,1,402,112.15Z"
                fill="#1ef9aa"
              />
              <path
                d="M405.92,110a32.68,32.68,0,0,1,4.36,2.71A32.05,32.05,0,0,1,405.92,110Z"
                fill="#1ef9aa"
              />
              <path
                d="M410.28,109.25a17,17,0,0,1,2.51,2.64A15.7,15.7,0,0,1,410.28,109.25Z"
                fill="#1ef9aa"
              />
              <path
                d="M414.15,108.84a9.05,9.05,0,0,1,.93,2.58A9.28,9.28,0,0,1,414.15,108.84Z"
                fill="#1ef9aa"
              />
              <path
                d="M417.19,108.63a8.56,8.56,0,0,1,.45,2.6A8.82,8.82,0,0,1,417.19,108.63Z"
                fill="#1ef9aa"
              />
              <path
                d="M419.87,108.52a8.52,8.52,0,0,1,0,2.57A7.92,7.92,0,0,1,419.87,108.52Z"
                fill="#1ef9aa"
              />
              <path
                d="M422.19,108.52a8.06,8.06,0,0,1,0,2.5A7.49,7.49,0,0,1,422.19,108.52Z"
                fill="#1ef9aa"
              />
              <path
                d="M424.86,108.52a8.08,8.08,0,0,1-.24,2.5A7.54,7.54,0,0,1,424.86,108.52Z"
                fill="#1ef9aa"
              />
              <path
                d="M426.94,108.52a8.57,8.57,0,0,1-.56,2.55A8.27,8.27,0,0,1,426.94,108.52Z"
                fill="#1ef9aa"
              />
              <path
                d="M429.61,108.63a8.34,8.34,0,0,1-1,2.45A8.74,8.74,0,0,1,429.61,108.63Z"
                fill="#1ef9aa"
              />
              <path
                d="M431.77,108.77a10,10,0,0,1-1.45,2.44A10,10,0,0,1,431.77,108.77Z"
                fill="#1ef9aa"
              />
              <path
                d="M434.5,109a11.72,11.72,0,0,1-1.91,2.41A11.72,11.72,0,0,1,434.5,109Z"
                fill="#1ef9aa"
              />
              <path
                d="M437,109.31a18.21,18.21,0,0,1-3,2.58A19.23,19.23,0,0,1,437,109.31Z"
                fill="#1ef9aa"
              />
              <path
                d="M439.68,109.77a27,27,0,0,1-3.91,2.62A27,27,0,0,1,439.68,109.77Z"
                fill="#1ef9aa"
              />
              <path
                d="M442.68,110.57a48,48,0,0,1-5.67,2.78A51.3,51.3,0,0,1,442.68,110.57Z"
                fill="#1ef9aa"
              />
              <path
                d="M443.56,113.35a65.58,65.58,0,0,1-7.27.74A68.33,68.33,0,0,1,443.56,113.35Z"
                fill="#1ef9aa"
              />
              <path
                d="M436.29,115.08a2.26,2.26,0,0,1-1.24-.52A2.29,2.29,0,0,1,436.29,115.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M405.28,114.09a32.1,32.1,0,0,1,5,0A29.81,29.81,0,0,1,405.28,114.09Z"
                fill="#1ef9aa"
              />
              <path
                d="M410.89,115.13a2.38,2.38,0,0,1,1.31-.45A2.38,2.38,0,0,1,410.89,115.13Z"
                fill="#1ef9aa"
              />
              <path
                d="M448.21,119.47l-1.68,1.62L440.47,127c0,1.63-7.66,2.91-17.1,2.85s-17.07-1.41-17.06-3l-5.61-5.54-2.05-2c3.68,1.76,13.38,3.06,24.76,3.12S444.51,121.19,448.21,119.47Z"
                fill="#434c68"
              />
              <path
                d="M433.2,118v2.74a24.37,24.37,0,0,0,4.61-.34v-2.74A27.54,27.54,0,0,1,433.2,118Z"
                fill="url(#e0c16df3-84af-402e-aca3-c0c928f5ee25)"
              />
              <path
                d="M440.47,127l.29-.28c-16.67,2-28,1-34.73-.17l.28.26c0,1.63,7.63,3,17.06,3S440.46,128.58,440.47,127Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <ellipse
                cx="423.21"
                cy="111.19"
                rx="25.03"
                ry="5.07"
                opacity="0.44"
                fill="url(#a4daf704-16ad-4c5a-81b0-448da1187e00)"
              />
            </g>
            <path
              d="M450,79.77C450,85,432.14,115,425,115s-26-28.5-26-33.77,18.82,1.47,26,1.47S450,74.5,450,79.77Z"
              opacity="0.44"
              fill="url(#bea08fcd-8361-4aa8-9d71-a5a7267a49cf)"
              style={{ mixBlendMode: 'color-dodge' }}
            />
            <g>
              <g>
                <path
                  d="M423.24,47.38A11.73,11.73,0,1,0,435,59.1,11.72,11.72,0,0,0,423.24,47.38Zm0,19.37a7.65,7.65,0,1,1,7.65-7.65A7.64,7.64,0,0,1,423.24,66.75Z"
                  fill="#d8fff2"
                />
                <rect
                  x="416.95"
                  y="45.34"
                  width="12.91"
                  height="3.74"
                  fill="#d8fff2"
                />
                <rect
                  x="427.49"
                  y="53.15"
                  width="12.91"
                  height="3.74"
                  transform="translate(316.43 -366.32) rotate(67.19)"
                  fill="#d8fff2"
                />
                <rect
                  x="423.41"
                  y="66.07"
                  width="12.91"
                  height="3.74"
                  transform="translate(807.09 -149.1) rotate(141.11)"
                  fill="#d8fff2"
                />
                <rect
                  x="410.16"
                  y="66.07"
                  width="12.91"
                  height="3.74"
                  transform="translate(706.59 374.69) rotate(-142.65)"
                  fill="#d8fff2"
                />
                <rect
                  x="406.08"
                  y="53.15"
                  width="12.91"
                  height="3.74"
                  transform="translate(203.26 414.77) rotate(-67.41)"
                  fill="#d8fff2"
                />
              </g>
              <ellipse
                cx="423.64"
                cy="61.12"
                rx="39.45"
                ry="20.38"
                fill="none"
                stroke="#9ce967"
                strokeMiterlimit="10"
                strokeWidth="5.26"
              />
              <image
                width="158"
                height="119"
                transform="translate(342.96)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAAB3CAYAAADyzvkxAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4Xu293XIbV5K1vVbmriqAFCXRttpyhyLG0eHoAyrmyBdg3YTndiTdxnsLvgn5Anw0IR44HPO641O05JZtSqJAoKp25voOCuCPLLl7Zl6TcjdWBFkASAJVwMPcf5lrUxK22uqyZX/vF7ba6rfQFrytrkRb8La6Em3B2+pKtAVvqyvRFrytrkRb8La6Em3B2+pKtAVvqyvRFrytrkRb8La6Em3B2+pKtAVvqyvRFrytrkRb8La6Em3B2+pKtAVvqyvRFrytrkRb8La6Em3B2+pKtAVvqyvRFrytrkRb8La6EpW/9wv/zCJJvKOs+P9VtTF/5Qf6Fy5q5r/KtZ+H7JdXLDx8+JC4/4sf/L/VQ+D+/ft6E0eeu/GvAuM/LXjvAu3hwwcXADv46jHx5YU/xeGj5xML9+6dPvYF/jF9ff7Oo0cAgIN7ty6+yV8Bh1/ePXvsIXD//oPT+/8KIP5Tgfc22M6Ddh6yw0fP+cW9e/j2m78Sn0+PPT084gEAHADAXTz77qd3tpT/iG5/9qGAx8AhcAjgk4P96bS+Af78+R/19aNHZ1Ceh/EciP+sEP5TgEeQwAY24SEeEgAef/WYX365jmD37uGTNWRPD494cAA8++4298oxAeCoLAjcwa4vzmD7BJj/sPwfwbf8eC48Pbu/iF0BT7B/Z1f4Hjiue7r92TMdHq6B/AZ4+vkfhTWMX30F3F2DeB9T87w5EeH3/6H9bsG7CBvwEA8InEW104iGv3L/8IjP2gmyo7LgnTt3cPR0wbkteWx7nHFFAFjYLrsXPbE/PWf7ciBuApi+/ff04gWGG+10ekfA7s1OfS4EACvNtJfHWuZc+5/s6smTJ9ivuzque7o9PNPRwb7+jHMR8Vw0vI9zkfB3HAV/d+CdB+5CM4rHPHz0nJ/s/Zn4HNjHEZ/hNvdwzOFpa69syZ01ZJ3tcsGecezW2sAVR+5d38MKI5vFyJ4dAaCw/kq0233j/uIXv9GpaAGgU69xtxFeA2OuNFOjIVv5XuSuJiBXmukkj3U952o/GfIYe7qNZzrCRQgP8c8RBX834L0NuE10u4W7/BZ/5Qa2+uSZ7fo+57bk+KKx7tYux1fHttyfM18vrLk+Y56YFVammRVUDmxZWOmrliMrMQN8FdPnOp9hXN+evfsUsQLQzFxYTvfamWu5ApquKDCoVVHVoIoiy8yqItvJHF81smuZ86Olmut72edCTYy5zLkWcaRy53aeh/A5Hp9FwXV/8PcWAd978DYDhgvAnYtuT+dH/GDdjA5da3NbcvTG6qti7Qc7DDu2WLilmc3MLLmyNLPszZJr+GjmDDoKRyYdhXUMti1Qh5zga0+//X0NA0prGgagNK5AVSNTwBWqsi6zLotMmdZlWmaaZrnK6bbvRnru5fDzicr1mk2MOfv4o1x8f6Tjuqefh2f6ZLmvp8ff6uD5Lf0eAXyvwSPICTgQ9x9cAG5/fsRnB2fRrZZiN9xttGMLc7OT9LAJOOvT08zM0pNmIq2hWXI0jTSRZkwanLE+GpMxJtEAQAMb8x8aZHhjGgFgBLwJjSPgxZQIUSVTITZKqkmT0pQ5rI+ZFpaZ2U3HZUbu7Fh4Rh7nXnpEllpzEUcqq9v5NgDP9wHf5+b3vQTvQpTDAx589ZiHt94ErthHzY82emPVi10zt9cn4eZryPp0mnxwuQ2NNzOzsaaT8sIJNpFWWE11uh2YoCOTWZMoDViT/6P1nQqomAyhWoHGSwqh1AQgpaxQFmdUKRsxVCzGVWa2Y7TBUDKys5iHxTIzr+14vM7IEjV/jjF9XOUGwC8O7uZzPD7XB3y/o997B95ZlDtrVm/hLr8+fGwftLdZZ8/so2Zmozdmr9Pjgym60edulr6ydBvSY/RCl5NyWpmOlNeYjk6aMAGHqEY4RViGWBwIGC30C+gYvx75AoC5TW9qBdIpRyoxHeGe45gilO6MkLKIIWdI66+s0zEY3kTNtMjWYpYWimVktYhdjzcB7D7r8ym+1QGmQcjpAOQ9hO+9Au8Uujej3OdHXHy/a0PXWmmqVy/mHm624+OqL2bpdShlbulhXqLWQiueEYWtPMMKKecb0EXK6UYlzSASyYSRnIJFQnQAgJ+eY4Z47u7bFYA5tb4JQ0qiDCnBBFdSyhCyeImoY0oMdwbEMM86DAxzr8oaXkqtOQFYotbStvU8gLWWKLVm2w+5++kij77Z1/7nR3mIi32/96npfW/AuwAdHvMQz/kJ/sz+u85uz4o973ovx9W9DbeSPpam1GEsrXsJ8+I1SpoVNysZUdysgOegoxyUR8IdmJpa0AxJJS0hkkYYwDwX1c5BphB/8eAbOv+TWB8JCggIJilV3LLWFBzpViJC6RYBnUU986zpXjXUsPSKOUbPrJGlemStba0lJgBX81m9HiVy7OLH8S9n0e/Rxb7f+wTfewHem9Ddwl0+P3xsi52zKGclfVi2pZahtEMpxUuBq6nmBaHGLQoCTdKKWZQMK5lZSHMSDsoFmhNTE5th5saaaQ5HQmTk349m75RDKcLenmuWWAMYAbmJUgoUgKQpsyptHfEkhJmqxEhlNfMKx2jKysBYMytLO46RdafBOESt7djVHBexu7tTj2rN/pMufj58Jhw8z7Om9/2B78rBeyt0eGyL73fN5+HW3PTVyUkZm6a0PhSNbFDQqLKBo4E1DQINEo01UTJZjFaUWUA5MUW5dSwzkUYkda5JZdgZcLE5xGlzef7xt+ocrOefKzcR0qdfCeCsGQ5ASMEsBYlSAsqUp1uEMEFIy5qyaqkKx8jECMfIwDisbyMwosHY1LGu5rPajX39Ocb8aOmxe7LIW+cGHu8LfFcK3pvQHX2zb/ufH/HJE/hHzb/ZcvGqjN2qdE1bMKJBQWPRtHI15tmCaCK9RaoR0ZhlUXANnbsVGJCmpAEwUiSMm37aKQzARSA8pykJTeCdRqtfoU8wGjBFPZ+gc/f1EchMwt4IpxkwM8UaQjdLApmmRFjCMiQGhKBUaRhhGCGMNTG62VA8hmGJsdn1wQIjK8ZhPtZZ3ak5voj42GMXi7yF9wu+KwPvXZHuyRN4193yUqrPSlNypUaOZqy1tSitebTm3kZkS8s20loIjTGLyALAmeZgdcKIdf/t9MNfa/OBm1NCriMQRZsGAAYqELA1fNP9t8vX3zYRjjSeNd0OQtQ56H8NRGl6bZgygVw3yWFkpavmOAGYZgMHjGzVZ04AKnxY1tWIQaOaHJudWZ0Py/rjuMo7dxDvE3xXAh5JSr8OHVZoMKDBdTReS5sxdubeKtlJtaNZy1QLQ2NkSbIoVQwwkEaIuV5mO9W5D/Z8M2egpBSgFEym6edyagIvkLBffaNs3T/MtAksrEGDSJKItFMgQRJ645+ChE0RkzbBLkgKiqY0MKQImVXkFPXccsiwwUz96dHrENWHtpTBZhxXdazzYVnjY4/dw0UeHjzPg6/ODTiuaKrlfzI1+r+Xpnm6g4PHPPzyOQ/WA4mP5mHLDXQNGke0XksbmR1L6SxrJ7GTrKOyhXkjoQmoEOmYRqokpjBFCAJ1BhdFywQ8TcygUpFKWMKYComGBEOASTlNg8hNU1NsAupbLqggOa3YE2JN0WAEgoARTE59S5CUKWFwEkoDaSkSlkYYzcAEyBRpUwsv0jLkZhYUPU2umiVlnk6X0cRwM7KYsYL0UrH8GZx90GAJYP7DEoud3Sk38NbzBKCHDx8QenDp0AFXAN5pE3t/Sl36BH/mYmcwn4cvF/Myq01Z1XGCrpQ2CjuuNAPRpWwmoKOrjfTWnIWZRYQzaYAINygSAuWGFDIpSwApMo0WCSUCCSCMlpCSqQz3BJRTEIAIiaAUUwQiq1AvolcKMD3ip+ARIgDGNHfLhJlRTMicdjqqdk5ziSLMRZPDosIFWHEwEjZFRpEEJp7lENyMDpOZ5JRbulsGOIyyYmRUYH5diJU0G1aw+U39gBf4N+xiuLevfTzm4f270ulncrlR7wqaWvL8YKK/0Vm323vfLcpOmZW+79pSa6vCrhR2DM0gzUKaWbKTsQPRTP06llxPAnMzgjSlMgUrAdWEGDIGgDAxoAitpy1YlTIGpQxMk7r0koQyZXKEUiZvTOM4ApjWXd+8oqhT37FpGsSY0zovkkanKo1NUqApaCBsM4E9zSvK3WnIaa4xAGdOc47g+nEzItMAhzyloMwYKVUQIypGUn2aepGrUrmScVVNPav6Woah63w4+duqdru7tV900b3sczPJPK3vXi4IlxrxNtEOAA7xnAefg0+ewHZf7Xncvu5ajc28oskmWmQzRbqyhs7YCexobJFoRBVlusGIEOSUImVggB7ICJrXiAhi6pirIsxRURFyhNyCo1Ju4VLWRklFukyljQyYMADjOKq0a+AGnB42uSqlnWbuxmGk0ZkwFIAVRjXVDM5pwrpaAU2FhpBHyEn3zHQSLsoRLKQK6L4enScATxjck4CRDipy/f8Gg8EyRQgkhFoAVWDWpCpSzUiVbHJoW+0X5pPZM90eoEM8n8YXuPyod2kR780BxRH2rf1+cJ+Hx9Ibzdh407UR7JA5Q9Es0+aQZnDNctSMZi2IhsoC0AgjME1FmE0TrwGGE2NK1TTNgcEwmqmavI5ar4Mmo4ihUoMqWbWOeM0U7WZS9gAauEKjAKB0RVi95eJmQO2npFFnQwAwBCsLcxjNu8IcR/POOY5nSQqbZTxwvbzXyM1Y6jCN0pNWNpFdzIKUw7mZHoKJkiEQGSocLHMIobdiSwRXZrlE5Qpmq97Vd2M/jF0zzIdljaXH8Gkb+7iaqHd5EW99SfcBPMJdAo951O1b3yzc6nVvylg4ohkVbVvUZlonoYOhQ64jHdFQLHAaY4IuoTSzCKlSWZ0+ImM0w0hghFgJjAzV6mN1eRUYai2GfpUtGQZmJ+QwU5Zlo9CgpYra2aAREBaGdqcII04ni08A7GyubQSKtRhOKnM3UJaVMd9Bw8phLtY+zNExxt5AMyMsSWOVj4STo7MpbhElkgVAk7QGiQZEZKoBmaSKxEKtBxwUjfRc/1fnNDJRjJKRUjLDM1WVSMuxNOkeMXqTe5/eyF084VVFvUuLeBf6dutod7K7U3aatni/amtjHSNmVTFP2dxkcyHmMJ+ZohOtpfIUOnkKsgQywGl6AcIocthMNSAx0jFGeo3MaplVyVDDyLToWgtX5kqZVYP2cpZVvUY1ml1rNGolvALme61eAsDLX7m8G8ANAMvjgbgOrI5nbGxkwymVvrCysGVyNSWhmllLs8Gm9C2y8ax1WmMONDA0SjTF1ISpZVqbUguuI2BmEWluQCQAIYwYZRwy0SNjRfiSDU685rIfuWrNV71nP+tWg/cxvhn1HuCBLgu8S4l4v+jbAcSnd3j889/M/KaPPpR0Kz54g9I0No6tOdqUtUY0AhoQDjsHXVhy6rqPUTGKORR6r8hBZgOJYSRGEKOTFUStLJHsY2aMFTP7cXaa8Rsv5vopl9rJVv3NhUrfiT8Bqw9m6gdg79aOsPrh3Re5+hgv7IToOtzqAXZTdVpr1ziyZ2Fly4ZHr+fW2Mg0M5hZYTEO6bR0GjzIIg4NKhpa0yTVKjJgDAhJKqf5aAOQJXKas6SbSShIiJJAS2MGErVmBopHcKjmVheL9HnXxF65kbuHT3j4t+fEvYm4KXj+9vBdCniThIOv/oNHf/ozn33e8eYPP9pe19jJSXjXzFyvx0YNGstssy1N1GhpbCA0pDsynT41r9AEXQqjjTnIvCetT6oXcyCtj5qjh0aqG8cmatIiuYo5GCd9TYvdtL3IXgt5fyP3umP5uiSxnvxBdudIeA3sLE7w8ad7+g498PFN4Lt3XN5nPT6D44fvj7kAYJ8CR08WvIMbWHhPt+ALI+fd8rTYaGm03deyuOGGJXxp8GYYSrjX0vooV8NANXqQGSIzUiomVUs4HVhHPmQaZUiTzJgpNSKqwlqYVyfGQhQNXrLsxKvXK2/mP+aL9nZ+ce8unk/1K8JvjtykSwFPAB7iIQ/WxdR7OObojclo5ukx1lLcS5iVIhSGmspp4V+WheAZdKYEFDSOljmo4QoZvZGrCPUZPnSz7Af5iDnGEn210QKB0M48xoycB3MlCitkjT9orx7pxac3he+A28MzPcURdrEv/DSd7/zTD/Xvm4v57M2ru6jhp346z0+B3TstDg+fnNbwfvYZ8AOS7ZPChfdUodVuyToWi9bNT9LlrDlYkQ8FQoR1YYhIeiAkB5AOWaxXOkRqilOkiwy5TAXJBFFFVBIN6thUtGOx9JmZNcXt2Ha4V475LXruf7meUD7naPBb6lLA2+jw0XMe3AOPnu7bbtdxwd5mNBstnEWOYWwqSiOgMWMR4Eg5YDbN/SsVTDOrAY1u3jOjJ7lC5UqG3rrsMfowazAOY61lPq8ZizjOMX24kajIl3GsVzX1Qd3Tq+GJdg/29e/4UF9/9gg/P9pYThwB/zWd99ef//Ef/jDuf/5HfPXV41N3gv2DTUH5XcwBDOj5l1dPNgVKeVQW3PV9qtB2uy5eva7uTYScFQMCZQh4k4pRU9e/gCmgOCGRlkY6JTJT6xUSOig3soBZCJRqVoBaBsKzh5u7xUu33dk+dw+fEAcA7uOyAt7lgod79/Dsu5/Y771g+2qwnM9slemlaT2qptw5ZBFQptS5dGgavQGAgoJhmjjV1K9Lll5Rexn61riKMYah4dCMYx2HWV2WF3FztLj98R/WVVo/6NVwTZ8sWz39/D91gAmyr/FHAfeAe5PdxEU/k6/edUVv1ZdfTp/fad3vven+1wAOcMT9A+AQH7L7puer+YKl7bhXjnPRtaZ5yV3vgl69z5LyRQ5VajORxUAnOC20WIpOmZNpFAyEr1c6jAbPVBGsiCgN3StHB+GdmYEN8WHPo1XP/YO7OHz0iJvzvAz95uBtBhbTNAqw/Az48YeP8doWlNGgaWrBxnQVOCCn4Eg4OY33kEnKMk1pYoBRkzbWwNgwhrDSw2ofYwzR+IAR48tetd1l7frdjH5I4EkOP+3r58+XOsA14asjPP38nn4JGUBMJ/xgfee/09km14kJAjbN1vk/fvjwAdZF6Nr/ryPufwkc4j/Z4c/cx1Euvt+1xZT8Kpst9XpF7I4DrGlRI0mGUeYQCoBCqUh0Gl2SESQdTMlEOQHnBKSzyktrFuxNRmt5jW4/8dl3P/GLe/dODYcuY1rlN59O2YD31Vdf2tGf9q39cJpG6fq+jZl3kT4vpc5t8F0id1WwA2EHshmploTnlNkbEEbQemSuCJyAOCFxEixL1GFlnn0dy3DSD7Xd3al9/zzeVgQDvGEFsdZv/mafy5bR+vvG52VK97/LT/DXC+n+O81J0epscr1mnbtsrmkacYfOuZRzmq1XdGCCBCGc6EGsCJzU4IkQi9LaIsZYFmuXbav+xcBxZ3FSh5/a2P+vo/zyy69ymtj7bd+L3zziTRLw5X+c3pv9uOKSlfP1YrpGmjXJrFPCphJmFJWiuGYjAJEyICWGptSPGISwcYwyb2vUIWL0uN5b7JUunq1uZ/eyz30c5VNM0W2Th/YA+G9Hs/+tzn+Y5CaXYHrwIR7g8VePgVvP8cm9P+ez74DOK5MWqrSlr6ILD2/aaqpVQg1Y0BgmRiKF04lgEABjvT5cCsxKUnTmCHM2HFgZx8FbXfeG+YZw8d/xt9GlWNE+fPjwF1eyhz0AO+gAGJNBZzLJMBJ5mji5OUUap0wRpBIpuk6XuUyZrkzPSN+LbG6OuahH6j7r8+nxt9p00S7UmkK6TOje1PTi0oaS+3igu1/e1cHzW3qKb/Xz8ExtP+RKM/m1SMtZ9sqcyjNKhkpSSEVK65SvN1+DKZJihqiYCpsCyRHBgsoVRx7/vDr7bN7wCfwtdSngvUvDqrJy8iSxdYbHJp0310tib5M5hTplijhM0bpOAIxqhCPgBwDHn+4JmEaok8XDg9O/v0rg3tSb53L45V3h0ZmX3l4eCy8m45925gq4gBHACAO1Sde/KJvex02C8/q4yaK5oA/Xx89/8ZPfVJcC3mS/elHHOEY7Kwq5ikwpk7kJUQEEbF33MMmg1JQSGUaDMWlUrSZWcxYWVjYc2drAj/Ex9r4/5v7hEaeVksfE/QcANg0J3wn1Zev8qg4w9fW+uHcP+zjiUVnw2Pa4tDkLOzpaOmJtseFMaPqi+IsPMnBWIhKACuUw+SbLZgnM9prTuUp88+YT/La6pD7eWt8A+BDY251Je73w8gRN1ylayYdQVBNgEiCGoJJCrpva00zetAxzEO5oLWvvbOXo5Sxzjw/6OP7bU+92d/Xxp3v6BPs8xLc4wGM8xAPgIaD7D3QK3yX384BN/266ve7fnQ4wzpd2fjQPM3cLT1v66O0ARyOvA7wATocrMU2uVxi5gTin5zZOnRFCrlQWE4YRDVuNc8hfBVYfzLSzOJlO5itcWnN7KREP4IWpsOcA5mpVsyg0KvsQi3KaRFFyGl7kWZXX9F8t0IBiIFyZpebYpFlRqCnupfpQxmVTyq3rXprq/9/T3tvvBz/ALTv6Zt/w6JEd3H/Mh3jAB3hAYerZTzUQ09fbz/9/r/OvIQGC8AAPThMn8OiRHX2zb88xQefz8Bfr0s6h6UtjpYRbGSoap00pU/RpmiThYlhOWc7TiAWUA8n1+0ls+sMl2SpbFQ17k3Hkx+tuyeZML0OXNp3yEA/4BWD/iZ/85g8vSnQfNnV43bHtZlr2O2iaHSp3M3IXwo67zyR0RhUBJlCkagZGA1eilsZcZvUlGpyo2sp91bu3/UnF2Ixjne1MJX6z8aN8dqfm7cNnOlru6+nn09TKu3yHp/O+cBEA/n5kvDCHt9b5P3ibH/MhnvOTbyabjmu4zdco9vz52jXho3CtpjrirNY1hV30Mbdi8xTnJpsncm5EpylzxQkygQQxMtUruSJwohILpy1G4sSHWMq5Km3tvY/xxfHN+u+ffRhfA3lZBUC/eVM7TSFMH8jXeIQPvvt3LHfngk6UKupSWRsGVIPyoFklFCmlGVNJBQWHmIIDyDA0HhlRLKzNMPMYMSqqASBKM1Iko0mmuR37y7j5w5i4fifbnSMd4FYeYV/4EwA8miC8D/zHV19y4zv8ADiD8QzHXw0H5z+qDWQP1/cff/WYX95/DAA4xF0e/WmfTw+P+EH772w/PCZwhz/+8KO9OE7f++iWDfNavO+KylTa2SS7DHZyThV2yjZrtmYspDxBM4ACZQqJTEAJYxitVk01ui0RJ8qcJ3JQKyR0+7MP9fWjR9i43P/W0AGXEPEmneXi4RCO63f82U5tur5vM6ybtznrhZ0G2AnkrlB2zHIO2YxSK7JMlWMUlAGbJpJP886KLxFcMdRvSvza4sP4utahbWvUk9jdtTj+cUy/cePUY27jO/zz8EyfbHyHAWwMsE9P/yvgyy/v6iF+XfeBaZ32XD9pY/z9BYBv8dc1bGd+zBtvv/CXtmeN2WLXh6YvZjPXqKZGba1kK7Erzi4Vc8hnMMzc0KlONShyGKcBmEAbJQ0gVgwtAzhx2ALEic14otFXpVdfu+XwcnWjvnr1JA4OEJeZifybRzxgaqkerG8fHeyr/f5IHjvpEdl2JRQIa6yGVCEfizRWWVMm/5CpiGG9DimaM6c+cyGURmUNOMgoMoWM2di4pLOrY1dsbHxW1Vvc+Hg3FkeZ2EPeiL080Uxd7fNgdkeL74+0/PQnffAdcPverTM3dgD4E/B/vvkrvvg7yQL/55u/En/aP73/9PCIB/du4dl3P3H5GdBi4MH1OzzyBU/Kjt2gsTqMJutOdr16unVLz7EURxQ0aDpbZ2M7uxQ6yKf6E0ObyhZUAc1U02gUZYmMRPGKzErDWIixMiuICjXR63Xy2jw1zLRfj7R7sC/gCHgI8P7F7sFvpUuJeOeXzW59eZf/+d1PfnPvRflp6c1sPmu7sI5NzKpsDmHHi3ZqxY5Zzk3skmyhbLSpEwQyNC2hkTmQ3meqJ9HT1CtsSI8BgREFY8moY5SaYZHdKubB8NjJxbVp0vm8AfapG3vs6sm57QEArPPy1trc+Ozs8MP309YF+HSTi3cHR37RXf7U+Nvcds0saMZlTL5+lt6MXtxq6Q2NhbeR2Zp566pdbqrshI5SS2eRpj6wYXpfUllFO412LDhh4IQtTqKWpXxY+RD92DUDVhj7RRcX+nf47ZfLgEuKeBtNk6OPePCHW8J4J69fexnL3qPpxrqKrCFULzZG1tFpg4SSSkfSsa52zqmywJzTNNVUAShKaV7clHIBBULxYgMSpSZqUa21LRUxC6RF7RjzgblKy0X2OeZc+9cyB7kgaFDVjdxT/jhN/zwH8H+fB27mjoAfgL31Rf0AAB/j/9oJsbuDWwCOf1zxxmwPg1WCYNB5k+LR67lV65lmNjdaJY0Wjkhv+rFw1nottdSYyjchtBBaSW3KWhpbKDsYGuIMOmAaxYIKwqo2ZQDGIUaNaDDaKmthVqCtsdNHGeqUHjZAXz/6z9P+HSbyfnNdCniCRJAPMK0kHGFqbpv4KG33x3jdz6KLUksTIzxcg5VwcxM9kUbIptpSMMlpyiDhU6U9MSVBkqk0OR2pUoBSazawaZpfYIVQS1NrXVeZtWlhmgyv590yh2GWVUUp06DXqmo0ZiPtrdSd1l4sgJfXLl7gjQVuYqq3eHUdWB3P2dhI8jWTHSsLQXLeLS17MwCGDlaHOk2HNI0Xegmp2OCNmRVITSBbczZUtilrnWho1qzrLVyQAQBtqj2RUCWORg6iemMOTB/gGKAYq9fqwzwiPOaxzHLndn7yTa/9e9Dhppm9jCYQl9TUAhenVQDYAR4bcMePf3xZln1tm27WttW6QTlrS5mNGndMNodrpsq5jJ2vs5Jjsh/j9LxnrkpU1qn5XRf/GEZqKvahTf5y4V6lGkrGxnf4vAE2sw7FVwoAAA5FSURBVMvAKOsyp+0BirA8QZ0XYYGp2uwtGk4qsQuUZSXmOyisHFiZvZmjoay3pFlLWtKMNX2knCb3aiVtMpY0WkFqU2E2FfbYOhubKpYsUwZKXoCOsqrMgZymUMRclqY5yZpLVFuJw6ovXd/1/cCZxperG/XOqydx+LfniXv3LrWZBS4p4gEXp1UO8Pgs6s0j6868Nv1o1nTWhJs8jL0cTlomkzRQgDg1LEmQNCGnryQJTNUGJoPMEyqq2bhhBFQJ1UBWipWjh3VZJUQdI4tPhTTeeETfq6hJC+YIU2hQ03VqEojZqJrDVF97TrWvtBng2RCdY8yBYmGBM2WW7M0bZ47yBKzW8NLQLLJQxVXksFJKZEloqqW107raAmWRWMxo4mRrMSVMSIg1dJtaE01lAM52NfR1sLYM0DCYz8cyDjUGD9xBFNQ8+mZfB/egQ2xa2MuBDrjEiAe8GfUe2cHhLXtyHX6nu+U/tmquuZr6yrps+g7ZzOiTfUWKcwozGTqm1tVnWcynNY5M0YyiIRNTsqiEABhJVROrkGFmtdYImlWI4R4hnRlgT9kuJVmUOYTYlCwKBUyliWnfijccBTZ2AnXIaV+M0elIVjo1VrN2srEQqxXS6tqDmXQPyjOykHLLyTpXyQKHm1gA+Tof0dcp7dxMK21y7ihVKxy0LuYuxGoMrqzxpWpdybiyMuUpzrrZcDIOdefWSf3L4SJxRdEOuMSIB7wZ9W7paLmv0nZ55D3ry0UMf5ixb8JKbdkWcQixOGEQCFdNyZgitCkxKBScRoup32c21QEaJZchTHAYCmCRyqBZuBBwRFRLGaOAEZNZTxKZrMrSIIXJAiIBYXA1jWkcxosXtQawaRrUIRlMCkkDyQZUTQNogFsAVkCrkjMm2wonPCs8SSfgMLgJlpQbYEqaEaeWa5NnXibWbqEAxkgOTPbWcDUO6gu4UqinN705hqjD2IxjTR/i1q0bAfwhvzhAPn/8+Kxvd4nQAZcc8YCLUe98cfeP8/Dri3mZdU3JVk3UvvNS2iE1K84O0kzJToZOYsdzxc2ZcgNNTNssPwtT7vepwSGU0HTbhEgh3RABTxeDUIaU9MkMMUFRSAMlT9UK2Nojz8vF3LeoWkORLAVgTD54IswwFeAozsx6gnJHWCTcCizT3QADc20IDkNOtSbnHXK5tqslrUqqWLuDkuozvSfRy6aJ9Dqqp6tvSxkWw+sx5zfGru9r/0kX3TcXDXsuO9oBlxzxgHMj3IfA4f27wqNHwh9u5b9hF767xLIFZqXB0DsxVrSlIIKSm5w1RaaApCwyM5JqyFyb3NANOC0OSooQ3MQpHdw8HUhlFjMl4GvI1gvoppx8aCVUTJUf0zS+HGcfzi+TLqfXc4ACwKnLRFSYyjTopoUlJ98TCga6mYVBNCcowAgykwZfn/vmtUw5mYgiaV4nlyiOzDV04YOZepr6WtXTs6evzRmH12PTz+q8vIjoPQHk0+Nv9RT3rgw64NKyU94QzxbkD57fEg6e5+7JIuNjj/mwrKs61lnXDF66fqjqYePKLZdJX2bkEsBJMpeElqSWIFfTBHIOIYxUVkopbRw9AcKYGb6eiphGj0RDqSXZythJ7FJTvxKOWSrnqZyrck7TzJRz2Nnjmy8YZqac06YR+OnjjnUfVbPJUJIdyZa2idZWlBvPZhqS5gAi1tFN5yrqxEHOFRArQy4t1+9D5JINToK5DJaljCvzrm/LMNjwelz1szrfnUx6/nKyyKePvtXj57eEh5c/oDivS29qN3qzyT1vR/tRM7NlOy+zk6a8bhfNfNxpUNTQo+1X7Myn2XxmtjA0sR5sINGgmJ+3pFWGCXZa4HD6+kZlAgQl06k9LTUdJxNu02ZzlM3fGX7pheyYUrdOn5uaNmpZ29MSdprKn9BkvwPRDJNZ97lz2gwcpq6BJZQxeSCvna80mW4j6yizIc2GEjGk+5AxDqiTAzxnGuNHjw10uyfvjw0tcIXgAe+Gb4Fd8x/WWw2Uk9JaU9SjSUczLqLF/Gw5qRiazGyVpbEmi5FFwZJScYdFwgEYOdUdkG83vQYA2cZyloqIUxd4GpXAJr8StItN7Sk86x7m25zf4TjbuOX866+d37UGH5qc32UIrDNKTFlhZUxlRXJ0i2Hj+s7EmO4Daj+y0ThEW5txrCc7q3pztHgndLi6aAdcMXjAO+DbbK7yaWvlx+p905XZclXG0kzbDjiajaNSs74tm45pLEg0JDzJwpSb06Ypicln+HRagpqcRP0NEAEgAgFc3OsCePeOA79geT0weMdzy7mOrusIJyXcMus06BEyTFbTVFNZi5URyZGOETmO43odmqFxiKg7zXwcaq3tfKhZLepYou2H/MvJIvGeQQe8B+ABv4TvEM+Jw1v2wcFtdk973y/Fjkr12UlThqYv1Utp3AvGVaPKppiVIdF4O1l8ZUYxrnf2KeZMvHVnn00TTNpp5u7/bnefd2jdbANTUy1NlWFEiuY5jaiR7oisyGmeMSJllak6Wa3ltLtPemVwZME4RtRSp9SvZhxrDB51r8Stvotnq/pebyt16aPat2kz0hUe6CEe4OCrxzi89Ty7g332iw5PZs/0Uc70Yt6pvG7SmwgvFnVgVC+VNhakj6iY9jMrKhnTkTRPZCHgICxDDsIE20y/UKnJ5NoBFue6gPwf2NNsEt+xA5DMhASsUFj3GxMQjLlpVpFKSUlnTEGWkVHDzKsjazRemVkBVB9LZcE4zqOWaKthjJLzat0i0i1eNcv86JYH8Dy7b/Z1OpA4fL+gA94T8IA34Dt8ANyH9vGYRy/3cXuAFjuuLnvVeUkcI6Pt00tG8baaNQ54CY6FdGdFgY1FKB61FlIOFEeVqzHjGj4ApkyjGzNllsbNFgGeQJJnuwAlsKGPxOlmKubUpu8HBII43SXIE9NAJKftC5IpGlORgiFBJIRUmbyY6QwrWSULk9VBGUZWIyqtxKioxdo6FbCrZlyLlyXyZh+xO+7n4k7NvxxOe9fi88d6inu6+3C7e+M/pE0FljDZO7y5k+PeZ8ccnra2aX59ER7uZp5uNvM6DsUsndau96pN5ygfbXJVZ52Wn5w83cFRwanSPmiTY7vRIEaIZTM4eONfdLNv7aYJPVWdoKsRcOfpPrUpE12ZdTpuim9CylIYdVCq8Cx5IS28RFVaKC2atlaFhXY8FkeZ9VqJzY7d57cLfXO37qn/cHWj13fpvYl4G0kSSU5zv9DDKXdZ+3jMW5/d1bfo2S86LT47Tjxt83rXxdFx9bE0seuyoVjFCj67lrYa1smVNAPhGOFJswa0xBo6VhNoNWgGowA6nIlp54GolaU0UzH0uXdL/pYp0HWRea0jvJikqeBcgARTRIiIBJVQSUBZoBxHZdNajFKCCHYMJGN5YjnrLACPl/3r3N21OB7H9PmN7Pr+DDjs6y/4XgefQ09xT4cPz1wT1mu6753eu4h3XptBB7AeeKzrGW7hLr9dm9vslWMOXWu1FIuXLy1KY3vFLdwtzWxmZqs+vbMpS0RGa2imdXpSjqOJNOO0uJ+kBZM2OtFgstcYk2gAoIGNb6nGB5CNCRiBEfBmKlDHCGQzOSWalAHTtDW80ppmSsOSclROvmPqUu2UprXKzJ0dj5KZm+3gmxhz9vFHufj+SBvgnuKPOnjblvB4v5rWN/Veg7fR3wNwH3/k4vvv7ajsM5ofbcf2GO629+rYorg1N2aMxYmFTTDmyqzsrHPl5kH1NGdDQ3A1TM1t1wEVhXWMKetkWAO32dzi9MZw4VBam7JYGldBVd8DKdOsVeZ66wJ2yli6rMusJ0U2m5JRPSM9drJcm2Drf1rofHFSuXM7b+OZfs/AbfS7AA843/cDHj4Ecf/BL2pTn87PKrh2yz7/soZwxhXrq2LtBwPjtVvDGVfXR+aJ2caNvbDy9cpsZw4MrHS0HPvK+QwYVpO/C+YzjOvbs/V5bba9aGYuLKd77cy1XAFNVxQY1KroZAlcm2VWFVUNqiqynczZq8ld3q9FDj+3KtdrrjRTuVVz/8muFvXorBJuue7D3bv1uwVuo98NeBudBxC4aP+wKSX8BH/l/uERn71RRvi2opuWA5ecs+XA5njG1XqLAOAaeo7cBdCzvrV5fZc6FS0AdGoEvMaoRrNsNO6tNKjVXEsNavW2IqO3lV1uohsA/N6B2+h3B95GvwDwfJX+eQi/+SvxObCPIz777gzEO3fu4OjpWQXYLQDHXHHxoucHH3yAxYueWFcqti8H4iaA6duv6AXwAhhuTNYQOAJ2b3b6+eefsXuz056moqHTSrZPdvXkyRNsQLv92dSM4hvg6ee/hG1TYP57Bm6j3y1458V1kuRbIdw0x4+e84t79/DtBsTDI+K8G/v3x8SnF8sST1/gE2D+w/IfinrL9ZYFG71ZJvnxp3v67jvg9mfPhMOpzhjfAH/+/I/6elNI/g5rjfd1auR/on8K8M7rTQiBM7tX4AxE4I0q/zWQwLoQGwAOAOAunn330z8E3Ua3P/tQwONpb1icKwzfAAZcdCs4DxqA+7ivNWb4Z4hub9M/HXjntWmOgfMgXoyIGx28YT0BrMEEzmpOAXyBt+vr83cePQKAizYYwC8AA/Bus6B/ksj2Lv1Tg/em3gXiRg8fTgOVN6H8X+vhdDgP2Eb/KqC9qX8p8N6l80C+qf/pu/POtvlfDLB3aQveVleiq6m52OpfXlvwtroSbcHb6kq0BW+rK9EWvK2uRFvwtroSbcHb6kq0BW+rK9EWvK2uRFvwtroSbcHb6kq0BW+rK9EWvK2uRFvwtroSbcHb6kq0BW+rK9EWvK2uRFvwtroSbcHb6kq0BW+rK9EWvK2uRFvwtroSbcHb6kr0/wNe9Egqv3ALZgAAAABJRU5ErkJggg=="
              />
              <ellipse
                cx="423.64"
                cy="61.12"
                rx="39.45"
                ry="20.38"
                fill="none"
                stroke="#e1e1ef"
                strokeMiterlimit="10"
                strokeWidth="1.32"
              />
            </g>
          </g>
        </g>
      </g>
      <g className="text">
        <path
          d="M211.19,203.58a.8.8,0,0,0-.25-.5,1.22,1.22,0,0,0-.66-.2c-.64,0-1.3-.06-2-.07l-2,0c-.8,0-1.57,0-2.33.05l-2.11.11a1.34,1.34,0,0,0-.5.16.61.61,0,0,0-.28.42,2.81,2.81,0,0,0-.13.73c0,.28,0,.56,0,.83a1,1,0,0,0,.16.66.65.65,0,0,0,.5.16c.18,0,.5,0,.95,0s1-.07,1.6-.09c0,.63-.08,1.25-.1,1.86s0,1.22,0,1.83c0,.89,0,1.78.06,2.66s.1,1.78.19,2.67a.71.71,0,0,0,.31.59,1.33,1.33,0,0,0,.63.23l.22,0h.21c.27,0,.55,0,.84,0s.55-.05.82-.09a.79.79,0,0,0,.45-.2.61.61,0,0,0,.13-.44c0-.07,0-.27,0-.61s-.06-.75-.11-1.26-.07-1.1-.1-1.75,0-1.34,0-2.07c0-.57,0-1.13,0-1.69s0-1.12.1-1.67c.67,0,1.25,0,1.73.09a9.17,9.17,0,0,0,1.08.08.71.71,0,0,0,.45-.12.65.65,0,0,0,.19-.39,6,6,0,0,0,.11-1.11A7.11,7.11,0,0,0,211.19,203.58Z"
          fill="#fff"
        />
        <path
          d="M218.09,209.39a4.31,4.31,0,0,0-.73-1.34A4.23,4.23,0,0,0,216,207a4.54,4.54,0,0,0-2.08-.44,4.63,4.63,0,0,0-1.76.34,4.42,4.42,0,0,0-1.48.95,4.69,4.69,0,0,0-1,1.47,4.63,4.63,0,0,0-.38,1.87,4.38,4.38,0,0,0,.37,1.84,4.72,4.72,0,0,0,1,1.41,4.34,4.34,0,0,0,1.43.9,4.41,4.41,0,0,0,1.68.33,7.1,7.1,0,0,0,2.19-.32,3.64,3.64,0,0,0,1.5-.83.8.8,0,0,0,.29-.6v-.17a.81.81,0,0,0,0-.19c0-.13-.05-.26-.08-.39a2.91,2.91,0,0,0-.12-.39,1.05,1.05,0,0,0-.14-.3.26.26,0,0,0-.21-.09,1.32,1.32,0,0,0-.38.12,4.77,4.77,0,0,1-1.14.38,5.16,5.16,0,0,1-1.08.14,3,3,0,0,1-1.19-.24,2.59,2.59,0,0,1-.92-.65l1.49-.12c.52,0,1-.12,1.5-.19s.93-.15,1.36-.24a9.42,9.42,0,0,0,1.09-.31.63.63,0,0,0,.36-.28,1,1,0,0,0,.08-.4A3.87,3.87,0,0,0,218.09,209.39Zm-4.3.8c-.6.05-1.16.08-1.69.11a1.88,1.88,0,0,1,.73-1A2,2,0,0,1,214,209a1.72,1.72,0,0,1,.83.22,1.35,1.35,0,0,1,.62.74A11.09,11.09,0,0,1,213.79,210.19Z"
          fill="#fff"
        />
        <path
          d="M227.4,213.8a2.43,2.43,0,0,0-.09-.3c-.06-.15-.12-.3-.19-.44s-.14-.28-.22-.41-.27-.34-.42-.34a.57.57,0,0,0-.24.06l-.33.15a3,3,0,0,1-.4.19c-.15.07-.32.13-.49.19a3.41,3.41,0,0,1-.55.14,2.35,2.35,0,0,1-.51.06,2.16,2.16,0,0,1-.86-.17,2.06,2.06,0,0,1-.65-.46,1.84,1.84,0,0,1-.41-.67,2.12,2.12,0,0,1-.14-.79,1.86,1.86,0,0,1,.18-.82,2.16,2.16,0,0,1,.51-.65,2.75,2.75,0,0,1,.76-.46,3.52,3.52,0,0,1,.92-.21c0,.18,0,.36,0,.55s0,.35.06.52a.93.93,0,0,0,.8.84,5.39,5.39,0,0,0,1,.07.78.78,0,0,0,.51-.13,1,1,0,0,0,.21-.51,7.36,7.36,0,0,0,.1-1.25,4.43,4.43,0,0,0,0-.51c0-.17,0-.35-.05-.54a1.29,1.29,0,0,0-.23-.71,1.43,1.43,0,0,0-.59-.38,3.92,3.92,0,0,0-.91-.23,6.24,6.24,0,0,0-.85-.05,6.15,6.15,0,0,0-2,.34,5.94,5.94,0,0,0-1.74,1,4.83,4.83,0,0,0-1.23,1.47,3.85,3.85,0,0,0-.46,1.86,5.74,5.74,0,0,0,.06.76,4,4,0,0,0,.25.94,4.66,4.66,0,0,0,.52,1,3.4,3.4,0,0,0,.9.87,4.76,4.76,0,0,0,1.38.63,6.83,6.83,0,0,0,1.93.24,5.84,5.84,0,0,0,.93-.08,6.51,6.51,0,0,0,.92-.23,4.68,4.68,0,0,0,.82-.33,2.82,2.82,0,0,0,.64-.41.64.64,0,0,0,.25-.76Z"
          fill="#fff"
        />
        <path
          d="M237.11,207.67a2.17,2.17,0,0,0-.73-.77,2.69,2.69,0,0,0-.89-.34,5.61,5.61,0,0,0-.85-.08,5.3,5.3,0,0,0-1.53.23,4.27,4.27,0,0,0-1.15.53,1.82,1.82,0,0,0-.23.15c0-.12,0-.24,0-.37,0-.29,0-.6,0-.92s0-.88,0-1.28,0-.75,0-1.06,0-.52,0-.63a.74.74,0,0,0-.07-.36c-.05-.09-.17-.14-.36-.14l-.51,0-.61,0c-.2,0-.4,0-.59.06a3.21,3.21,0,0,0-.5.09.5.5,0,0,0-.41.36,4,4,0,0,0-.09.69,1.09,1.09,0,0,1,0,.18c0,.54,0,1.11-.07,1.69s0,1.29,0,1.94,0,1.35,0,2,0,1.28.07,1.88.06,1.15.11,1.66.07.94.11,1.31a1.37,1.37,0,0,0,.22.64,1.07,1.07,0,0,0,.73.25H231a1.39,1.39,0,0,0,.76-.2.56.56,0,0,0,.19-.46c0-.06,0-.12,0-.18l0-.2c-.06-.53-.1-1.2-.12-2s0-1.65-.06-2.57a3.57,3.57,0,0,1,1.91-.66.57.57,0,0,1,.51.26,1.26,1.26,0,0,1,.17.69c0,1.27,0,2.28-.1,3s-.1,1.21-.1,1.34a.7.7,0,0,0,.57.78,6.68,6.68,0,0,0,.84.14c.3,0,.53,0,.69,0,.31,0,.51-.08.6-.26a1.52,1.52,0,0,0,.17-.56c.07-.52.13-1,.19-1.58,0-.25,0-.49.07-.73s0-.55.05-.81c0-.5.06-1,.07-1.39s0-.8,0-1.12A2.77,2.77,0,0,0,237.11,207.67Z"
          fill="#fff"
        />
        <path
          d="M247.17,207.67a2.06,2.06,0,0,0-.72-.77,2.66,2.66,0,0,0-.9-.34,5.37,5.37,0,0,0-.84-.08,5.16,5.16,0,0,0-2.93.93c0-.1,0-.18,0-.26a1.62,1.62,0,0,0,0-.22.57.57,0,0,0-.09-.34.43.43,0,0,0-.36-.12h-.51l-.61.05-.59.06a3.21,3.21,0,0,0-.5.09.5.5,0,0,0-.41.36,3.27,3.27,0,0,0-.08.69c0,.22,0,.43,0,.64V209q0,1.4.09,2.79c0,.73.1,1.44.17,2.15h0l.06.6a1.27,1.27,0,0,0,.22.64,1,1,0,0,0,.72.25h1.16a1.42,1.42,0,0,0,.76-.2.59.59,0,0,0,.19-.46c0-.06,0-.12,0-.18l0-.2c-.07-.74-.13-1.49-.17-2.24s-.06-1.51-.06-2.28a3.94,3.94,0,0,1,1-.53,3.08,3.08,0,0,1,1-.17.59.59,0,0,1,.51.26,1.26,1.26,0,0,1,.17.69c0,.73,0,1.35,0,1.85s0,.92-.07,1.25-.06.59-.07.79,0,.36,0,.49a.7.7,0,0,0,.57.78,7,7,0,0,0,1.53.18c.31,0,.51-.08.6-.26a1.52,1.52,0,0,0,.17-.56c.07-.52.13-1,.19-1.58s.09-1.05.12-1.54,0-1,.07-1.39,0-.8,0-1.12A2.66,2.66,0,0,0,247.17,207.67Z"
          fill="#fff"
        />
        <path
          d="M257.33,209a3.82,3.82,0,0,0-2.18-1.36c0-.13,0-.22,0-.27a.76.76,0,0,0,0-.14c0-.19,0-.32-.13-.38a1.4,1.4,0,0,0-.37-.19,4.54,4.54,0,0,0-.68-.14,4.15,4.15,0,0,0-.67-.05,5.07,5.07,0,0,0-1.83.34,5.36,5.36,0,0,0-1.61,1,4.92,4.92,0,0,0-1.16,1.53,4.36,4.36,0,0,0-.44,2,4.7,4.7,0,0,0,.35,1.9,3.67,3.67,0,0,0,1,1.39,4.3,4.3,0,0,0,1.6.85,7.26,7.26,0,0,0,2.1.28,5.65,5.65,0,0,0,1.71-.27,5.16,5.16,0,0,0,1.52-.81,4.19,4.19,0,0,0,1.1-1.33,4.27,4.27,0,0,0-.38-4.3Zm-2.25,3.11a1.79,1.79,0,0,1-.47.52,2.24,2.24,0,0,1-.66.32,2.71,2.71,0,0,1-.74.11,2.55,2.55,0,0,1-.74-.11,1.92,1.92,0,0,1-.62-.32,1.51,1.51,0,0,1-.42-.52,1.64,1.64,0,0,1-.15-.71,2.19,2.19,0,0,1,.61-1.58,2.35,2.35,0,0,1,1.51-.72,1.63,1.63,0,0,0,0,.43.64.64,0,0,0,.13.26.73.73,0,0,0,.22.16,2.65,2.65,0,0,0,.35.13,1.74,1.74,0,0,1,.8.48,1.21,1.21,0,0,1,.31.84A1.41,1.41,0,0,1,255.08,212.11Z"
          fill="#fff"
        />
        <path
          d="M262.41,204.17c0-.29,0-.57,0-.84a.89.89,0,0,0-.12-.55.51.51,0,0,0-.4-.15,8.1,8.1,0,0,0-.9.06,5.67,5.67,0,0,0-1,.16.55.55,0,0,0-.37.26,2.16,2.16,0,0,0-.16.79c-.1,1-.17,2-.21,3s-.06,2.1-.06,3.11,0,1.76,0,2.54.05,1.43.1,2a1.18,1.18,0,0,0,.21.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.68-.31a2.21,2.21,0,0,0,.16-.73c0-.52.08-1.15.12-1.88s.07-1.51.09-2.35,0-1.7.06-2.57,0-1.73,0-2.55C262.42,204.75,262.42,204.45,262.41,204.17Z"
          fill="#fff"
        />
        <path
          d="M272.57,209a3.84,3.84,0,0,0-2.19-1.36c0-.13,0-.22.05-.27a.76.76,0,0,0,0-.14.44.44,0,0,0-.14-.38,1.32,1.32,0,0,0-.36-.19,4.42,4.42,0,0,0-.69-.14,4,4,0,0,0-.66-.05,5.07,5.07,0,0,0-1.83.34,5.54,5.54,0,0,0-1.62,1,4.89,4.89,0,0,0-1.15,1.53,4.36,4.36,0,0,0-.45,2,4.7,4.7,0,0,0,.36,1.9,3.65,3.65,0,0,0,1,1.39,4.35,4.35,0,0,0,1.61.85,7.26,7.26,0,0,0,2.1.28,5.54,5.54,0,0,0,1.7-.27,5.22,5.22,0,0,0,1.53-.81,4.16,4.16,0,0,0,1.09-1.33,4.23,4.23,0,0,0-.37-4.3Zm-2.26,3.11a1.66,1.66,0,0,1-.47.52,2.13,2.13,0,0,1-.66.32,2.65,2.65,0,0,1-.74.11,2.55,2.55,0,0,1-.74-.11,1.87,1.87,0,0,1-.61-.32,1.51,1.51,0,0,1-.42-.52,1.64,1.64,0,0,1-.15-.71,2.22,2.22,0,0,1,.6-1.58,2.37,2.37,0,0,1,1.52-.72,1.69,1.69,0,0,0,0,.43.65.65,0,0,0,.14.26.73.73,0,0,0,.22.16,2.2,2.2,0,0,0,.35.13,1.74,1.74,0,0,1,.8.48,1.2,1.2,0,0,1,.3.84A1.41,1.41,0,0,1,270.31,212.11Z"
          fill="#fff"
        />
        <path
          d="M283.62,208.88c0-.46,0-.85-.05-1.17a2.1,2.1,0,0,0-.08-.51.88.88,0,0,0-.17-.32.68.68,0,0,0-.27-.2l-.06,0a1.85,1.85,0,0,0-.31-.11,8.9,8.9,0,0,0-1-.19,5.93,5.93,0,0,0-.76-.07.42.42,0,0,0-.32.1.62.62,0,0,0-.13.36,4.3,4.3,0,0,0-.65-.15,4.62,4.62,0,0,0-.65,0,4.54,4.54,0,0,0-1.87.41,5.43,5.43,0,0,0-2.79,2.74,4.89,4.89,0,0,0-.44,2,4.1,4.1,0,0,0,.25,1.41,3.35,3.35,0,0,0,.72,1.14,3.55,3.55,0,0,0,1.15.76,4.18,4.18,0,0,0,1.54.27,4.34,4.34,0,0,0,2.69-.92c0,.44-.08.86-.13,1.27s-.1.8-.16,1.17a16.15,16.15,0,0,1-1.68-.12,8.2,8.2,0,0,1-1.65-.4,1.32,1.32,0,0,0-.45-.11.4.4,0,0,0-.26.1.93.93,0,0,0-.22.3c-.1.23-.21.5-.32.79a2.06,2.06,0,0,0-.16.68.6.6,0,0,0,.17.44,1.74,1.74,0,0,0,.42.3,11.81,11.81,0,0,0,2.06.68,10.47,10.47,0,0,0,2.27.22,3.4,3.4,0,0,0,1.08-.16l.19-.07a3.26,3.26,0,0,0,.67-.35,2.47,2.47,0,0,0,.62-.63,2,2,0,0,0,.31-.75q.12-.67.21-1.56c.06-.6.11-1.22.15-1.88s.06-1.31.08-2,0-1.33,0-1.94S283.64,209.34,283.62,208.88Zm-3,2.05c0,.34,0,.69,0,1a2.58,2.58,0,0,1-1.71.72,1.58,1.58,0,0,1-1.14-.39,1.31,1.31,0,0,1-.41-1,2.08,2.08,0,0,1,.15-.74,2.42,2.42,0,0,1,.44-.74,2.31,2.31,0,0,1,.7-.57,1.88,1.88,0,0,1,1-.23,3.2,3.2,0,0,1,.56,0,3,3,0,0,1,.48.13Z"
          fill="#fff"
        />
        <path
          d="M293.66,211.54q0-.85-.06-1.62c0-.51-.06-1-.09-1.41s-.07-.81-.1-1.13-.14-.55-.31-.64a1.66,1.66,0,0,0-.74-.13,3.65,3.65,0,0,0-.55,0l-.51.1a1.84,1.84,0,0,0-.73.34.74.74,0,0,0-.19.55c0,.07,0,.25,0,.54s.07.65.1,1.07.07.88.1,1.37.05.95.06,1.39a3.46,3.46,0,0,1-1,.51,3.31,3.31,0,0,1-1,.17.58.58,0,0,1-.51-.25,1.2,1.2,0,0,1-.17-.66c0-.46,0-.91,0-1.36s.07-.87.1-1.26.07-.72.1-1,0-.49,0-.61a.73.73,0,0,0-.57-.76,3.06,3.06,0,0,0-.56-.14,4,4,0,0,0-.6,0,2,2,0,0,0-.87.15.82.82,0,0,0-.36.65c-.07.51-.14,1-.19,1.53s-.1,1-.12,1.48-.06.92-.08,1.34,0,.78,0,1.08a2.64,2.64,0,0,0,.29,1.32,2.1,2.1,0,0,0,.72.73,2.58,2.58,0,0,0,.9.33,4.56,4.56,0,0,0,.85.08,5.17,5.17,0,0,0,1.56-.23,4.9,4.9,0,0,0,1.43-.71,18.79,18.79,0,0,1-.26,2.48c-.3,0-.57,0-.82,0s-.5-.05-.74-.09a6.69,6.69,0,0,1-.75-.16c-.26-.06-.53-.14-.83-.24l-.25-.07a.79.79,0,0,0-.2,0,.36.36,0,0,0-.25.1,2.27,2.27,0,0,0-.43.69,4.22,4.22,0,0,0-.18.45c-.05.15-.1.29-.13.41a1.08,1.08,0,0,0-.06.28.59.59,0,0,0,.16.4,1.5,1.5,0,0,0,.4.28,10,10,0,0,0,4.36.9,3.4,3.4,0,0,0,1.08-.16,2.93,2.93,0,0,0,.85-.42,2,2,0,0,0,.58-.63,1.74,1.74,0,0,0,.27-.75c.08-.64.14-1.35.17-2.13s.05-1.57.05-2.38C293.68,212.67,293.67,212.1,293.66,211.54Z"
          fill="#fff"
        />
        <path
          d="M309.58,202.53a.71.71,0,0,0-.4-.29,6.73,6.73,0,0,0-1.85-.25.37.37,0,0,0-.33.15.64.64,0,0,0-.15.26l-.09.43-.65-.05c-.21,0-.42,0-.64,0a12,12,0,0,0-2.39.24,7.48,7.48,0,0,0-2.12.75,4.49,4.49,0,0,0-1.52,1.3,3.09,3.09,0,0,0-.58,1.88,2.75,2.75,0,0,0,.52,1.74,3.92,3.92,0,0,0,1.28,1.07,6.49,6.49,0,0,0,1.68.63c.6.14,1.16.26,1.67.35s.94.19,1.28.29.52.23.52.39a.65.65,0,0,1-.25.52,1.9,1.9,0,0,1-.65.35,5.31,5.31,0,0,1-.92.19,8.89,8.89,0,0,1-1,.06,7.67,7.67,0,0,1-.91,0l-.59-.08-.3-.07-.25,0a.34.34,0,0,0-.29.12.68.68,0,0,0-.14.31c0,.23-.06.46-.09.71s0,.5,0,.73v.34a2.53,2.53,0,0,0,0,.38.8.8,0,0,0,.18.3.79.79,0,0,0,.39.18,12.85,12.85,0,0,0,2.14.19,9.42,9.42,0,0,0,2.38-.28,5.9,5.9,0,0,0,1.9-.84,4.22,4.22,0,0,0,1.26-1.34,3.54,3.54,0,0,0,.47-1.81,3.1,3.1,0,0,0-.49-1.81,3.74,3.74,0,0,0-1.22-1.09,6,6,0,0,0-1.6-.6c-.57-.14-1.11-.26-1.59-.35a10.16,10.16,0,0,1-1.22-.31c-.33-.12-.49-.29-.49-.53a.58.58,0,0,1,.2-.43,1.65,1.65,0,0,1,.56-.32,4.36,4.36,0,0,1,.84-.19,6.79,6.79,0,0,1,1-.08l.65,0c.22,0,.45,0,.69.07l0,.43c0,.14,0,.29,0,.43a.82.82,0,0,0,.11.39.41.41,0,0,0,.3.23,6.91,6.91,0,0,0,.8.15q.36,0,.93,0a.57.57,0,0,0,.47-.17.71.71,0,0,0,.19-.4c.05-.3.1-.59.14-.87s.09-.58.13-.89.06-.62.09-1,0-.74.07-1.17A.62.62,0,0,0,309.58,202.53Z"
          fill="#fff"
        />
        <path
          d="M319.17,211.12a1.13,1.13,0,0,0-.87-.54l-.39-.05-.41,0-.44,0-.47.05c.39-.34.8-.71,1.21-1.1a11.39,11.39,0,0,0,1-1,1.1,1.1,0,0,0,.31-.65,1,1,0,0,0-.25-.57,4.53,4.53,0,0,0-1.13-.94.74.74,0,0,0-.44-.14.55.55,0,0,0-.34.1,2.44,2.44,0,0,0-.3.27,19.25,19.25,0,0,0-1.46,1.66c-.45.58-.91,1.21-1.36,1.89,0-2.14,0-3.77.05-4.89s.06-1.79.06-2a.88.88,0,0,0-.07-.36c-.05-.09-.17-.14-.36-.14l-.52,0-.6,0c-.21,0-.4,0-.59.06a3,3,0,0,0-.5.09.53.53,0,0,0-.39.28,2.94,2.94,0,0,0-.11.77c-.05.57-.08,1.18-.1,1.82s0,1.29,0,1.94,0,1.35,0,2,0,1.3.07,1.9.07,1.17.11,1.68.08.95.12,1.32a1.27,1.27,0,0,0,.22.64,1,1,0,0,0,.72.25h1.16a1.42,1.42,0,0,0,.76-.2.59.59,0,0,0,.18-.46s0-.12,0-.26,0-.3,0-.49,0-.4-.05-.62,0-.46,0-.68a3.82,3.82,0,0,1,.67-.15,5.34,5.34,0,0,1,.69-.05,4.72,4.72,0,0,1,.68.05l.51.08a8.18,8.18,0,0,1-.05.88,5,5,0,0,1-.15.72q0,.16-.06.24c0,.06,0,.1,0,.14a.52.52,0,0,0,.14.38.61.61,0,0,0,.27.17,8.08,8.08,0,0,0,.92.21,4.93,4.93,0,0,0,.81.07.61.61,0,0,0,.52-.19,1.94,1.94,0,0,0,.25-.63c.08-.33.15-.72.22-1.16a7.41,7.41,0,0,0,.1-1.12A2.6,2.6,0,0,0,319.17,211.12Z"
          fill="#fff"
        />
        <path
          d="M324,203.4a1.11,1.11,0,0,0-.32-.56,1.18,1.18,0,0,0-.57-.28,4.89,4.89,0,0,0-.84-.07,1.84,1.84,0,0,0-1.37.42,1.77,1.77,0,0,0-.4,1.28,3.26,3.26,0,0,0,.09.84,1.27,1.27,0,0,0,.29.54,1.15,1.15,0,0,0,.55.28,3.85,3.85,0,0,0,.84.08,3.33,3.33,0,0,0,.91-.11,1.19,1.19,0,0,0,.56-.34,1.08,1.08,0,0,0,.28-.5,2.61,2.61,0,0,0,.08-.64A3.46,3.46,0,0,0,324,203.4Zm-.28,3.5q-.06-.14-.33-.15l-.29,0h-.3l-.76,0a4.26,4.26,0,0,0-.68.1.48.48,0,0,0-.45.33,2.92,2.92,0,0,0-.11.68c0,.7-.08,1.39-.1,2s0,1.34,0,2c0,.41,0,.83,0,1.25s0,.85.05,1.28a1.53,1.53,0,0,0,.19.67,1,1,0,0,0,.7.27,7.94,7.94,0,0,0,1,.05,1.78,1.78,0,0,0,.52-.05.53.53,0,0,0,.28-.17.68.68,0,0,0,.12-.3c0-.13,0-.28.05-.46.08-1.18.14-2.33.16-3.44s.05-2.3.05-3.58A1.67,1.67,0,0,0,323.75,206.9Z"
          fill="#fff"
        />
        <path
          d="M328.59,204.17v-.84a.37.37,0,0,0,0-.11.75.75,0,0,0-.12-.44.47.47,0,0,0-.39-.15,8.42,8.42,0,0,0-.91.06l-.31,0h0a4.88,4.88,0,0,0-.62.12.57.57,0,0,0-.38.26,2.41,2.41,0,0,0-.16.79c-.09,1-.16,2-.2,3s-.07,2.1-.07,3.11,0,1.76,0,2.54.06,1.43.11,2a1.18,1.18,0,0,0,.2.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.69-.31a2,2,0,0,0,.15-.73c.05-.52.09-1.15.13-1.88s.06-1.51.08-2.35.05-1.7.07-2.57,0-1.73,0-2.55C328.6,204.75,328.6,204.45,328.59,204.17Z"
          fill="#fff"
        />
        <path
          d="M333.3,204.55c0-.13,0-.26,0-.38,0-.29,0-.57,0-.84a.89.89,0,0,0-.12-.55.51.51,0,0,0-.4-.15,8.1,8.1,0,0,0-.9.06,5.67,5.67,0,0,0-.95.16.55.55,0,0,0-.37.26,1.42,1.42,0,0,0-.14.63.78.78,0,0,0,0,.16c-.1,1-.17,2-.21,3s-.06,2.1-.06,3.11,0,1.76,0,2.54.06,1.43.11,2a1.1,1.1,0,0,0,.21.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.68-.31a2.21,2.21,0,0,0,.16-.73c0-.52.08-1.15.12-1.88s.07-1.51.09-2.35,0-1.7.06-2.57,0-1.73,0-2.55C333.31,204.89,333.31,204.72,333.3,204.55Z"
          fill="#fff"
        />
        <path
          d="M339.06,209.58a.78.78,0,0,0,.45.2,5.55,5.55,0,0,0,1.07.11.64.64,0,0,0,.49-.15,1.27,1.27,0,0,0,.22-.42,8.29,8.29,0,0,0,.17-.82,5.73,5.73,0,0,0,.08-.86.83.83,0,0,0-.15-.54.86.86,0,0,0-.44-.28,6.81,6.81,0,0,0-1.22-.3,8.37,8.37,0,0,0-1.31-.11,5.36,5.36,0,0,0-1.49.21,4.38,4.38,0,0,0-1.28.57,3.09,3.09,0,0,0-.91.89,2.08,2.08,0,0,0-.34,1.17,2.3,2.3,0,0,0,.27,1.15,2.79,2.79,0,0,0,.69.8,4.27,4.27,0,0,0,.89.55l.89.39a5.63,5.63,0,0,1,.69.33q.27.17.27.36a.34.34,0,0,1-.25.34,2,2,0,0,1-.66.08,3.1,3.1,0,0,1-.63-.07,2.5,2.5,0,0,1-.7-.23,1.64,1.64,0,0,0-.47-.14c-.13,0-.25.12-.37.37s-.13.33-.22.53a4.89,4.89,0,0,0-.21.54,1.42,1.42,0,0,0,0,.38.62.62,0,0,0,.48.59,5.87,5.87,0,0,0,1.13.31,9.07,9.07,0,0,0,1.35.1,6.53,6.53,0,0,0,1.56-.19,4,4,0,0,0,1.24-.54,2.71,2.71,0,0,0,.83-.82,2.05,2.05,0,0,0,.3-1.09,2.18,2.18,0,0,0-.3-1.18,2.83,2.83,0,0,0-.77-.81,5,5,0,0,0-1-.55c-.36-.15-.69-.28-1-.39s-.57-.23-.77-.33-.3-.23-.3-.36a.44.44,0,0,1,.31-.43,2.21,2.21,0,0,1,.78-.12,2.5,2.5,0,0,1,.57.09V209A1,1,0,0,0,339.06,209.58Z"
          fill="#fff"
        />
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(140, 95)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
      <g className="flowers">
        <g>
          <g>
            <g>
              <path
                d="M323.58,168.14c-2.27.44-4.38-4.81-5.88-7.18,0,0,4,.24,5.92,1.5S326.64,167.54,323.58,168.14Z"
                fill="#1c7f19"
              />
              <path
                d="M317.7,161a36.56,36.56,0,0,1,4.08,2.82,18.23,18.23,0,0,1,1.83,1.69,3.7,3.7,0,0,1,1.2,2.13,2.19,2.19,0,0,0-.49-1.12,5.87,5.87,0,0,0-.8-.93,20.64,20.64,0,0,0-1.85-1.64C320.41,162.85,319,161.92,317.7,161Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M337,165.81c-2.27.44-4.38-4.81-5.88-7.18,0,0,4,.24,5.92,1.5S340.09,165.21,337,165.81Z"
                fill="#1c7f19"
              />
              <path
                d="M331.15,158.63a36.56,36.56,0,0,1,4.08,2.82,18.32,18.32,0,0,1,1.83,1.69,3.73,3.73,0,0,1,1.2,2.13,2.19,2.19,0,0,0-.49-1.12,6.37,6.37,0,0,0-.79-.93,19.2,19.2,0,0,0-1.86-1.63C333.86,160.53,332.5,159.59,331.15,158.63Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M331.53,173c-2.27.44-4.38-4.81-5.88-7.18,0,0,4,.24,5.92,1.5S334.6,172.37,331.53,173Z"
                fill="#1b6817"
              />
              <path
                d="M325.65,165.79a35.66,35.66,0,0,1,4.08,2.82,18.32,18.32,0,0,1,1.83,1.69,3.67,3.67,0,0,1,1.2,2.13,2.19,2.19,0,0,0-.49-1.12,6.37,6.37,0,0,0-.79-.93,19.2,19.2,0,0,0-1.86-1.63C328.36,167.69,327,166.75,325.65,165.79Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M325.59,173c-1.63.32-3.14-3.45-4.23-5.16a11.42,11.42,0,0,1,4.26,1.08C327,169.79,327.79,172.53,325.59,173Z"
                fill="#1b6817"
              />
              <path
                d="M321.36,167.8a26.94,26.94,0,0,1,2.94,2,12.52,12.52,0,0,1,1.31,1.21,2.66,2.66,0,0,1,.86,1.53,2.91,2.91,0,0,0-.92-1.47,14.84,14.84,0,0,0-1.33-1.17C323.31,169.17,322.33,168.49,321.36,167.8Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M325.33,162.17c-1.64.33-3.17-3.49-4.27-5.22a11.43,11.43,0,0,1,4.31,1.1C326.78,159,327.56,161.74,325.33,162.17Z"
                fill="#1c7f19"
              />
              <path
                d="M321.06,157a29,29,0,0,1,3,2.05,15.5,15.5,0,0,1,1.33,1.23,2.69,2.69,0,0,1,.87,1.55,2.94,2.94,0,0,0-.93-1.49A15.31,15.31,0,0,0,324,159.1C323,158.33,322,157.65,321.06,157Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M327.2,170.12c2.27.45,4.37-4.81,5.88-7.18,0,0-4,.24-5.92,1.5S324.13,169.52,327.2,170.12Z"
                fill="#1c7f19"
              />
              <path
                d="M333.08,162.94c-1.35,1-2.71,1.9-4,3a19.08,19.08,0,0,0-1.85,1.63,7,7,0,0,0-.79.94,2.11,2.11,0,0,0-.49,1.11,3.67,3.67,0,0,1,1.2-2.13,19.37,19.37,0,0,1,1.82-1.69A39.58,39.58,0,0,1,333.08,162.94Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M339,163.14c2.27.44,4.37-4.81,5.88-7.19,0,0-4,.25-5.93,1.51S335.89,162.54,339,163.14Z"
                fill="#1c7f19"
              />
              <path
                d="M344.84,156c-1.35,1-2.71,1.9-4,3a20.53,20.53,0,0,0-1.85,1.63,8,8,0,0,0-.8.94,2.18,2.18,0,0,0-.48,1.11,3.74,3.74,0,0,1,1.19-2.13,22.47,22.47,0,0,1,1.83-1.69A39.58,39.58,0,0,1,344.84,156Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M327.22,164.16c1.65.32,3.18-3.5,4.27-5.22a11.48,11.48,0,0,0-4.3,1.09C325.77,160.94,325,163.72,327.22,164.16Z"
                fill="#1b6817"
              />
              <path
                d="M331.49,158.94c-1,.7-2,1.38-2.89,2.15a13.74,13.74,0,0,0-1.35,1.18,3,3,0,0,0-.93,1.49,2.69,2.69,0,0,1,.87-1.55,13.93,13.93,0,0,1,1.33-1.22A26.13,26.13,0,0,1,331.49,158.94Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M327.05,172.32a9.46,9.46,0,0,1-1.73-3.2,5.5,5.5,0,0,1-.24-1.86,3.51,3.51,0,0,1,.16-1c.11-.33.22-.6.31-.85a13.46,13.46,0,0,0,.57-3.44c.07-1.18.09-2.37.08-3.58a16.72,16.72,0,0,1,.45,3.59,10.86,10.86,0,0,1-.45,3.65c-.13.31-.24.59-.32.83a3.07,3.07,0,0,0-.16.8,5.38,5.38,0,0,0,.12,1.69A14.33,14.33,0,0,0,327.05,172.32Z"
              fill="#30562e"
            />
            <path
              d="M333.48,161.8c-.1.43-.37.88-.48,1.25a4,4,0,0,0,.39,1.16,10,10,0,0,1,.75,2.67,12.2,12.2,0,0,1-.66,5.44c.06-.91.08-1.81.1-2.7a18,18,0,0,0-.12-2.66,14.46,14.46,0,0,0-.58-2.58c-.05-.22-.12-.43-.17-.66a1.35,1.35,0,0,1,0-.78C333,162.49,333.22,162.2,333.48,161.8Z"
              fill="#30562e"
            />
            <path
              d="M339.06,157.05a7.31,7.31,0,0,1-1.08,1.57c-.4.47-.79,1-.63,1.47a4,4,0,0,0,.9,1.47,5.75,5.75,0,0,1,1,1.73,11,11,0,0,1,.46,3.84,14.88,14.88,0,0,1-.64,3.75,31.63,31.63,0,0,0,.12-3.76,12,12,0,0,0-.58-3.6,5.17,5.17,0,0,0-.82-1.56,3.73,3.73,0,0,1-.94-1.78,1.46,1.46,0,0,1,.24-1.06,4.68,4.68,0,0,1,.66-.73A9.29,9.29,0,0,0,339.06,157.05Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M340.23,169.68c1.65.32,3.17-3.5,4.27-5.22a11.55,11.55,0,0,0-4.31,1.09C338.78,166.47,338,169.24,340.23,169.68Z"
                fill="#1b6817"
              />
              <path
                d="M338.7,172.18c1.65.32,3.18-3.49,4.28-5.22a11.55,11.55,0,0,0-4.31,1.09C337.25,169,336.47,171.74,338.7,172.18Z"
                fill="#1b6817"
              />
              <path
                d="M344.5,164.46c-1,.7-2,1.38-2.89,2.15a15.2,15.2,0,0,0-1.35,1.18,3,3,0,0,0-.93,1.49,2.67,2.67,0,0,1,.87-1.54,14,14,0,0,1,1.33-1.23A27.49,27.49,0,0,1,344.5,164.46Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M335.07,171.85c2.27.44,4.37-4.81,5.87-7.18,0,0-4,.24-5.92,1.5S332,171.25,335.07,171.85Z"
                fill="#1c7f19"
              />
              <path
                d="M340.94,164.67c-1.34,1-2.7,1.89-4,3a20.64,20.64,0,0,0-1.85,1.64,7.13,7.13,0,0,0-.8.93,2.18,2.18,0,0,0-.48,1.11,3.63,3.63,0,0,1,1.19-2.12,19.38,19.38,0,0,1,1.83-1.69A36.56,36.56,0,0,1,340.94,164.67Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M332.1,164.85c-1.65.32-3.18-3.5-4.27-5.22a11.48,11.48,0,0,1,4.3,1.09C333.55,161.63,334.33,164.41,332.1,164.85Z"
                fill="#1c7f19"
              />
              <path
                d="M327.83,159.63a26.13,26.13,0,0,1,3,2.05,13.93,13.93,0,0,1,1.33,1.22,2.69,2.69,0,0,1,.87,1.55,3,3,0,0,0-.94-1.49,12.56,12.56,0,0,0-1.34-1.18C329.8,161,328.81,160.33,327.83,159.63Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M339.15,159.56c-1.8-.68-.27-3.57-.47-4.78s1.59-2,3-1.28.6,1.93,1.77,2.67S340.62,160.12,339.15,159.56Z"
                fill="#bc784a"
              />
              <path
                d="M338.36,159.71c-1.91-.2-1.13-3.4-1.62-4.51s1.05-2.34,2.62-2,1.05,1.72,2.37,2.14S339.92,159.87,338.36,159.71Z"
                fill="#ed863a"
              />
              <path
                d="M338.28,160c-1.92-.2-.25-2.86-.75-4s.09-2.14,1.66-1.82,1,.92,2.3,1.34S339.83,160.13,338.28,160Z"
                fill="#bc784a"
              />
              <path
                d="M338.53,160.5c-1.7-.5-.45-2.95-.72-3.94s1.35-1.71,2.72-1.17.66,1.59,1.79,2.16S339.91,160.91,338.53,160.5Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M333.1,160.53c-1.89-.36-.87-3.48-1.28-4.63s1.23-2.24,2.77-1.8.92,1.8,2.2,2.33S334.64,160.81,333.1,160.53Z"
                fill="#4233aa"
              />
              <path
                d="M332.35,160.81c-1.92.14-1.69-3.15-2.37-4.15s.64-2.49,2.24-2.45,1.33,1.51,2.7,1.69S333.9,160.7,332.35,160.81Z"
                fill="#583bea"
              />
              <path
                d="M332.31,161.07c-1.92.14-.74-2.77-1.41-3.78s-.28-2.13,1.32-2.09,1.13.73,2.49.91S333.86,161,332.31,161.07Z"
                fill="#4233aa"
              />
              <path
                d="M332.65,161.56c-1.76-.2-.95-2.83-1.38-3.76s1-1.92,2.47-1.63.93,1.45,2.13,1.82S334.07,161.72,332.65,161.56Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M327.34,158.71c1.89-.35.87-3.47,1.28-4.62s-1.23-2.25-2.77-1.8-.92,1.8-2.2,2.32S325.8,159,327.34,158.71Z"
                fill="#ad45a6"
              />
              <path
                d="M328.09,159c1.92.13,1.69-3.15,2.37-4.16s-.65-2.48-2.24-2.44-1.34,1.51-2.7,1.69S326.53,158.89,328.09,159Z"
                fill="#dd52cd"
              />
              <path
                d="M328.13,159.26c1.92.14.73-2.78,1.41-3.78s.27-2.13-1.32-2.09-1.13.73-2.5.91S326.57,159.15,328.13,159.26Z"
                fill="#ad45a6"
              />
              <path
                d="M327.79,159.75c1.76-.2.95-2.83,1.38-3.76s-1-1.92-2.48-1.63-.92,1.45-2.13,1.82S326.36,159.91,327.79,159.75Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="341.13"
              cy="168.27"
              rx="1.21"
              ry="0.36"
              transform="translate(-6.84 321.91) rotate(-50.08)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <g>
            <g>
              <path
                d="M370.23,166.57c-2,.4-3.89-4.27-5.23-6.38,0,0,3.53.21,5.27,1.33S373,166,370.23,166.57Z"
                fill="#1c7f19"
              />
              <path
                d="M365,160.19a33.39,33.39,0,0,1,3.63,2.5,17.88,17.88,0,0,1,1.63,1.51,3.25,3.25,0,0,1,1.06,1.89,1.92,1.92,0,0,0-.43-1,6.23,6.23,0,0,0-.71-.83,16.15,16.15,0,0,0-1.65-1.45C367.41,161.87,366.2,161,365,160.19Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M382.19,164.5c-2,.4-3.89-4.28-5.23-6.39,0,0,3.53.22,5.27,1.34S384.92,164,382.19,164.5Z"
                fill="#1c7f19"
              />
              <path
                d="M377,158.11a36.19,36.19,0,0,1,3.64,2.51,19.18,19.18,0,0,1,1.62,1.5,3.25,3.25,0,0,1,1.06,1.9,1.89,1.89,0,0,0-.43-1,5.57,5.57,0,0,0-.71-.83,16.28,16.28,0,0,0-1.64-1.46C379.37,159.8,378.16,159,377,158.11Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M377.3,170.87c-2,.4-3.89-4.28-5.23-6.39,0,0,3.53.22,5.27,1.34S380,170.34,377.3,170.87Z"
                fill="#1b6817"
              />
              <path
                d="M372.07,164.48A33.47,33.47,0,0,1,375.7,167a16.56,16.56,0,0,1,1.63,1.5,3.25,3.25,0,0,1,1.06,1.9,1.89,1.89,0,0,0-.43-1,5.11,5.11,0,0,0-.71-.83,17.45,17.45,0,0,0-1.64-1.46C374.48,166.17,373.27,165.34,372.07,164.48Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M372,170.87c-1.45.28-2.8-3.08-3.76-4.59a10,10,0,0,1,3.78.95C373.29,168,374,170.48,372,170.87Z"
                fill="#1b6817"
              />
              <path
                d="M368.26,166.28a24.21,24.21,0,0,1,2.61,1.8,12,12,0,0,1,1.17,1.08,2.3,2.3,0,0,1,.76,1.36,2.57,2.57,0,0,0-.82-1.31,10.58,10.58,0,0,0-1.18-1C370,167.49,369.12,166.89,368.26,166.28Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M371.79,161.27c-1.47.28-2.83-3.11-3.8-4.64a10,10,0,0,1,3.83,1C373.08,158.41,373.77,160.88,371.79,161.27Z"
                fill="#1c7f19"
              />
              <path
                d="M368,156.63a21.71,21.71,0,0,1,2.64,1.82,11,11,0,0,1,1.18,1.09,2.41,2.41,0,0,1,.78,1.38,2.71,2.71,0,0,0-.83-1.33,12,12,0,0,0-1.2-1.05C369.74,157.85,368.86,157.25,368,156.63Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M373.45,168.34c2,.39,3.89-4.28,5.23-6.39,0,0-3.53.22-5.27,1.34S370.72,167.8,373.45,168.34Z"
                fill="#1c7f19"
              />
              <path
                d="M378.68,162c-1.2.85-2.41,1.69-3.54,2.63A17.51,17.51,0,0,0,373.5,166a5.64,5.64,0,0,0-.71.84,1.89,1.89,0,0,0-.43,1,3.25,3.25,0,0,1,1.06-1.9,17.65,17.65,0,0,1,1.62-1.5A34.61,34.61,0,0,1,378.68,162Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M383.91,162.12c2,.4,3.89-4.27,5.23-6.38,0,0-3.53.21-5.27,1.33S381.18,161.59,383.91,162.12Z"
                fill="#1c7f19"
              />
              <path
                d="M389.14,155.74c-1.2.85-2.41,1.68-3.54,2.63a16.15,16.15,0,0,0-1.65,1.45,6.15,6.15,0,0,0-.7.83,1.9,1.9,0,0,0-.44,1,3.26,3.26,0,0,1,1.07-1.89,17.76,17.76,0,0,1,1.62-1.51A33.51,33.51,0,0,1,389.14,155.74Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M373.47,163c1.46.29,2.82-3.11,3.79-4.64a10.21,10.21,0,0,0-3.82,1C372.18,160.17,371.48,162.64,373.47,163Z"
                fill="#1b6817"
              />
              <path
                d="M377.26,158.39c-.87.62-1.75,1.23-2.56,1.91a11,11,0,0,0-1.2,1.06,2.58,2.58,0,0,0-.83,1.32,2.4,2.4,0,0,1,.77-1.38,15.23,15.23,0,0,1,1.18-1.09A26.33,26.33,0,0,1,377.26,158.39Z"
                fill="#30562e"
              />
            </g>
            <path
              d="M373.31,170.29a8.49,8.49,0,0,1-1.53-2.84,4.86,4.86,0,0,1-.22-1.66,4.65,4.65,0,0,1,.43-1.61,12.31,12.31,0,0,0,.5-3.06c.06-1.05.08-2.11.07-3.18a14.82,14.82,0,0,1,.4,3.19,9.52,9.52,0,0,1-.4,3.25,4.49,4.49,0,0,0-.43,1.45,4.78,4.78,0,0,0,.11,1.5A13,13,0,0,0,373.31,170.29Z"
              fill="#30562e"
            />
            <path
              d="M379,160.93c-.09.39-.32.79-.42,1.11a3.57,3.57,0,0,0,.34,1,9.05,9.05,0,0,1,.68,2.38,10.82,10.82,0,0,1-.6,4.83c.05-.81.08-1.61.1-2.4a18.39,18.39,0,0,0-.11-2.36,12.85,12.85,0,0,0-.51-2.3l-.16-.58a1.1,1.1,0,0,1,0-.7C378.57,161.55,378.81,161.29,379,160.93Z"
              fill="#30562e"
            />
            <path
              d="M384,156.71a6.69,6.69,0,0,1-1,1.4c-.36.42-.7.86-.56,1.31a3.4,3.4,0,0,0,.81,1.29,5,5,0,0,1,.87,1.55,9.26,9.26,0,0,1,.41,3.41A13,13,0,0,1,384,169a28.8,28.8,0,0,0,.1-3.34,11.4,11.4,0,0,0-.51-3.21,4.71,4.71,0,0,0-.74-1.38,3.48,3.48,0,0,1-.83-1.58,1.3,1.3,0,0,1,.21-.95,3.76,3.76,0,0,1,.6-.65A8.78,8.78,0,0,0,384,156.71Z"
              fill="#30562e"
            />
            <g>
              <path
                d="M385,167.94c1.46.29,2.82-3.11,3.8-4.64a10.24,10.24,0,0,0-3.83,1C383.75,165.08,383.05,167.56,385,167.94Z"
                fill="#1b6817"
              />
              <path
                d="M383.68,170.17c1.47.29,2.83-3.11,3.8-4.64a10.08,10.08,0,0,0-3.83,1C382.39,167.31,381.7,169.78,383.68,170.17Z"
                fill="#1b6817"
              />
              <path
                d="M388.84,163.3c-.87.62-1.76,1.23-2.57,1.91a12.12,12.12,0,0,0-1.2,1.06,2.58,2.58,0,0,0-.83,1.32,2.39,2.39,0,0,1,.77-1.37,13.72,13.72,0,0,1,1.19-1.1A24.22,24.22,0,0,1,388.84,163.3Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M380.45,169.87c2,.4,3.89-4.27,5.23-6.38,0,0-3.54.21-5.27,1.33S377.72,169.34,380.45,169.87Z"
                fill="#1c7f19"
              />
              <path
                d="M385.68,163.49c-1.2.85-2.41,1.68-3.54,2.63a16.15,16.15,0,0,0-1.65,1.45,5.5,5.5,0,0,0-.7.83,1.9,1.9,0,0,0-.44,1,3.26,3.26,0,0,1,1.07-1.89A17.76,17.76,0,0,1,382,166,33.51,33.51,0,0,1,385.68,163.49Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M377.81,163.65c-1.47.28-2.83-3.11-3.8-4.65a10.24,10.24,0,0,1,3.83,1C379.1,160.79,379.79,163.26,377.81,163.65Z"
                fill="#1c7f19"
              />
              <path
                d="M374,159a23.88,23.88,0,0,1,2.64,1.83,11,11,0,0,1,1.18,1.09,2.39,2.39,0,0,1,.78,1.37,2.73,2.73,0,0,0-.83-1.32,12,12,0,0,0-1.2-1.05C375.76,160.23,374.88,159.62,374,159Z"
                fill="#30562e"
              />
            </g>
            <g>
              <path
                d="M384.08,159c-1.6-.61-.24-3.18-.42-4.26s1.41-1.77,2.69-1.14.54,1.72,1.58,2.38S385.39,159.44,384.08,159Z"
                fill="#bc784a"
              />
              <path
                d="M383.38,159.08c-1.7-.19-1-3-1.45-4s.94-2.08,2.33-1.8.94,1.54,2.11,1.91S384.76,159.22,383.38,159.08Z"
                fill="#ed863a"
              />
              <path
                d="M383.3,159.3c-1.7-.18-.22-2.55-.66-3.54s.08-1.9,1.47-1.62.88.82,2.05,1.19S384.69,159.45,383.3,159.3Z"
                fill="#bc784a"
              />
              <path
                d="M383.53,159.78c-1.51-.45-.41-2.63-.64-3.51s1.2-1.52,2.41-1,.6,1.42,1.59,1.93S384.76,160.15,383.53,159.78Z"
                fill="#ed863a"
              />
            </g>
            <g>
              <path
                d="M378.7,159.8c-1.69-.31-.78-3.09-1.14-4.11s1.09-2,2.46-1.6.82,1.6,2,2.06S380.06,160.06,378.7,159.8Z"
                fill="#4233aa"
              />
              <path
                d="M378,160.05c-1.71.13-1.51-2.79-2.11-3.69s.57-2.21,2-2.18,1.19,1.35,2.41,1.51S379.41,160,378,160.05Z"
                fill="#583bea"
              />
              <path
                d="M378,160.29c-1.71.12-.65-2.47-1.25-3.37s-.25-1.89,1.17-1.85,1,.64,2.22.81S379.38,160.19,378,160.29Z"
                fill="#4233aa"
              />
              <path
                d="M378.29,160.72c-1.56-.18-.84-2.52-1.22-3.34s.92-1.71,2.2-1.45.82,1.29,1.89,1.61S379.56,160.87,378.29,160.72Z"
                fill="#583bea"
              />
            </g>
            <g>
              <path
                d="M373.57,158.19c1.69-.31.78-3.09,1.14-4.11s-1.09-2-2.46-1.6-.82,1.6-2,2.06S372.2,158.45,373.57,158.19Z"
                fill="#ad45a6"
              />
              <path
                d="M374.24,158.44c1.71.12,1.51-2.79,2.11-3.69s-.57-2.21-2-2.18-1.18,1.35-2.4,1.51S372.86,158.34,374.24,158.44Z"
                fill="#dd52cd"
              />
              <path
                d="M374.28,158.68c1.71.12.65-2.47,1.25-3.37s.25-1.89-1.18-1.86-1,.65-2.21.81S372.89,158.58,374.28,158.68Z"
                fill="#ad45a6"
              />
              <path
                d="M374,159.11c1.56-.18.84-2.52,1.22-3.34s-.93-1.71-2.2-1.45-.83,1.28-1.9,1.61S372.7,159.26,374,159.11Z"
                fill="#dd52cd"
              />
            </g>
            <ellipse
              cx="385.84"
              cy="166.69"
              rx="1.08"
              ry="0.32"
              transform="translate(10.39 355.64) rotate(-50.08)"
              fill="#b2eff9"
              opacity="0.25"
            />
          </g>
          <g>
            <path
              d="M347.75,168.14c-2.27.44-4.37-4.81-5.88-7.18,0,0,4,.24,5.93,1.5S350.82,167.54,347.75,168.14Z"
              fill="#1c7f19"
            />
            <path
              d="M341.87,161a36.68,36.68,0,0,1,4.09,2.82,18.12,18.12,0,0,1,1.82,1.69,3.64,3.64,0,0,1,1.2,2.13,2.17,2.17,0,0,0-.48-1.12,7.13,7.13,0,0,0-.8-.93,20.64,20.64,0,0,0-1.85-1.64C344.58,162.85,343.22,161.92,341.87,161Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M361.2,165.81c-2.27.44-4.37-4.81-5.88-7.18,0,0,4,.24,5.93,1.5S364.27,165.21,361.2,165.81Z"
              fill="#1c7f19"
            />
            <path
              d="M355.32,158.63a36.68,36.68,0,0,1,4.09,2.82,20.81,20.81,0,0,1,1.83,1.69,3.66,3.66,0,0,1,1.19,2.13,2.17,2.17,0,0,0-.48-1.12,7.13,7.13,0,0,0-.8-.93,19.08,19.08,0,0,0-1.85-1.63C358,160.53,356.67,159.59,355.32,158.63Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M355.7,173c-2.27.44-4.37-4.81-5.87-7.18,0,0,4,.24,5.92,1.5S358.77,172.37,355.7,173Z"
              fill="#1b6817"
            />
            <path
              d="M349.83,165.79a36.56,36.56,0,0,1,4.08,2.82,19.48,19.48,0,0,1,1.83,1.69,3.66,3.66,0,0,1,1.19,2.13,2.17,2.17,0,0,0-.48-1.12,6.44,6.44,0,0,0-.8-.93,19.08,19.08,0,0,0-1.85-1.63C352.53,167.69,351.17,166.75,349.83,165.79Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M349.76,173c-1.63.32-3.14-3.45-4.22-5.16a11.46,11.46,0,0,1,4.26,1.08C351.2,169.79,352,172.53,349.76,173Z"
              fill="#1b6817"
            />
            <path
              d="M345.54,167.8a26.82,26.82,0,0,1,2.93,2,13.71,13.71,0,0,1,1.32,1.21,2.66,2.66,0,0,1,.86,1.53,3,3,0,0,0-.92-1.47,14.84,14.84,0,0,0-1.33-1.17C347.49,169.17,346.51,168.49,345.54,167.8Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M349.51,162.17c-1.65.33-3.18-3.49-4.27-5.22a11.4,11.4,0,0,1,4.3,1.1C351,159,351.74,161.74,349.51,162.17Z"
              fill="#1c7f19"
            />
            <path
              d="M345.24,157a29,29,0,0,1,3,2.05,15.37,15.37,0,0,1,1.32,1.23,2.64,2.64,0,0,1,.87,1.55,2.87,2.87,0,0,0-.93-1.49,15.18,15.18,0,0,0-1.34-1.19C347.21,158.33,346.22,157.65,345.24,157Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M351.38,170.12c2.26.45,4.37-4.81,5.87-7.18,0,0-4,.24-5.92,1.5S348.31,169.52,351.38,170.12Z"
              fill="#1c7f19"
            />
            <path
              d="M357.25,162.94c-1.34,1-2.71,1.9-4,3a19.08,19.08,0,0,0-1.85,1.63,6.42,6.42,0,0,0-.8.94,2.18,2.18,0,0,0-.48,1.11,3.66,3.66,0,0,1,1.19-2.13,19.48,19.48,0,0,1,1.83-1.69A39.45,39.45,0,0,1,357.25,162.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M363.13,163.14c2.27.44,4.38-4.81,5.88-7.19,0,0-4,.25-5.92,1.51S360.07,162.54,363.13,163.14Z"
              fill="#1c7f19"
            />
            <path
              d="M369,156c-1.34,1-2.71,1.9-4,3a20.53,20.53,0,0,0-1.85,1.63,6.42,6.42,0,0,0-.8.94,2.19,2.19,0,0,0-.49,1.11,3.76,3.76,0,0,1,1.2-2.13,19.59,19.59,0,0,1,1.83-1.69A39.45,39.45,0,0,1,369,156Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M351.39,164.16c1.65.32,3.18-3.5,4.27-5.22a11.52,11.52,0,0,0-4.3,1.09C349.94,160.94,349.16,163.72,351.39,164.16Z"
              fill="#1b6817"
            />
            <path
              d="M355.66,158.94c-1,.7-2,1.38-2.88,2.15a13.74,13.74,0,0,0-1.35,1.18,3,3,0,0,0-.93,1.49,2.69,2.69,0,0,1,.87-1.55A12.82,12.82,0,0,1,352.7,161,26,26,0,0,1,355.66,158.94Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M351.22,172.32a9.26,9.26,0,0,1-1.72-3.2,5.51,5.51,0,0,1-.25-1.86,3.52,3.52,0,0,1,.17-1c.11-.33.21-.6.31-.85a13.91,13.91,0,0,0,.57-3.44c.06-1.18.09-2.37.08-3.58a17.38,17.38,0,0,1,.45,3.59,10.62,10.62,0,0,1-.46,3.65l-.32.83a3.55,3.55,0,0,0-.16.8A6.05,6.05,0,0,0,350,169,14.8,14.8,0,0,0,351.22,172.32Z"
            fill="#30562e"
          />
          <path
            d="M357.65,161.8c-.1.43-.36.88-.48,1.25a4,4,0,0,0,.39,1.16,9.64,9.64,0,0,1,.76,2.67,12.21,12.21,0,0,1-.67,5.44c.06-.91.09-1.81.11-2.7a21.27,21.27,0,0,0-.12-2.66,14.46,14.46,0,0,0-.58-2.58l-.18-.66a1.28,1.28,0,0,1,0-.78C357.13,162.49,357.4,162.2,357.65,161.8Z"
            fill="#30562e"
          />
          <path
            d="M363.24,157.05a7.69,7.69,0,0,1-1.08,1.57c-.41.47-.8,1-.63,1.47a4,4,0,0,0,.9,1.47,6,6,0,0,1,1,1.73,11.18,11.18,0,0,1,.46,3.84,15.34,15.34,0,0,1-.64,3.75,33.87,33.87,0,0,0,.11-3.76,12,12,0,0,0-.57-3.6A5,5,0,0,0,362,162a3.91,3.91,0,0,1-.94-1.78,1.47,1.47,0,0,1,.25-1.06,4.23,4.23,0,0,1,.66-.73A9.29,9.29,0,0,0,363.24,157.05Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M364.4,169.68c1.65.32,3.18-3.5,4.27-5.22a11.52,11.52,0,0,0-4.3,1.09C363,166.47,362.17,169.24,364.4,169.68Z"
              fill="#1b6817"
            />
            <path
              d="M362.88,172.18c1.65.32,3.18-3.49,4.27-5.22a11.52,11.52,0,0,0-4.3,1.09C361.43,169,360.65,171.74,362.88,172.18Z"
              fill="#1b6817"
            />
            <path
              d="M368.67,164.46c-1,.7-2,1.38-2.88,2.15a15.2,15.2,0,0,0-1.35,1.18,3,3,0,0,0-.93,1.49,2.67,2.67,0,0,1,.87-1.54,12.92,12.92,0,0,1,1.33-1.23A27.36,27.36,0,0,1,368.67,164.46Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M359.24,171.85c2.27.44,4.38-4.81,5.88-7.18,0,0-4,.24-5.92,1.5S356.17,171.25,359.24,171.85Z"
              fill="#1c7f19"
            />
            <path
              d="M365.12,164.67c-1.35,1-2.71,1.89-4,3a20.76,20.76,0,0,0-1.86,1.64,6.37,6.37,0,0,0-.79.93,2.19,2.19,0,0,0-.49,1.11,3.65,3.65,0,0,1,1.2-2.12,17.2,17.2,0,0,1,1.83-1.69A36.56,36.56,0,0,1,365.12,164.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M356.28,164.85c-1.65.32-3.18-3.5-4.27-5.22a11.52,11.52,0,0,1,4.3,1.09C357.73,161.63,358.51,164.41,356.28,164.85Z"
              fill="#1c7f19"
            />
            <path
              d="M352,159.63a26,26,0,0,1,3,2.05,12.82,12.82,0,0,1,1.33,1.22,2.69,2.69,0,0,1,.87,1.55,3,3,0,0,0-.93-1.49,13.74,13.74,0,0,0-1.35-1.18C354,161,353,160.33,352,159.63Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M363.33,159.56c-1.81-.68-.27-3.57-.48-4.78s1.59-2,3-1.28.6,1.93,1.78,2.67S364.79,160.12,363.33,159.56Z"
              fill="#bc784a"
            />
            <path
              d="M362.54,159.71c-1.91-.2-1.13-3.4-1.63-4.51s1.06-2.34,2.62-2,1.06,1.72,2.38,2.14S364.09,159.87,362.54,159.71Z"
              fill="#ed863a"
            />
            <path
              d="M362.45,160c-1.91-.2-.25-2.86-.74-4s.09-2.14,1.65-1.82,1,.92,2.31,1.34S364,160.13,362.45,160Z"
              fill="#bc784a"
            />
            <path
              d="M362.71,160.5c-1.7-.5-.46-2.95-.72-3.94s1.35-1.71,2.71-1.17.67,1.59,1.79,2.16S364.09,160.91,362.71,160.5Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M357.28,160.53c-1.9-.36-.88-3.48-1.29-4.63s1.23-2.24,2.77-1.8.92,1.8,2.2,2.33S358.81,160.81,357.28,160.53Z"
              fill="#4233aa"
            />
            <path
              d="M356.52,160.81c-1.92.14-1.69-3.15-2.37-4.15s.65-2.49,2.24-2.45,1.34,1.51,2.7,1.69S358.08,160.7,356.52,160.81Z"
              fill="#583bea"
            />
            <path
              d="M356.48,161.07c-1.92.14-.73-2.77-1.41-3.78s-.27-2.13,1.32-2.09,1.13.73,2.5.91S358,161,356.48,161.07Z"
              fill="#4233aa"
            />
            <path
              d="M356.82,161.56c-1.76-.2-.95-2.83-1.37-3.76s1-1.92,2.47-1.63.93,1.45,2.13,1.82S358.25,161.72,356.82,161.56Z"
              fill="#583bea"
            />
          </g>
          <g>
            <path
              d="M351.51,158.71c1.9-.35.87-3.47,1.28-4.62s-1.23-2.25-2.76-1.8-.93,1.8-2.21,2.32S350,159,351.51,158.71Z"
              fill="#ad45a6"
            />
            <path
              d="M352.27,159c1.92.13,1.69-3.15,2.36-4.16s-.64-2.48-2.24-2.44-1.33,1.51-2.7,1.69S350.71,158.89,352.27,159Z"
              fill="#dd52cd"
            />
            <path
              d="M352.31,159.26c1.92.14.73-2.78,1.41-3.78s.27-2.13-1.33-2.09-1.12.73-2.49.91S350.75,159.15,352.31,159.26Z"
              fill="#ad45a6"
            />
            <path
              d="M352,159.75c1.76-.2.95-2.83,1.37-3.76s-1-1.92-2.47-1.63-.93,1.45-2.13,1.82S350.54,159.91,352,159.75Z"
              fill="#dd52cd"
            />
          </g>
          <ellipse
            cx="365.31"
            cy="168.27"
            rx="1.21"
            ry="0.36"
            transform="translate(1.82 340.46) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g transform="translate(-10 -2)">
          <g>
            <polygon
              points="322.2 93.15 322.2 93.16 322.2 93.16 322.2 93.15"
              fill="#ef6291"
            />
            <path
              d="M311.71,91h0c0,.59,2.48,1.06,5.33,1.06s5.16-.48,5.16-1.07Z"
              fill="#ef6291"
            />
            <path
              d="M313.81,97.6h0a0,0,0,0,0,0,0c0,.35,1.36.63,3,.63s3-.28,3-.63a0,0,0,0,0,0,0h0l2.28-4.48H311.71Z"
              fill="#a05775"
            />
            <path
              d="M311.71,91c0,.59,2.48,1.06,5.33,1.06s5.16-.48,5.16-1.07S319.89,90,317,90s-5.31.48-5.33,1.07Z"
              fill="#c16f86"
            />
            <path
              d="M312.3,91c0,.52,2.2.94,4.73.94s4.58-.43,4.58-1-2.05-1-4.58-1S312.3,90.5,312.3,91Z"
              fill="#513126"
            />
            <path
              d="M313.89,97.76c3.64.18,3.52-4.29,3.52-4.29l4.69-.17-2.18,4.3h0a0,0,0,0,1,0,0c0,.35-1.36.63-3,.63A5.85,5.85,0,0,1,313.89,97.76Z"
              fill="#602b8e"
              opacity="0.35"
            />
            <path
              d="M311.71,91v2.12h0c0,.59,2.4,1.07,5.24,1.07s5.23-.48,5.25-1.07h0V91c0,.59-2.31,1.07-5.16,1.07S311.71,91.62,311.71,91Z"
              fill="#ce6f94"
            />
            <path
              d="M319.42,92h0c1.65-.18,2.78-.54,2.78-1v2.13h0c0,.5-1.78.93-4.06,1A1.81,1.81,0,0,0,319.42,92Z"
              fill="#602b8e"
              opacity="0.35"
            />
          </g>
          <g>
            <path
              d="M317.19,91.88a7.36,7.36,0,0,1,0-6.69c1.76-3.87,1.06-6,0-11.27,0,0,2.11,5.28,1.76,7.75s-1.06,3.52-1.76,6A7.08,7.08,0,0,0,317.19,91.88Z"
              fill="#513126"
            />
            <path
              d="M319,81.67c0-1.41-.35-2.11,1.76-2.82A3.8,3.8,0,0,0,323.17,76s-.7,2.81-1.76,2.81-2.11.71-2.11,1.41A3.7,3.7,0,0,1,319,81.67Z"
              fill="#513126"
            />
            <path
              d="M317.93,77.61c-.74-1.22-1.09-.87-2.5-1.57A2.51,2.51,0,0,1,314,73.92a2.56,2.56,0,0,0,1.76,2.82C317.89,77.44,317.93,77.61,317.93,77.61Z"
              fill="#513126"
            />
            <path
              d="M316.13,77.44c1.84,1.11-4.22-.35-4.22-2.46A6.29,6.29,0,0,1,313,71.11a5.27,5.27,0,0,1,2.11,2.11C315.78,74.63,312.61,75.33,316.13,77.44Z"
              fill="#4f7737"
            />
            <path
              d="M320,80.61c-1.84,1.1,4.22-.35,4.22-2.46a6.33,6.33,0,0,0-1.05-3.87,5.2,5.2,0,0,0-2.11,2.11C320.35,77.8,323.52,78.5,320,80.61Z"
              fill="#4f7737"
            />
            <path
              d="M319.91,80.71c-1.36.81,3.12-.26,3.12-1.82a4.64,4.64,0,0,0-.78-2.85,3.9,3.9,0,0,0-1.56,1.55C320.17,78.63,322.51,79.15,319.91,80.71Z"
              fill="#649147"
            />
            <path
              d="M316.13,75.33c-1.76-1.41-2.81-.7-2.11,0a1.56,1.56,0,0,1-.7,2.47c-1.06.35.7,0,2.11,1s.43-2.22,1.62-2.16Z"
              fill="#649147"
            />
            <path
              d="M317.19,74.63c-1.41-1.06-2.82-2.47-.7-3.52a1.94,1.94,0,0,0,1.05-2.82s.35,2.82,1.41,3.87,2.11,2.82.7,3.88S317.19,74.63,317.19,74.63Z"
              fill="#42632d"
            />
            <path
              d="M319,77.8c-1.41-1.76-3.11-2.12-2.61-3.88s.5-2.11,1.2-1,1.06,1.76,2.11,1.76,2.82-.71,1.41.35A7.4,7.4,0,0,0,319,77.8Z"
              fill="#4f7737"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <polygon
                points="189.76 157.27 189.76 157.28 189.76 157.28 189.76 157.27"
                fill="#ef6291"
              />
              <path
                d="M179.27,155.14h0c0,.6,2.48,1.07,5.33,1.07s5.16-.48,5.16-1.07Z"
                fill="#ef6291"
              />
              <path
                d="M181.37,161.72h0v0c0,.35,1.36.63,3,.63s3-.28,3-.63a0,0,0,0,0,0,0h0l2.29-4.48H179.27Z"
                fill="#a05775"
              />
              <path
                d="M179.27,155.14c0,.6,2.48,1.07,5.33,1.07s5.16-.48,5.16-1.07-2.31-1.07-5.16-1.07-5.31.48-5.33,1.07Z"
                fill="#c16f86"
              />
              <path
                d="M179.86,155.14c0,.53,2.2,1,4.73,1s4.58-.43,4.58-1-2-.95-4.58-.95S179.86,154.62,179.86,155.14Z"
                fill="#513126"
              />
              <path
                d="M181.44,161.88c3.65.18,3.52-4.29,3.52-4.29l4.7-.17-2.19,4.3h0a0,0,0,0,1,0,0c0,.35-1.36.63-3,.63A6,6,0,0,1,181.44,161.88Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M179.27,155.14v2.13h0c0,.59,2.4,1.07,5.24,1.07s5.23-.48,5.25-1.07h0v-2.13c0,.59-2.31,1.07-5.16,1.07S179.27,155.74,179.27,155.14Z"
                fill="#ce6f94"
              />
              <path
                d="M187,156.09h0c1.65-.18,2.78-.54,2.78-1v2.13h0c0,.5-1.78.93-4.06,1A1.81,1.81,0,0,0,187,156.09Z"
                fill="#602b8e"
                opacity="0.35"
              />
            </g>
            <g>
              <path
                d="M184.75,156a7.33,7.33,0,0,1,0-6.68c1.76-3.88,1.06-6,0-11.27,0,0,2.11,5.28,1.76,7.75s-1.06,3.52-1.76,6A7.05,7.05,0,0,0,184.75,156Z"
                fill="#513126"
              />
              <path
                d="M186.51,145.79c0-1.41-.35-2.12,1.76-2.82a3.8,3.8,0,0,0,2.46-2.82S190,143,189,143s-2.11.7-2.11,1.41A3.7,3.7,0,0,1,186.51,145.79Z"
                fill="#513126"
              />
              <path
                d="M185.49,141.73c-.74-1.22-1.09-.87-2.5-1.58a2.49,2.49,0,0,1-1.41-2.11,2.56,2.56,0,0,0,1.76,2.82C185.45,141.56,185.49,141.73,185.49,141.73Z"
                fill="#513126"
              />
              <path
                d="M183.69,141.56c1.84,1.1-4.22-.35-4.22-2.46a6.27,6.27,0,0,1,1.06-3.87,5.27,5.27,0,0,1,2.11,2.11C183.34,138.75,180.17,139.45,183.69,141.56Z"
                fill="#4f7737"
              />
              <path
                d="M187.56,144.73c-1.84,1.1,4.22-.35,4.22-2.46a6.36,6.36,0,0,0-1.05-3.88,5.27,5.27,0,0,0-2.11,2.12C187.91,141.91,191.08,142.62,187.56,144.73Z"
                fill="#4f7737"
              />
              <path
                d="M187.47,144.83c-1.36.81,3.12-.26,3.12-1.82a4.67,4.67,0,0,0-.78-2.86,3.88,3.88,0,0,0-1.56,1.56C187.73,142.75,190.07,143.27,187.47,144.83Z"
                fill="#649147"
              />
              <path
                d="M183.69,139.45c-1.76-1.41-2.81-.7-2.11,0a1.55,1.55,0,0,1-.7,2.46c-1.06.36.7,0,2.11,1.06s.42-2.22,1.62-2.17Z"
                fill="#649147"
              />
              <path
                d="M184.75,138.75c-1.41-1.06-2.82-2.47-.7-3.52a1.94,1.94,0,0,0,1-2.82s.35,2.82,1.41,3.87,2.11,2.82.7,3.87S184.75,138.75,184.75,138.75Z"
                fill="#42632d"
              />
              <path
                d="M186.51,141.91c-1.41-1.76-3.11-2.11-2.61-3.87s.5-2.11,1.2-1,1.06,1.76,2.11,1.76,2.82-.71,1.41.35A7.33,7.33,0,0,0,186.51,141.91Z"
                fill="#4f7737"
              />
            </g>
          </g>
          <g>
            <g>
              <path d="M209.92,164.56h0Z" fill="#ef6291" />
              <path
                d="M227.11,161.07v0c0,1-4.07,1.73-8.73,1.73s-8.46-.78-8.46-1.75Z"
                fill="#ef6291"
              />
              <path
                d="M223.67,171.81h0v.05c0,.57-2.22,1-5,1s-5-.46-5-1v-.05h-.05l-3.74-7.31h17.19Z"
                fill="#a05775"
              />
              <path
                d="M227.11,161.09c0,1-4.07,1.73-8.73,1.73s-8.46-.78-8.46-1.75,3.79-1.74,8.46-1.74,8.69.79,8.73,1.74Z"
                fill="#c16f86"
              />
              <path
                d="M226.14,161.09c0,.85-3.61,1.53-7.75,1.53s-7.5-.69-7.5-1.55,3.36-1.55,7.5-1.55S226.14,160.23,226.14,161.09Z"
                fill="#513126"
              />
              <path
                d="M223.55,172.07c-6,.3-5.77-7-5.77-7l-7.71-.27,3.59,7h.05v.05c0,.57,2.22,1,5,1C221.08,172.89,223.08,172.54,223.55,172.07Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M227.11,161.09v3.47h0c0,1-3.93,1.74-8.58,1.74s-8.58-.78-8.61-1.74h0v-3.49c0,1,3.79,1.75,8.46,1.75S227.11,162.05,227.11,161.09Z"
                fill="#ce6f94"
              />
              <path
                d="M214.47,162.62h0c-2.7-.29-4.55-.87-4.55-1.55v3.49h0c0,.82,2.91,1.51,6.66,1.7C213.79,165.63,214.47,162.62,214.47,162.62Z"
                fill="#602b8e"
                opacity="0.35"
              />
            </g>
            <g>
              <path
                d="M218.13,162.48s2.89-4.6,0-10.92-1.73-9.76,0-18.37c0,0-3.46,8.61-2.88,12.63s1.73,5.74,2.88,9.76A11.48,11.48,0,0,1,218.13,162.48Z"
                fill="#513126"
              />
              <path
                d="M215.25,145.82c0-2.29.57-3.44-2.89-4.59a6.24,6.24,0,0,1-4-4.6s1.16,4.6,2.89,4.6,3.46,1.15,3.46,2.3A5.89,5.89,0,0,0,215.25,145.82Z"
                fill="#513126"
              />
              <path
                d="M216.92,139.21c1.21-2,1.79-1.43,4.1-2.58a4.06,4.06,0,0,0,2.3-3.44,4.15,4.15,0,0,1-2.88,4.59C217,138.93,216.92,139.21,216.92,139.21Z"
                fill="#513126"
              />
              <path
                d="M219.86,138.93c-3,1.8,6.93-.57,6.93-4s-.58-4-1.74-6.32a8.64,8.64,0,0,0-3.46,3.45C220.44,134.34,225.63,135.49,219.86,138.93Z"
                fill="#4f7737"
              />
              <path
                d="M213.52,144.1c3,1.8-6.92-.57-6.92-4s.58-4,1.73-6.32a8.58,8.58,0,0,1,3.46,3.45C213,139.51,207.75,140.65,213.52,144.1Z"
                fill="#4f7737"
              />
              <path
                d="M213.67,144.26c2.22,1.33-5.11-.42-5.11-3s.43-3,1.28-4.67a6.35,6.35,0,0,1,2.55,2.55C213.25,140.87,209.41,141.72,213.67,144.26Z"
                fill="#649147"
              />
              <path
                d="M219.86,135.49c2.89-2.3,4.62-1.15,3.46,0a2.54,2.54,0,0,0,1.16,4c1.73.57-1.16,0-3.46,1.72s-.7-3.62-2.66-3.54Z"
                fill="#649147"
              />
              <path
                d="M218.13,134.34c2.31-1.73,4.62-4,1.15-5.75s-1.73-4.59-1.73-4.59-.57,4.59-2.3,6.32-3.47,4.59-1.16,6.31S218.13,134.34,218.13,134.34Z"
                fill="#42632d"
              />
              <path
                d="M215.25,139.51c2.3-2.88,5.09-3.45,4.27-6.32s-.81-3.45-2-1.72-1.73,2.87-3.46,2.87-4.61-1.15-2.31.57A12.11,12.11,0,0,1,215.25,139.51Z"
                fill="#4f7737"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              points="239.01 172.77 239.01 172.78 239.01 172.78 239.01 172.77"
              fill="#ef6291"
            />
            <path
              d="M254.44,169.64v0c0,.86-3.65,1.55-7.84,1.55s-7.59-.7-7.59-1.57Z"
              fill="#ef6291"
            />
            <path
              d="M251.35,179.28h0a.43.43,0,0,1,0,.05c0,.5-2,.92-4.47.92s-4.46-.42-4.46-.92a.07.07,0,0,1,0-.05h0L239,172.72h15.43Z"
              fill="#a05775"
            />
            <path
              d="M254.44,169.66c0,.86-3.65,1.55-7.84,1.55s-7.59-.7-7.59-1.57,3.4-1.56,7.59-1.56,7.81.7,7.84,1.56Z"
              fill="#c16f86"
            />
            <path
              d="M253.57,169.65c0,.77-3.24,1.38-7,1.38s-6.73-.62-6.73-1.39,3-1.39,6.73-1.39S253.57,168.89,253.57,169.65Z"
              fill="#513126"
            />
            <path
              d="M251.24,179.51c-5.36.27-5.18-6.28-5.18-6.28l-6.91-.24,3.22,6.29h0a.07.07,0,0,0,0,.05c0,.5,2,.92,4.46.92C249,180.25,250.82,179.93,251.24,179.51Z"
              fill="#602b8e"
              opacity="0.35"
            />
            <path
              d="M254.44,169.66v3.11h0c0,.86-3.53,1.57-7.7,1.57s-7.7-.71-7.73-1.57h0v-3.13c0,.87,3.4,1.57,7.59,1.57S254.44,170.52,254.44,169.66Z"
              fill="#ce6f94"
            />
            <path
              d="M243.1,171h0c-2.43-.26-4.09-.78-4.09-1.39v3.13h0c0,.74,2.61,1.36,6,1.52C242.49,173.73,243.1,171,243.1,171Z"
              fill="#602b8e"
              opacity="0.35"
            />
          </g>
          <g>
            <path
              d="M246.38,170.9s2.59-4.12,0-9.79-1.55-8.76,0-16.49c0,0-3.11,7.73-2.59,11.33s1.55,5.16,2.59,8.77A10.19,10.19,0,0,1,246.38,170.9Z"
              fill="#513126"
            />
            <path
              d="M243.79,156c0-2.06.52-3.09-2.59-4.12a5.56,5.56,0,0,1-3.62-4.12s1,4.12,2.59,4.12,3.1,1,3.1,2.06A5.29,5.29,0,0,0,243.79,156Z"
              fill="#513126"
            />
            <path
              d="M245.29,150c1.09-1.8,1.61-1.28,3.68-2.31a3.66,3.66,0,0,0,2.07-3.09,3.73,3.73,0,0,1-2.59,4.12C245.34,149.77,245.29,150,245.29,150Z"
              fill="#513126"
            />
            <path
              d="M247.93,149.77c-2.7,1.61,6.22-.52,6.22-3.61s-.52-3.61-1.56-5.67a7.69,7.69,0,0,0-3.1,3.09C248.45,145.65,253.11,146.68,247.93,149.77Z"
              fill="#4f7737"
            />
            <path
              d="M242.24,154.41C245,156,236,153.89,236,150.8s.52-3.61,1.55-5.67a7.68,7.68,0,0,1,3.11,3.09C241.73,150.28,237.07,151.32,242.24,154.41Z"
              fill="#4f7737"
            />
            <path
              d="M242.38,154.55c2,1.19-4.59-.38-4.59-2.66a6.83,6.83,0,0,1,1.15-4.18,5.67,5.67,0,0,1,2.29,2.28C242,151.51,238.56,152.27,242.38,154.55Z"
              fill="#649147"
            />
            <path
              d="M247.93,146.68c2.59-2.06,4.15-1,3.11,0a2.26,2.26,0,0,0,1,3.6c1.55.52-1,0-3.11,1.55s-.63-3.25-2.39-3.17Z"
              fill="#649147"
            />
            <path
              d="M246.38,145.65c2.07-1.55,4.14-3.61,1-5.16s-1.56-4.12-1.56-4.12-.52,4.12-2.07,5.67-3.11,4.12-1,5.67S246.38,145.65,246.38,145.65Z"
              fill="#42632d"
            />
            <path
              d="M243.79,150.28c2.07-2.57,4.57-3.09,3.84-5.66s-.73-3.1-1.77-1.55-1.55,2.58-3.11,2.58-4.14-1-2.07.51A10.93,10.93,0,0,1,243.79,150.28Z"
              fill="#4f7737"
            />
          </g>
        </g>
        <g>
          <g>
            <polygon
              points="292.45 176.97 292.45 176.98 292.45 176.98 292.45 176.97"
              fill="#ef6291"
            />
            <path
              d="M277,173.85h0c0,.87,3.65,1.55,7.84,1.55s7.59-.7,7.59-1.56Z"
              fill="#ef6291"
            />
            <path
              d="M280.11,183.48h0v.05c0,.51,2,.92,4.46.92s4.46-.41,4.46-.92v-.05h0l3.36-6.55H277Z"
              fill="#a05775"
            />
            <path
              d="M277,173.86c0,.87,3.65,1.55,7.84,1.55s7.59-.7,7.59-1.56-3.4-1.57-7.59-1.57-7.8.71-7.84,1.57Z"
              fill="#c16f86"
            />
            <path
              d="M277.89,173.86c0,.77,3.24,1.38,7,1.38s6.73-.62,6.73-1.39-3-1.39-6.73-1.39S277.89,173.09,277.89,173.86Z"
              fill="#513126"
            />
            <path
              d="M280.22,183.72c5.36.26,5.18-6.28,5.18-6.28l6.92-.25-3.23,6.29h0v.05c0,.51-2,.92-4.46.92C282.44,184.45,280.64,184.14,280.22,183.72Z"
              fill="#602b8e"
              opacity="0.35"
            />
            <path
              d="M277,173.86V177h0c0,.86,3.53,1.57,7.71,1.57s7.69-.71,7.72-1.57h0v-3.12c0,.86-3.4,1.56-7.59,1.56S277,174.73,277,173.86Z"
              fill="#ce6f94"
            />
            <path
              d="M288.37,175.24h0c2.42-.26,4.08-.79,4.08-1.39V177h0c0,.74-2.61,1.36-6,1.53C289,177.94,288.37,175.24,288.37,175.24Z"
              fill="#602b8e"
              opacity="0.35"
            />
          </g>
          <g>
            <path
              d="M285.08,175.11s-2.58-4.13,0-9.8,1.56-8.76,0-16.49c0,0,3.11,7.73,2.59,11.34s-1.55,5.15-2.59,8.76A10.31,10.31,0,0,0,285.08,175.11Z"
              fill="#513126"
            />
            <path
              d="M287.67,160.16c0-2.06-.51-3.09,2.59-4.12a5.61,5.61,0,0,0,3.63-4.13s-1,4.13-2.59,4.13-3.11,1-3.11,2.06A5.29,5.29,0,0,1,287.67,160.16Z"
              fill="#513126"
            />
            <path
              d="M286.17,154.22c-1.09-1.79-1.6-1.28-3.67-2.31a3.65,3.65,0,0,1-2.08-3.09,3.74,3.74,0,0,0,2.59,4.12C286.12,154,286.17,154.22,286.17,154.22Z"
              fill="#513126"
            />
            <path
              d="M283.53,154c2.7,1.62-6.21-.51-6.21-3.6s.51-3.61,1.55-5.67a7.74,7.74,0,0,1,3.11,3.09C283,149.85,278.35,150.88,283.53,154Z"
              fill="#4f7737"
            />
            <path
              d="M289.22,158.61c-2.7,1.62,6.21-.51,6.21-3.61s-.51-3.6-1.55-5.66a7.74,7.74,0,0,0-3.11,3.09C289.74,154.49,294.4,155.52,289.22,158.61Z"
              fill="#4f7737"
            />
            <path
              d="M289.09,158.76c-2,1.19,4.58-.38,4.58-2.66a6.77,6.77,0,0,0-1.15-4.19,5.73,5.73,0,0,0-2.29,2.28C289.47,155.72,292.91,156.48,289.09,158.76Z"
              fill="#649147"
            />
            <path
              d="M283.53,150.88c-2.59-2.06-4.14-1-3.11,0a2.28,2.28,0,0,1-1,3.61c-1.56.51,1,0,3.11,1.55s.62-3.26,2.38-3.18Z"
              fill="#649147"
            />
            <path
              d="M285.08,149.85c-2.07-1.55-4.14-3.61-1-5.15s1.55-4.13,1.55-4.13.52,4.13,2.07,5.67,3.11,4.13,1,5.67S285.08,149.85,285.08,149.85Z"
              fill="#42632d"
            />
            <path
              d="M287.67,154.49c-2.07-2.58-4.57-3.09-3.84-5.67s.74-3.09,1.77-1.55,1.56,2.58,3.11,2.58,4.14-1,2.07.52A10.85,10.85,0,0,0,287.67,154.49Z"
              fill="#4f7737"
            />
          </g>
        </g>
      </g>
    </g>
  );
};
export default TechnologySkillsLink;
